<template>
    <PageWrap :is-allowed="isPageAllowed" :last-data-time="lastDataTime" :fixed-table-height="tableSettings.fixedTableHeight"  ref="pageWrap" @toggle="calcTableHeight" @resize="calcFilterDisplayCounts" @change-tab="initPage">
        <template slot="left">
            <!--<h3 class="title-group">条件选择</h3>-->
            <div class="search-bar p6">
                <el-input
                    placeholder="请输入查询关键字"
                    prefix-icon="el-icon-search"
                    size="mini"
                    clearable
                    @input="changeFilterSearch"
                    v-model="filterSearch">
                </el-input>
            </div>
            <div class="chosen-area" v-loading="conditionLoading">
                <el-tabs class="filter-tabs" :class="filterSearch.length>0?'show-search-result':''" v-model="activeFilterTab" :stretch="true">
                    <el-tab-pane label="数据维度" name="first">
                        <div class="pl6 filter-tab-pane" :style="{height:filterTabContentHeight+'px'}">
                            <el-scrollbar class="full-h">
                                <el-collapse v-model="filterTabCondition">
                                    <el-collapse-item v-for="item in dimensionList" :key="item.name"
                                                      :title="item.display_name" :name="item.name">
                                        <CheckItem v-for="field in (item.children||[])" :key="field.name" :field="field"
                                                   @click-menu="handleMenuClick" @change="changeCheckItem"
                                                   :is-active-menu="formItem.condition.map(inner=>inner.name).includes(field.name)"
                                                   :hide-menu="field.name=='date'"
                                                   :is-time-filter="isTimeFilter"
                                                   :is-compare="isCompare"
                                                   :is-sum-field="item.name==(platName+'_sum_data')"
                                                   filter-type="group"/>
                                    </el-collapse-item>
                                </el-collapse>
                                <p v-if="dimensionList.length<=0" class="tac text-color-gray">暂无数据</p>
                            </el-scrollbar>

                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="数据指标" name="third">
                        <div class="pl6 filter-tab-pane" :style="{height:filterTabContentHeight+'px'}">
                            <el-scrollbar class="full-h">
                                <el-collapse v-model="filterTabField">
                                    <el-collapse-item v-for="item in fieldList" :key="item.name" :title="item.display_name"
                                                      :name="item.name">
                                        <p class="pl10 pr10 font12px text-color-gray" v-if="(!isTimeFilter&&(item.children||[]).length>0)||isTimeFilter&&((item.children||[]).some(inner=>((inner.config||{}).time_type||[]).includes('hour')))">
                                            <span class="pl20 pointer" @click="checkAllFields(item)">全选</span>
                                            <span class="pl10 pointer" @click="clearAllFields(item)">取消全选</span>
                                        </p>
                                        <CheckItem v-for="field in (item.children||[])" :key="field.name" :field="field" :is-time-filter="isTimeFilter"
                                                   hide-menu @change="changeCheckItem" :is-compare="isCompare"  :is-sum-field="item.name==(platName+'_sum_data')" filter-type="field"/>
                                        <p v-if="isTimeFilter&&!((item.children||[]).some(inner=>((inner.config||{}).time_type||[]).includes('hour')))" class="tac text-color-gray">暂无数据</p>
                                    </el-collapse-item>
                                </el-collapse>
                                <p v-if="fieldList.length<=0" class="tac text-color-gray">暂无数据</p>
                            </el-scrollbar>
                        </div>
                    </el-tab-pane>
                </el-tabs>

            </div>
            <div class="search-result" v-if="filterSearch.length>0">
                <el-scrollbar class="full-h">
                    <p class="title-text" v-if="dimensionResultList.length>0">数据维度</p>
                    <CheckItem
                        v-for="field in dimensionResultList"
                        :key="'search-condition-'+field.name"
                        :field="field"
                        :is-time-filter="isTimeFilter"
                        :is-active-menu="formItem.condition.map(inner=>inner.name).includes(field.name)"
                        @click-menu="handleMenuClick"
                        @change="changeCheckItem"
                        :is-compare="isCompare"
                        :is-sum-field="field.name==(platName+'_sum_data')"
                        :hide-menu="field.name=='date'"
                        filter-type="group"/>
                    <!--<p class="title-text" v-if="dimensionResultList.length>0">维度分组</p>-->
                    <!--<CheckItem v-for="field in dimensionResultList" :key="'search-dimension-'+field.name" :field="field"-->
                    <!--hide-menu @change="changeCheckItem" filter-type="group"/>-->
                    <p class="title-text" v-if="fieldResultList.length>0">数据指标</p>
                    <CheckItem v-for="field in fieldResultList" :key="'search-field-'+field.name" :field="field" hide-menu :is-time-filter="isTimeFilter"
                               @change="changeCheckItem" :is-compare="isCompare"  :is-sum-field="getIsSumField(field)" filter-type="field"/>
                    <p v-if="dimensionResultList.length+fieldResultList.length===0"
                       class="text-color-gray tac">暂无数据</p>
                </el-scrollbar>
            </div>
        </template>

        <template slot="top" slot-scope='scope'>
            <el-row class="header-title">
                <el-col :span="16" class="fl" style="min-width: 590px;">
                    <div class="date-wrap relative">
                        <div class="date-loading" v-if="disableDateLoading">
                            <div v-loading="disableDateLoading"></div>
                        </div>
                        <div class="date-loading2" v-if="disableDateLoading&&isCompare">
                            <div v-loading="disableDateLoading"></div>
                        </div>
                        <el-date-picker
                            ref="range_time"
                            v-model="formItem.range_time"
                            type="daterange"
                            align="left"
                            :picker-options="basePickerOptions"
                            :disabled="disableDateLoading"
                            :clearable="false"
                            :editable="false"
                            @change="changeRangeTime"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 220px;"
                            popper-class="form-range-time"
                            size="mini">
                        </el-date-picker>
                        <span class="el-icon-c-scale-to-original pointer ver-middle relative"
                              v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`, event: '点击',  name: `已选条件区(对比)` }"
                              :class="isCompare&&!disableDateLoading?'active':''" @click="confirmCompareSumFields"
                              style="font-size: 24px;top: -2px;"></span>
                        <template v-if="isCompare">
                            <el-select v-model="formItem.compare_type" @change="changeCompareType" size="mini"
                                       style="width: 90px;" class="mr10">
                                <el-option label="环比" value="MoM"></el-option>
                                <el-option label="同比" value="YoY" :title="isDisabledYoY?'按【天】【周】【年】【汇总】无法同比，可选择自定义对比':''" :disabled="isDisabledYoY"></el-option>
                                <el-option label="自定义" value="self"></el-option>
                            </el-select>
                            <el-date-picker
                                ref="range_time1"
                                v-model="formItem.range_time1"
                                type="daterange"
                                :disabled="formItem.compare_type!='self'||disableDateLoading"
                                align="right"
                                :clearable="false"
                                @change="changeRangeTime1"
                                :editable="false"
                                :picker-options="comparePickerOptions"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                style="width: 220px;"
                                size="mini">
                            </el-date-picker>
                        </template>
                    </div>
                </el-col>

                <el-col :span="8" class="fr" style="width: 115px;">
                    <div class="tar display-setting">
                        <p class="text-color-primary inline-block">

                            <!--维度默认排序：{{formItem.dimension_default_sort=='1'?'开启':'关闭'}}；数据显示方式：{{getDataDisplayTypeText(formItem.data_display_type)}}；数据计算方式：{{getCostTypeText(formItem.cost_type)}}；-->
                        </p>
                        <el-popover
                            placement="bottom-end"
                            width="620"
                            trigger="hover">
                            <div slot="reference" class="text-color-primary inline-block pointer">
                                <span class="">更多配置</span>
                                <span  class="el-icon-setting pointer-icon ver-middle"></span>
                            </div>
                            <div>
                                <el-form label-width="150px">
                                    <el-form-item label="维度默认排序：">
                                        <el-switch v-model="formItem.dimension_default_sort" active-value="1" inactive-value="0"></el-switch>
                                        <p class="text-color-gray font12px mt6">开启后，查询结果的前10个维度将按照选择的第一个指标默认降序（手动设置的除外）</p>
                                    </el-form-item>
                                    <el-form-item label="数据显示方式：" class="mt20">
                                        <el-radio-group v-model="formItem.data_display_type" size="mini">
                                            <el-radio-button label="sum_up">汇总</el-radio-button>
                                            <el-radio-button label="average">日均</el-radio-button>
                                        </el-radio-group>
                                        <p class="text-color-gray font12px mt6">汇总：筛选日期的汇总数据；日均：汇总数 / 筛选日期的自然天数</p>
                                    </el-form-item>
                                    <el-form-item label="数据计算方式：" v-if="costFieldList.length>0">
                                        <template v-if="platId=='11'">
                                            <el-radio-group v-model="formItem.cost_type" size="mini">
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('ad_billing')" label="ad_billing">广告消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter" v-if="costFieldList.includes('cash_count')" label="cash_count">现金广告消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter" v-if="costFieldList.includes('inner_virtual_sum')" label="inner_virtual_sum">虚拟金消耗</el-radio-button>
                                            </el-radio-group>

                                            <el-radio-group v-model="formItem.cost_type" size="mini" class="mt6">
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter" v-if="costFieldList.includes('virtual_and_cash_count')" label="virtual_and_cash_count">返货金广告消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter" v-if="costFieldList.includes('virtual_count')" label="virtual_count">虚拟金广告消耗</el-radio-button>
                                            </el-radio-group>
                                        </template>
                                         <template v-else-if="platId=='1'">
                                           <el-radio-group v-model="formItem.cost_type" size="mini">
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('cost')" label="cost">总消耗 </el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn"  v-if="costFieldList.includes('cash_cost')" label="cash_cost">现金消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('vir_cost')" label="vir_cost">虚拟金消耗</el-radio-button>
                                            </el-radio-group>

                                            <el-radio-group v-model="formItem.cost_type" size="mini" class="mt6">
                                                <el-radio-button class="cost-type-radio-btn"  v-if="costFieldList.includes('gift_cost')" label="gift_cost">赠送消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn"  v-if="costFieldList.includes('rebate_cost')" label="rebate_cost">返货消耗</el-radio-button>
                                            </el-radio-group>
                                        </template>
                                        <template v-else>
                                            <el-radio-group v-model="formItem.cost_type" size="mini">
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('local_spend')" label="local_spend" style="width: 120px;">总消耗(支出)</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('cost')" label="cost">{{platId=='10'? '花费' : '总消耗'}} </el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter&&(platId=='1'||platId=='8'||platId=='10')" v-if="costFieldList.includes('cash_cost')" label="cash_cost">现金消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter&&(platId=='1'||platId=='8'||platId=='10')" v-if="costFieldList.includes('vir_cost')" label="vir_cost">虚拟金消耗</el-radio-button>
                                            </el-radio-group>

                                            <el-radio-group v-model="formItem.cost_type" size="mini" class="mt6">
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter&&(platId=='10')" v-if="costFieldList.includes('gift_cost')" label="gift_cost">赠送金消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('star_cost')" label="star_cost">耀星券消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" v-if="costFieldList.includes('exchange_cost')" label="exchange_cost">置换金消耗</el-radio-button>
                                                <el-radio-button class="cost-type-radio-btn" :disabled="isTimeFilter&&(platId=='10')" v-if="costFieldList.includes('rebate_cost')" label="rebate_cost">返利金消耗</el-radio-button>
                                            </el-radio-group>
                                        </template>
                                        <p class="text-color-gray font12px">所有涉及消耗计算的数据指标根据此处选择的消耗类型进行计算</p>
                                    </el-form-item>

                                    <el-form-item label="消耗指标小数位配置：" v-if="platId=='3'">
                                        <el-switch v-model="costDecimalConfig.unified" :active-value="1" :inactive-value="0" @change="changeCostDecimalUnified"></el-switch>
                                        <p class="text-color-gray font12px mt6">
                                            <span style="color: red;">小数位取数规则为四舍五入</span>
                                            <template v-if="costDecimalConfig.unified==1">；开启时，花费/现金花费/通用虚拟金共用一套小数位；关闭时，各指标可独立配置小数位</template>
                                            <template v-else>；当前为独立配置模式，花费/现金花费/通用虚拟金可分别设置小数位</template>
                                        </p>
                                        <div class="mt6">
                                            <span class="font12px inline-block" v-if="costDecimalConfig.unified==0" style="width: 80px;">总消耗：</span>
                                            <el-radio-group v-model="costDecimalConfig.cost" size="mini" @change="changeCostDecimal">
                                                <el-radio-button v-for="n in 6" :key="n-1" :label="n-1">{{n-1}}位</el-radio-button>
                                            </el-radio-group>
                                            <span class="text-color-gray font12px ml6" v-if="costDecimalConfig.unified==1">（三指标共用）</span>
                                        </div>
                                        <template v-if="costDecimalConfig.unified==0">
                                            <div class="mt6">
                                                <span class="font12px inline-block" style="width: 80px;">现金消耗：</span>
                                                <el-radio-group v-model="costDecimalConfig.cash_cost" size="mini" @change="changeCostDecimal">
                                                    <el-radio-button v-for="n in 6" :key="n-1" :label="n-1">{{n-1}}位</el-radio-button>
                                                </el-radio-group>
                                            </div>
                                            <div class="mt6">
                                                <span class="font12px inline-block" style="width: 80px;">虚拟金消耗：</span>
                                                <el-radio-group v-model="costDecimalConfig.vir_cost" size="mini" @change="changeCostDecimal">
                                                    <el-radio-button v-for="n in 6" :key="n-1" :label="n-1">{{n-1}}位</el-radio-button>
                                                </el-radio-group>
                                            </div>
                                        </template>
                                    </el-form-item>

                                    <el-form-item :label="(isPlatAll?'Apple':'')+'数据时区：'" v-if="platId==9||isPlatAll">
                                        <el-radio-group v-model="formItem.time_zone" @change="updateDisableDate">
                                            <el-radio label="Asia/Shanghai">亚洲/上海</el-radio>
                                            <el-radio label="UTC">UTC</el-radio>
                                        </el-radio-group>
                                        <p class="text-color-gray font12px mt6">修改数据时区后，在下次查询时生效</p>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-popover>
                    </div>
                </el-col>
            </el-row>
            <div>

                <!-- 筛选 -->
                <div class="filter-group-item relative">
                    <div class="filter-group-label inline-block">
                        <el-tooltip class="item" effect="dark" placement="top-start" content="筛选列表各维度的数据（可拖拽修改位置）">
                            <span class="el-icon-question pointer ml4"></span>
                        </el-tooltip>
                        <span class="text-bold pl2 pr6">筛选</span>
                    </div>
                    <div class="filter-main absolute ">
                        <div class="filter-checked-wrap relative">
                            <draggable :list="shownConditions" ghost-class="drag-ghost" handle=".filter-item-condition" group="field" @change="dragField('conditions',$event)" :move="moveField">
                                <FilterItem
                                    type="info"
                                    class="filter-item-condition"
                                    v-for="field in shownConditions"
                                    :key="field.name"
                                    :field="field"
                                    :loading="field.filterLoading"
                                    align="center"
                                    show-count
                                    @remove="removeCondition"
                                    @menu="handleMenuClick"
                                />
                            </draggable>
                            <div class="more-btn" v-if="hiddenConditions.length>0">
                                <el-popover
                                    placement="bottom-end"
                                    width="240"
                                    trigger="click">
                                    <el-button slot="reference" size="mini" type="primary" style="padding: 5px 15px;" plain>+{{hiddenConditions.length}}</el-button>

                                    <div class="hidden-list">
                                        <draggable :list="hiddenConditions" ghost-class="drag-ghost" group="field" @change="dragField('conditions',$event)" :move="moveField">
                                            <FilterItem
                                                type="info"
                                                class="filter-item-condition"
                                                v-for="field in hiddenConditions"
                                                :key="field.name"
                                                :field="field"
                                                align="center"
                                                show-count
                                                :loading="field.filterLoading"
                                                @remove="removeCondition"
                                                @menu="handleMenuClick"
                                                style="display: block"
                                            />
                                        </draggable>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                    <div class="filter-action absolute inline-block">
                        <FilterActionPop :data-list="conditionList" :is-time-filter="isTimeFilter" @check="handleMenuClick" type="condition"/>
                    </div>
                </div>


                <!-- 维度 -->
                <div class="filter-group-item relative">
                    <div class="filter-group-label inline-block">
                        <el-tooltip class="item" effect="dark" placement="top-start" content="选择的维度分组会在列表增加表头，并且数据按照该维度和顺序进行切割。（此处可拖拽切换维度顺序）">
                            <span class="el-icon-question pointer ml4"></span>
                        </el-tooltip>
                        <span class="text-bold pl2 pr6">维度</span>
                    </div>
                    <div class="filter-main absolute ">
                        <div class="filter-checked-wrap relative">
                            <draggable :list="shownDimensions" ghost-class="drag-ghost" group="field" @change="dragField('dimensions',$event)" :move="moveField">
                                <FilterItem
                                    class="filter-item-dimension"
                                    type="info"
                                    v-for="field in shownDimensions"
                                    :key="field.name"
                                    :field="field"
                                    align="center"
                                    show-subtext
                                    @remove="removeDimension"
                                    @menu="handleDimensionMenuClick"
                                    :sub-text="field.subText"
                                />
                            </draggable>
                            <div class="more-btn" v-if="hiddenDimensions.length>0">
                                <el-popover
                                    placement="bottom-end"
                                    width="240"
                                    trigger="click">
                                    <el-button slot="reference" size="mini" type="primary" style="padding: 5px 15px;" plain>+{{hiddenDimensions.length}}</el-button>

                                    <div class="hidden-list">
                                        <draggable :list="hiddenDimensions" ghost-class="drag-ghost" group="field" @change="dragField('dimensions',$event)" :move="moveField">
                                            <FilterItem
                                                class="filter-item-dimension"
                                                type="info"
                                                v-for="field in hiddenDimensions"
                                                :key="field.name"
                                                :field="field"
                                                align="center"
                                                show-subtext
                                                :sub-text="field.subText"
                                                @remove="removeDimension"
                                                @menu="handleDimensionMenuClick"
                                                style="display: block"
                                            />
                                        </draggable>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                    <div class="filter-action absolute inline-block">
                        <FilterActionPop :data-list="dimensionList" :is-time-filter="isTimeFilter" @check="filterActionDimensionCheck" type="dimension"/>
                    </div>
                </div>


                <!-- 指标 -->
                <div class="filter-group-item relative">
                    <div class="filter-group-label inline-block">
                        <el-tooltip class="item" effect="dark" placement="top-start" content="选择的指标会在列表增加表头以及数据。（此处可拖拽切换指标顺序）">
                            <span class="el-icon-question pointer ml4"></span>
                        </el-tooltip>
                        <span class="text-bold pl2 pr6">指标</span>
                    </div>
                    <div class="filter-main absolute ">
                        <div class="filter-checked-wrap relative">
                            <draggable :list="shownFields" ghost-class="drag-ghost" group="field" @change="dragField('fields',$event)" :move="moveField">
                                <FilterItem
                                    class="filter-item-field"
                                    v-for="field in shownFields"
                                    :key="field.name"
                                    :field="field"
                                    align="center"
                                    hide-menu
                                    @remove="removeField"
                                />
                            </draggable>
                            <div class="more-btn" v-if="hiddenFields.length>0">
                                <el-popover
                                    placement="bottom-end"
                                    width="240"
                                    trigger="click">
                                    <el-button slot="reference" size="mini" type="warning" style="padding: 5px 15px;" plain>+{{hiddenFields.length}}</el-button>

                                    <div class="hidden-list">
                                        <draggable :list="hiddenFields" ghost-class="drag-ghost" group="field" @change="dragField('fields',$event)" :move="moveField">
                                            <FilterItem
                                                class="filter-item-field"
                                                v-for="field in hiddenFields"
                                                :key="field.name"
                                                :field="field"
                                                align="center"
                                                hide-menu
                                                @remove="removeField"
                                                style="display: block"
                                            />
                                        </draggable>
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                    <div class="filter-action absolute inline-block">
                        <FilterActionPop :data-list="fieldList" :is-compare="isCompare" :plat-name="platName" :is-time-filter="isTimeFilter" @check="filterActionFieldCheck" type="field"/>
                    </div>
                </div>
            </div>
            <div class="filter-tool-bar clear-both mt10">
                <div class="left-tool fl">
                    <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`, event: '点击',  name: `已选条件区(查询)` }" id="tj-submit-btn" size="mini" type="primary" :loading="dataLoading" :disabled="isFilterLoading" @click="submitSearch">查询</el-button>
                    <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`, event: '点击',  name: `已选条件区(导出)` }" v-if="pageFuncNames.includes('export')" size="mini" :loading="exportLoading"
                               @click="showExportModal">导出
                    </el-button>
                    <el-popconfirm
                        title="确认要重置已选条件吗？"
                        confirm-button-text="重置"
                        cancel-button-text="取消"
                        @confirm="resetFilters"
                    >
                        <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `已选条件区(重置已选条件)` }" size="mini" slot="reference" class="ml10">重置已选条件</el-button>
                    </el-popconfirm>

                    <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `已选条件区(复制页面)` }" size="mini" class="ml10" @click="copyTab">复制页面</el-button>
                    <!--<el-button size="mini" class="ml10" @click="restoreLastData">恢复上次查询条件</el-button>-->
                </div>
                <div class="right-tool fr">
                    <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `已选条件区(保存模板)` }" size="mini" type="primary" @click="showAddTemplateModal">保存模板</el-button>
                    <el-button v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`,   name: `已选条件区(使用模板)` }" size="mini" type="primary" @click="showTemplateDrawer">使用模板</el-button>
                </div>
            </div>



            <AddTemplateModal ref="addTemplateModal" :plat-id="platId" :template-data="formItem" @add="addTemplate"/>
            <TemplateListDrawer ref="templateListDrawer" :plat-id="platId" @use-template="useTemplate"/>
            <ExportModal ref="exportModal" @close="hideExportModal" @submit="exportFile" :name="exportFileName"/>
            <DownloadTableModal ref="downloadTableModal" @close="hideDownloadTableModal" @submit="exportToExcel" :name="lastFileName"/>

            <TimeModal
                ref="timeModal"
                :plat-id="platId"
                :modal-data="actionFilterModal"
                :condition="formItem.condition"
                :range-time="formItem.range_time"
                :last="lastDataTime"
                @save-value="saveConditionValue"
                @close="closeConditionModal"/>

            <DateModal
                ref="dateModal"
                :plat-id="platId"
                :modal-data="actionFilterModal"
                :condition="formItem.condition"
                :dimension="formItem.group"
                :range-time="formItem.range_time"
                :time-zone="formItem.time_zone"
                :is-time-filter="isTimeFilter"
                :last="lastDataTime"
                @save-value="saveConditionValue"
                @close="closeConditionModal"/>

            <DateSelectModal
                ref="dateSelectModal"
                :plat-id="platId"
                :modal-data="actionFilterModal"
                :condition="formItem.condition"
                :dimension="formItem.group"
                :last="lastDataTime"
                :range-time="formItem.range_time"
                :time-zone="formItem.time_zone"
                :is-time-filter="isTimeFilter"
                :apple-ad-field-list="appleAdFieldList"
                :apple-keywords-field-list="appleKeywordsFieldList"
                @remove-apple-form="removeAppleForm"
                @save-value="saveConditionValue"
                @close="closeConditionModal"/>

            <SelectModal
                ref="selectModal"
                :plat-id="platId"
                :modal-data="actionFilterModal"
                @save-value="saveConditionValue"
                @close="closeConditionModal"/>
            <ContentModal
                ref="contentModal"
                :plat-id="platId"
                :modal-data="actionFilterModal"
                :condition="formItem.condition"
                :dimension="formItem.group"
                :range-time="formItem.range_time"
                :time-zone="formItem.time_zone"
                @save-value="saveConditionValue"
                :auto-load-fields="autoLoadFields"
                :is-time-filter="isTimeFilter"
                :apple-ad-field-list="appleAdFieldList"
                :apple-keywords-field-list="appleKeywordsFieldList"
                @remove-apple-form="removeAppleForm"
                @close="closeConditionModal"/>
            <DimensionModal
                ref="dimensionModal"
                :plat-id="platId"
                :modal-data="actionDimensionModal"
                :shown-field="shownFields"
                :hidden-field="hiddenFields"
                :all-field="fieldList"
                :dimensions="formItem.group"
                :condition="formItem.condition"
                :is-time-filter="isTimeFilter"
                :is-compare="isCompare"
                :apple-ad-field-list="appleAdFieldList"
                :apple-keywords-field-list="appleKeywordsFieldList"
                @remove-apple-form="removeAppleForm"
                @save-value="saveDimensionValue"/>

            <DateTips ref="dateTips" />

        </template>

        <template slot="bottom">
            <div class="table-tool-bar clear-both p6">
                <div class="fl">
                    <h3 class="title-group inline-block mr20">报表明细</h3>
                    <el-button icon="el-icon-setting" size="mini" disabled v-if="dataList.length<=0||dataLoading">冻结列</el-button>
                    <el-popover v-else placement="bottom-start" trigger="hover">
                        <div class="mt6" style="width: 260px;height: 120px;">
                            <el-radio-group v-model="tableSettings.tableFreezeCol" @change="handleTableFreezeChange">
                                <el-radio class="block ml10 mb10" label="1">冻结第一列</el-radio>
                                <el-radio :disabled="disabledFreezeDimension" :title="disabledFreezeDimension?'当前维度分组数量过多,冻结将影响您查看数据':''" class="block ml10 mb10" label="2">冻结所有维度列</el-radio>
                                <el-radio class="block ml10 mb10" label="3">自定义冻结列</el-radio>
                            </el-radio-group>
                            <p class="pl32 font12px" :class="tableSettings.tableFreezeCol!=3?'text-color-gray':''">冻结至
                                <el-input-number
                                    ref="freezeInput"
                                    v-model="tableSettings.tableFreezeColNum"
                                    :disabled="tableSettings.tableFreezeCol!=3"
                                    size="mini"
                                    controls-position="right"
                                    @change="handleTableFreezeChange"
                                    :min="0"
                                    :step="1"
                                    style="width: 110px;">
                                </el-input-number>
                                列
                            </p>
                        </div>
                        <el-button slot="reference" icon="el-icon-setting" size="mini">冻结列</el-button>
                    </el-popover>

                    <template v-if="lastSubmitRequestData.display_sum_dimension=='1'">
                        <el-tooltip class="item" effect="dark" content="已显示各维度汇总行" placement="top">
                            <el-checkbox disabled class="ml20">显示总-汇总数据</el-checkbox>
                        </el-tooltip>
                    </template>
                    <el-checkbox v-else v-model="tableSettings.showTotalRow"
                                 :disabled="dataLoading||(lastSubmitRequestData.group||[]).length<=2||dataList.length<=0" class="ml20">
                        显示总-汇总数据
                    </el-checkbox>
                    <el-checkbox v-if="!(isCompare&&this.formItem.compare_type=='self'&&!this.formItem.range_time1)"
                                 v-model="tableSettings.showDailyTotalRow"
                                 :disabled="dataLoading||(lastSubmitRequestData.group||[]).length<=2||dataList.length<=0">显示总-日均数据
                    </el-checkbox>
                </div>
                <div class="fr">
                    <el-tooltip  effect="dark" content="自定义列宽,最小宽度为100" placement="top">
                        <el-input-number placeholder="自定义列宽" v-model="tableSettings.customColWidth" @change="handleCustomColWidthChange" :min="100" step-strictly :controls="false" class=" mr20"/>
                    </el-tooltip>
                    <el-button size="mini" icon="el-icon-delete" :disabled="dataLoading||dataList.length<=0" class="mr20"
                               @click="clearTableData">清除表格数据
                    </el-button>
                    <span class="inline-block mr20">
                        <el-checkbox v-model="tableSettings.fixedTableHeight">固定表格高度</el-checkbox>
                    </span>
                    <el-button v-if="pageFuncNames.includes('download_report')" size="mini" icon="el-icon-download" :disabled="dataLoading||dataList.length<=0"
                               v-matomo="{behaviorCategory: `综合查询分析(${$route.meta.title})`, name: '列表结果区(下载报表)' }"
                               @click="showDownloadTableModal">下载报表
                    </el-button>


                </div>
            </div>
            <div class="data-table-wrap" v-loading="dataLoading" element-loading-spinner="custom-loading">
                <jt-table
                    border
                    :class="[tableSettings.fixedTableHeight?'':'no-fixed-table-height','data-table']"
                    id="data-table"
                    ref="table"
                    :data="allDataList"
                    :row-class-name="tableRowClassName"
                    :max-height="tableSettings.fixedTableHeight?tableMaxHeight:null"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @sort-change="tableSortChange"
                    @header-dragend="onHeaderDragend"
                    :default-sort="{prop: tableSettings.sortBy, order:tableSettings.sortOrder }"
                    style="width: 100%">
                    <el-table-column
                        v-for="(field,index) in columns"
                        :key="field.field+'-'+index"
                        :prop="field.field"
                        :label="field.name"
                        :fixed="field.fixed"
                        :sortable="field.sortable?'custom':null"
                        :sort-orders="field.sortable?tableSettings.sortOrderConfig:[]"
                        :type="field.field=='index'?'index':null"
                        show-overflow-tooltip
                        align="left"
                        :width="field.field=='index'?90:tableSettings.customColWidth"
                        :min-width="field.field=='index'?90:tableSettings.customColWidth">
                        <template slot="header" slot-scope="scope">
                            <CustomHeader
                                :plat-id="platId"
                                :condition="lastSubmitRequestData.condition"
                                :exclude-condition-fields="lastSubmitRequestData.exclude_condition_fields"
                                :form-field="lastSubmitRequestData.field"
                                :form-group="lastSubmitRequestData.group"
                                :range-time="lastSubmitRequestData.range_time"
                                :range-time1="lastSubmitRequestData.range_time1"
                                :compare-type="lastSubmitRequestData.compare_type"
                                :is-compare="isCompare"
                                :data-display-type="lastSubmitRequestData.data_display_type"
                                :cost-type="lastSubmitRequestData.cost_type"
                                :auto-load-fields="autoLoadFields"
                                :is-time-filter="isTimeFilter"
                                :timeInterval="lastSubmitRequestData.time_interval"
                                :time-zone="formItem.time_zone"
                                :item="field"
                                :ref="'customHeader-'+field.field"
                                :tableFilterList="tableFilterList"
                                @show-popper="hideOtherPopover"
                                @tableUpdate="tableUpdate">
                            </CustomHeader>
                            <!--<i class="el-icon-arrow-down" v-if="field.field!='index'" @click.stop="showFilterPop(field.field)"></i>-->
                        </template>
                        <template slot-scope="scope">
                            <span v-if="scope.column.property=='index'">
                                {{scope.row.index}}
                            </span>
                            <!--对比差值列-->
                            <div v-else-if="scope.column.property.includes('_diff')" style="z-index: 1;">
                                <p v-if="scope.row[field.field+'_color_bar']" class="inline-block cell-block-bg" :style="{width:scope.row[field.field+'_color_bar']*100+'%' }"></p>
                                <p class="ellipsis" :class="parseFloat(scope.row[field.field])>0?'text-color-success':parseFloat(scope.row[field.field])<0?'text-color-error':''"> {{scope.row[field.field]|Millimeter}}</p>
                            </div>
                            <div v-else class="relative" style="z-index: 1;">
                                <template v-if="submitDimensionNameList.includes(field.field)">
                                    <p class="ellipsis" v-if="field.field=='time_interval'">
                                        <span>{{scope.row[field.field]}}</span>
                                    </p>
                                    <p class="ellipsis" v-else>
                                        <span v-if="scope.row[field.field]=='总-日均'||scope.row[field.field]=='总-汇总'">-</span>
                                        <span v-else @mouseenter="showTdPop($event,field,scope.row)" @mouseleave="hideTdPop">{{scope.row[field.field]}}</span>
                                    </p>
                                </template>
                                <template v-else>
                                    <span v-if="scope.row[field.field+'_color_bar']" class="inline-block cell-block-bg" :style="{width:scope.row[field.field+'_color_bar']*100+'%' }"></span>

                                    <!--日期 对比日期  文本显示优化-->
                                    <template v-if="scope.column.property=='compare_date'||scope.column.property=='date'">
                                        <p class="ellipsis">{{scope.row[field.field]}}</p>
                                    </template>
                                    <p class="ellipsis" v-else>{{scope.row[field.field]|Millimeter}}</p>
                                </template>

                            </div>
                        </template>
                    </el-table-column>

                    <div slot="empty" class="mt50">
                        <p class="tac">暂无数据</p>
                        <p v-if="isPlatAll" class="text-color-error tac nowrap">当包含Apple媒体数据时，请注意币种问题，建议勾选币种维度，否则会出现多币种数据合并</p>
                    </div>
                </jt-table>
            </div>

            <div class="table-bottom-bar page-bar" v-show="!dataLoading">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryData.pn"
                    :pager-count="5"
                    :page-size="100"
                    layout="total, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>
            </div>
            <div class="game-loading-box"  v-if="dataLoading">
                <GameLoading ref="game-loading" />
            </div>

            <TableTdPop :action-data="actionColTd" :is-loading="tableTdPopLoading" @copy="copyFilterContent" @add="addFilter" @add-and-first="addFilterAndFirstGroup" @mouse-enter="clearHideTDPopTimer" @mouse-leave="hideTdPopNow"/>
        </template>
    </PageWrap>
</template>

<script>
    import { mapState } from 'vuex';
    import dayjs from 'dayjs';
    import quarterOfYear from 'dayjs/plugin/quarterOfYear';
    import Draggable from 'vuedraggable';
    import NoPermissionInfo from '@/components/noPermissionInfo';
    import PageWrap from './components/pageWrap';
    import CheckItem from './components/checkItem';
    import TitleGroup from './components/titleGroup';
    import FilterItem from './components/filterItem';
    import CustomHeader from './components/customTableHeader';
    import AddTemplateModal from './modal/templateModal';
    import TimeModal from './modal/timeModal';
    import DateModal from './modal/dateModal';
    import SelectModal from './modal/selectModal';
    import DateSelectModal from './modal/dateSelectModal';
    import ContentModal from './modal/contentModal';
    import DimensionModal from './modal/dimensionModal';
    import TemplateListDrawer from './drawer/templateList';
    import DateTips from './components/dateTips';
    import FilterActionPop from './components/filterActionPop';
    import HomeAPI from '@/api/home.js';
    import API from '@/api/dataCenter.js';
    import utils from '@/libs/utils.js';
    import dateShortcuts from '@/libs/dateShortcuts.js';
    import TableTdPop from './components/tableTdPop';
    import ExportModal from './modal/exportModal';
    import DownloadTableModal from './modal/downloadTableModal';
    import GameLoading from '@/components/GameLoading'

    dayjs.extend(quarterOfYear);

    export default {
        name: "QueryAnalysis",
        components: {
            GameLoading,
            NoPermissionInfo,
            PageWrap,
            AddTemplateModal,
            TemplateListDrawer,
            CheckItem,
            TitleGroup,
            TimeModal,
            DateModal,
            DateSelectModal,
            SelectModal,
            ContentModal,
            DimensionModal,
            Draggable,
            FilterItem,
            CustomHeader,
            DateTips,
            FilterActionPop,
            TableTdPop,
            ExportModal,
            DownloadTableModal,
        },
        data() {
            let _this = this;
            let customColWidth = window.localStorage.getItem('customColWidth') || 165;
            return {
                platName: '',
                platId: '',
                lastDataTime: null,
                disableDateLoading:false,
                notHasCostDate: [],      // 没有数据的，不可用日期
                hasCostDate:[],          // 有数据的，可用的日期
                startDate:'',
                endDate:'',
                dateAllDisabled:false,
                conditionLoading: false,
                dataLoading: false,
                exportLoading: false,
                activeFilterTab: 'first',
                leftWidth: 300,
                pageHeight: 500,
                isCompare: false,
                filterSearch: '',
                basePickerOptions: {
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            name:'today',
                            text: '今天',
                        },
                        dateShortcuts.yesterday,
                        dateShortcuts.last7,
                        dateShortcuts.last14,
                        dateShortcuts.last30,
                        dateShortcuts.thisWeek,
                        dateShortcuts.thisMonth,
                        dateShortcuts.thisQuarter,
                        dateShortcuts.thisYear,
                        dateShortcuts.lastWeek,
                        dateShortcuts.lastMonth,
                        dateShortcuts.lastQuarter,
                        dateShortcuts.lastYear,
                        dateShortcuts.firstHalfYear,
                        ...(new Date().getMonth() >= 6 ? [dateShortcuts.secondHalfYear] : []),
                        dateShortcuts.lastFirstHalfYear,
                        dateShortcuts.lastSecondHalfYear,
                        {
                            name:'all',
                            // text: '选中所有有数据日期',
                            text: '所有数据日期',
                            onClick(picker) {
                                setTimeout(()=>{
                                    _this.formItem.quick_date='所有有数据日期';
                                },300);
                                if(_this.dateAllDisabled){
                                    _this.$message.error('所选筛选在该日期无任何数据');
                                }else if(dayjs(_this.startDate).isAfter(dayjs(_this.endDate))){
                                    picker.$emit('pick', [dayjs(_this.startDate).format('YYYY-MM-DD'), dayjs(_this.startDate).format('YYYY-MM-DD')]);
                                }else{
                                    if(_this.hasCostDate.length>0){
                                        let costDateStart = _this.hasCostDate[0];
                                        if(dayjs(_this.startDate).isAfter(dayjs(costDateStart))){
                                            picker.$emit('pick', [dayjs(costDateStart).format('YYYY-MM-DD'), dayjs(_this.endDate).format('YYYY-MM-DD')]);
                                        }else{
                                            picker.$emit('pick', [dayjs(_this.startDate).format('YYYY-MM-DD'), dayjs(_this.endDate).format('YYYY-MM-DD')]);
                                        }
                                    }else{
                                        picker.$emit('pick', [dayjs(_this.startDate).format('YYYY-MM-DD'), dayjs(_this.endDate).format('YYYY-MM-DD')]);
                                    }
                                }
                            }
                        },
                    ],
                    disabledDate(time) {
                        let dateStr = utils.formatDate(time);
                        if(_this.startDate===null){
                            return true;
                        }
                        if(_this.dateAllDisabled){
                            return true;
                        }
                        if( time.getTime() < dayjs(_this.startDate).valueOf()){
                            return true;
                        }
                        if( time.getTime() > dayjs(_this.endDate).valueOf()){
                            return true;
                        }

                        if(_this.dataDays>0){
                            /* 最近n天 */
                            let curStartDate = dayjs().subtract(_this.dataDays,'day');
                            if(dayjs(time).isBefore(curStartDate)){
                                return true;
                            }
                        }

                        return time.getTime() > new Date(_this.lastDataTime).getTime() || _this.notHasCostDate.includes(dateStr);
                    },
                    cellClassName(date) {
                        let dateStr = dayjs(date).format('YYYY-MM-DD');
                        if(_this.dataDays>0){
                            /* 最近n天 */
                            let curStartDate = dayjs().subtract(_this.dataDays,'day');
                            if(dayjs(date).isBefore(curStartDate)){
                                return 'td-disabled-date';
                            }else{
                                if (_this.notHasCostDate.includes(dateStr)) {
                                    return 'td-empty-date';
                                }
                                if(dayjs(dateStr).isBefore(_this.startDate)&&dayjs(dateStr).isAfter(dayjs(_this.lastDataTime))){
                                    return 'td-empty-date';
                                }
                                if(dayjs(dateStr).isAfter(_this.endDate)&&dayjs(dateStr).isBefore(dayjs(_this.lastDataTime))){
                                    return 'td-empty-date';
                                }
                                if(dayjs(dateStr).isAfter(_this.endDate)&&dayjs(dateStr).isSame(dayjs(_this.lastDataTime))){
                                    return 'td-empty-date';
                                }
                            }
                        }else{
                            /* 不限日期 */
                            if (_this.notHasCostDate.includes(dateStr)) {
                                return 'td-empty-date';
                            }
                            if(dayjs(dateStr).isBefore(_this.startDate)||dayjs(dateStr).isAfter(_this.endDate)){
                                return 'td-empty-date';
                            }
                        }
                    },
                },
                comparePickerOptions: {
                    firstDayOfWeek: 1,
                    onPick(time) {
                        /* 没有数据日期维度时，可自行选择 */
                        if(!_this.isHasDateDimension){
                            return false;
                        }else if (time.minDate && !time.maxDate) {
                            let baseDate = _this.formItem.range_time;
                            let diff = dayjs(baseDate[1]).diff(dayjs(baseDate[0]), 'day');
                            _this.formItem.range_time1 = [dayjs(time.minDate).format('YYYY-MM-DD'), dayjs(time.minDate).add(diff, 'day').format('YYYY-MM-DD')];
                            _this.$refs.range_time1.handleClose();
                        }
                    },
                    disabledDate(time) {
                        let dateStr = utils.formatDate(time);
                        if(_this.startDate===null){
                            return true;
                        }
                        if( time.getTime() < dayjs(_this.startDate).valueOf()){
                            return true;
                        }
                        if( time.getTime() > dayjs(_this.endDate).valueOf()){
                            return true;
                        }
                        if(_this.dataDays>0){
                            /* 最近n天 */
                            let curStartDate = dayjs().subtract(_this.dataDays,'day');
                            if(dayjs(time).isBefore(curStartDate)){
                                return true;
                            }
                        }
                        if(_this.isCompare&&_this.formItem.compare_type=='self'){
                            if(_this.formItem.range_time[0]==dateStr){
                                return true;
                            }
                        }
                        return time.getTime() > new Date(_this.lastDataTime).getTime() || _this.notHasCostDate.includes(dateStr);
                    },
                    cellClassName(date) {
                        let dateStr = dayjs(date).format('YYYY-MM-DD');
                        if (_this.formItem.range_time[0]==dateStr) {
                            return 'td-disabled-same-start-date';
                        }
                    }
                },
                timeOptionRange: null,
                dataDays: "",
                conditionList: [],   // 筛选条件
                dimensionList: [],   //  维度分组
                fieldList: [],       //  数据指标
                formItem: {
                    quick_date:'',
                    range_time: [],
                    compare_type: '',
                    range_time1: [],
                    condition: [],
                    group: [],
                    field: [],
                    dimension_default_sort:'1',
                    data_display_type: 'sum_up',       //average-日均，sum_up-汇总
                    display_sum_dimension: '',
                    cost_type: '',
                    time_zone:'',   // 数据时区，仅Apple渠道和整体需要 - Asia/Shanghai   UTC
                },
                lastSubmitRequestData: {},
                actionFilterModal: {
                    title: '',
                },
                actionDimensionModal: {
                    title: '',
                },
                isDisabledYoY:true,
                shownFields: [],
                hiddenFields: [],
                shownDimensions: [],
                hiddenDimensions: [],
                shownConditions: [],
                hiddenConditions: [],
                filterDisplayCounts:4,
                columns: [],
                dataList: [],
                dataListCopy: [],
                sumTotalData: {},
                avgTotalData: {},
                lastFileName:'',


                //表格冻结
                tableSettings: {
                    tableFreezeCol: '1',
                    tableFreezeColNum: null,
                    showTotalRow: false,
                    showDailyTotalRow: false,
                    sortBy:'',
                    sortOrder:null,
                    sortOrderConfig:['ascending', 'descending', null],
                    fixedTableHeight:true,
                    customColWidth: customColWidth,
                },
                disabledFreezeDimension:false,
                tableMaxHeight:200,
                pageFunc: [],
                isPageAllowed: true,
                // filterTabContentHeight: 0,
                filterTabCondition: [],
                filterTabDimension: [],
                filterTabField: [],
                dataColumns: [],
                curTableDimensions: [],
                tableFilterList: [],     //用来存放前端筛选生效的条件

                // 内容弹窗列表内容需要自动加载的字段,也用来区分前端筛选后端筛选
                autoLoadFields:[
                    'bloc_name',
                    'company_name',
                    'account_id',
                    'account_name',
                    'app_id',
                    'app_name',
                    'main_app_name',
                    'project_name',
                    'package_name',
                    'plan_id',
                    'plan_name',
                    'adgroup_id',
                    'adgroup_name',
                    'ad_id',
                    'ad_name',
                    'idea_id',
                    'idea_name',
                    'task_id',
                    'task_name',
                    'sub_task_id',
                    'sub_task_name',
                    'campaign_id',
                    'campaign_name',
                    'keyword_id',
                    'key_word_text',
                    'search_term_text',
                    'subproject_content',
                    'subproject_name',
                    'subproject_id',
                    'creative_id',
                    'creative_name',
                    'group_id',
                ],

                // [添加筛选]临时存储字段
                tempChangedConditions:[],
                actionColTd:{
                    col:null,
                    row:null,
                    event:null,
                    type:'',
                },
                showTdPopTimer:null,
                hideTdPopTimer:null,
                exportFileName:'',
                hourSearchDays:31,    //分时数据的允许查询时间跨度-天


                queryData:{
                    pn: 1,
                    rn: 100,
                },
                totalCnt:0,
                resizeTimer:null,

                appleAdFieldList: ['ad_id','ad_name'],
                appleKeywordsFieldList: ['keyword_id','key_word_text','search_term_text','match_type','search_term_source'],
                isPlatAll:false,

                // vivo 综合查询分析-消耗指标小数位配置（unified:1-统一设置/0-独立设置，取值0~5）
                costDecimalConfig: {
                    unified: 1,
                    cost: 5,
                    cash_cost: 5,
                    vir_cost: 5,
                },
            }
        },
        computed: {
            ...mapState({
                sidebarOpened:state => state.app.sidebar.opened,
                pageConfig:state => state.user.page_config,
            }),
            dimensionResultList() {
                let allData = [];
                this.dimensionList.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        allData = allData.concat(item.children);
                    }
                });
                return allData.filter(item => {
                    let name = (item.display_name || '').toLowerCase();
                    let searchText = this.filterSearch.toLowerCase();
                    return name.includes(searchText);
                });
            },
            submitDimensionNameList(){
                let submitDimension = JSON.parse(this.lastSubmitRequestData.group)||[];
                console.log('submitDimensionNameList',submitDimension);
                return submitDimension.map(item=>item.group_by);
            },
            fieldResultList() {
                let allData = [];
                this.fieldList.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        allData = allData.concat(item.children);
                    }
                });
                return allData.filter(item => {
                    let name = (item.display_name || '').toLowerCase();
                    let searchText = this.filterSearch.toLowerCase();
                    return name.includes(searchText);
                });
            },
            pageFuncNames() {
                return this.pageFunc.map(item => item.name);
            },
            allDataList() {
                if(this.dataList.length<=0) return [];
                let avgCol = this.tableSettings.showDailyTotalRow ? [this.avgTotalData] : [];
                let sumCol = this.tableSettings.showTotalRow ? [this.sumTotalData] : [];

                if(this.lastSubmitRequestData.display_sum_dimension=='1'){
                    sumCol = [];
                }
                return [].concat(sumCol,avgCol,this.dataList);
            },
            filterTabContentHeight(){
                let $chosenArea = document.querySelector('.chosen-area') || {};
                return $chosenArea.clientHeight + 11;
            },
            costFieldList(){
                let allData = [];
                this.fieldList.forEach(item => {
                    if (item.children && item.children.length > 0) {
                        allData = allData.concat(item.children);
                    }
                });
                let allDataName = allData.map(item=>item.name);
                let costList = ['cost','cash_cost','vir_cost','gift_cost','star_cost','exchange_cost','local_spend', 'rebate_cost','ad_billing','cash_count','inner_virtual_sum','virtual_and_cash_count','virtual_count',];
                let validCost = costList.filter(item=>allDataName.includes(item));
                if(validCost.length>0&&!this.formItem.cost_type){
                    this.formItem.cost_type = validCost[0];
                }
                return validCost;
            },
            earliestPermissionDate(){
                return this.dataDays<0?null:dayjs().subtract((this.dataDays-1),'day').format('YYYY-MM-DD');
            },
            isFilterLoading(){
                return this.formItem.condition.some(item=>!!item.filterLoading);
            },
            isTimeFilter(){
                let conditions = this.formItem.condition.map(item=>item.name);
                let groups = this.formItem.group.map(item=>item.name);
                return conditions.includes('time_interval')||groups.includes('time_interval');
            },
            platTimeInterval(){
                if(!this.isTimeFilter) return '';
                return 'hour';
            },
            isHasDateDimension(){
                return this.formItem.group.map(item=>item.name).includes('date');
            },
            tableTdPopLoading(){
                let colData = this.actionColTd.col||{};
                let fieldData = colData.field||'';
                if(!fieldData) return false;

                let actionCondition = this.formItem.condition.find(item=>item.name==fieldData);
                if(!actionCondition) return false;

                return !!actionCondition.filterLoading;
            },
            excludeConditionFields(){
                let contendConditions = this.formItem.condition.filter(item=>{
                    let fieldConfig = item.config||{};
                    return fieldConfig.type==='content';
                });
                return contendConditions.filter(item=>item.isExclude).map(item=>item.name);
            },
            multipleSearchDimensionNames(){
                let allDimensions = [];
                this.dimensionList.forEach(item=>{
                    if(item.children&&item.children.length>0){
                        allDimensions = allDimensions.concat(item.children);
                    }
                });
                return allDimensions.filter(item=>{
                    let config = item.config||{};
                    return config.multiple_search=='true';
                }).map(item=>item.name);
            },
            isAppleKeywordsChecked(){
                /* 关键词系列维度 与 广告维度  不能一起选择 */
                if(this.platId!='9') return false;
                let formGroup = this.formItem.group;
                let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                let groupStartDate = formGroup.find(item=>item.name=='start_date');
                let keywordsFieldList = this.appleKeywordsFieldList;
                let isGroupHasKeywords = formGroup.map(item=>item.name).some(item=>keywordsFieldList.includes(item));

                let groupYYType = formGroup.find(item=>item.name=='yy_type');
                let isGroupYYTypeKeywords = (groupYYType?.dimensionValue?.yy_type_dimension||'') == 'keyword_yy_type';
                let isGroupCreateDateKeywords = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'keyword_create_date';
                let isGroupStartDateKeywords = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'keyword';
                let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';


                let formCondition = this.formItem.condition;
                let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                let conditionStartDate = formCondition.find(item=>item.name=='start_date');
                let isConditionHasKeywords = formCondition.map(item=>item.name).some(item=>keywordsFieldList.includes(item));
                let conditionYYType = formCondition.find(item=>item.name=='yy_type');
                let isConditionYYTypeKeywords = (conditionYYType?.selectValue||'') == 'keyword_yy_type';
                let isConditionCreateDateKeywords = (conditionCreateDate?.selectValue||'') == 'keyword_create_date';
                let isConditionStartDateKeywords = (conditionStartDate?.selectValue||'') == 'keyword';
                let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';

                return isGroupHasKeywords||isGroupYYTypeKeywords||isGroupCreateDateKeywords||isGroupStartDateKeywords||isGroupStartDateSearchTerm||isConditionHasKeywords||isConditionYYTypeKeywords||isConditionCreateDateKeywords||isConditionStartDateKeywords||isConditionStartDateSearchTerm;
            },
            isAppleSearchTermChecked(){
                if(!this.isAppleKeywordsChecked) return false;
                let formGroup = this.formItem.group;
                let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                let groupStartDate = formGroup.find(item=>item.name=='start_date');
                let keywordsFieldList =  ['search_term_text','match_type','search_term_source'];
                let isGroupHasKeywords = formGroup.map(item=>item.name).some(item=>keywordsFieldList.includes(item));
                let groupYYType = formGroup.find(item=>item.name=='yy_type');
                let isGroupYYTypeKeywords = (groupYYType?.dimensionValue?.yy_type_dimension||'') == 'keyword_yy_type';
                let isGroupCreateDateKeywords = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'keyword_create_date';
                let isGroupStartDateKeywords = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'keyword';
                let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';
                let formCondition = this.formItem.condition;
                let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                let conditionStartDate = formCondition.find(item=>item.name=='start_date');
                let isConditionHasKeywords = formCondition.map(item=>item.name).some(item=>keywordsFieldList.includes(item));
                let conditionYYType = formCondition.find(item=>item.name=='yy_type');
                let isConditionYYTypeKeywords = (conditionYYType?.selectValue||'') == 'keyword_yy_type';
                let isConditionCreateDateKeywords = (conditionCreateDate?.selectValue||'') == 'keyword_create_date';
                let isConditionStartDateKeywords = (conditionStartDate?.selectValue||'') == 'keyword';
                let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';
                return isGroupHasKeywords||isGroupYYTypeKeywords||isGroupCreateDateKeywords||isGroupStartDateKeywords||isGroupStartDateSearchTerm||isConditionHasKeywords||isConditionYYTypeKeywords||isConditionCreateDateKeywords||isConditionStartDateKeywords||isConditionStartDateSearchTerm;
            },
            isAppleAdChecked(){
                /* 关键词系列维度 与 广告维度  不能一起选择 */
                if(this.platId!='9') return false;
                let formGroup = this.formItem.group;
                let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                let groupStartDate = formGroup.find(item=>item.name=='start_date');

                let adFieldList = this.appleAdFieldList;
                let isGroupHasAd = formGroup.map(item=>item.name).some(item=>adFieldList.includes(item));
                let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';

                let formCondition = this.formItem.condition;
                let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                let conditionStartDate = formCondition.find(item=>item.name=='start_date');

                let isConditionHasAd = formCondition.map(item=>item.name).some(item=>adFieldList.includes(item));
                let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';
                return isGroupHasAd||isGroupCreateDateAd||isGroupStartDateAd||isConditionHasAd||isConditionCreateDateAd||isConditionStartDateAd;
            },
        },
        filters:{
            Millimeter(val){
                if(!val) return val;
                if(val.includes('%')) return val;
                if(isNaN(val)) return val;
                if(typeof (+val)==='number'){
                    const intPart = Math.trunc(val);
                    // 整数部分处理，增加,
                    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
                    // 预定义小数部分
                    let floatPart = '';
                    // 将数值截取为小数部分和整数部分
                    const valueArray = val.toString().split('.');
                    if (valueArray.length === 2) { // 有小数部分
                        floatPart = valueArray[1].toString();   // 取得小数部分

                        return (val<0&&val>-1?'-':'') + intPartFormat + '.' + floatPart;
                    }
                    return intPartFormat + floatPart;
                }else{
                    return val;
                }
            },
        },
        watch: {
            'formItem.field'() {
                let length = this.formItem.field.length;
                this.shownFields = this.formItem.field.slice(0, this.filterDisplayCounts);
                this.hiddenFields = length > this.filterDisplayCounts ? this.formItem.field.slice(this.filterDisplayCounts, length) : [];
            },
            'formItem.group'() {
                let length = this.formItem.group.length;
                this.shownDimensions = this.formItem.group.slice(0, this.filterDisplayCounts);
                this.hiddenDimensions = length > this.filterDisplayCounts ? this.formItem.group.slice(this.filterDisplayCounts, length) : [];
            },
            'formItem.condition'() {
                let length = this.formItem.condition.length;
                this.shownConditions = this.formItem.condition.slice(0, this.filterDisplayCounts);
                this.hiddenConditions = length > this.filterDisplayCounts ? this.formItem.condition.slice(this.filterDisplayCounts, length) : [];
            },
            sidebarOpened(){
                setTimeout(()=>{
                    this.calcFilterDisplayCounts();
                },600);
            },
        },
        created() {
            this.getPageAllowAction();
            this.$store.dispatch('app/closeSideBar', {withoutAnimation: false});

            let matchedRoute = this.$route.matched || [];
            let routeName = matchedRoute[matchedRoute.length - 1].name;
            let platNameMap = {
                data_1: 'oppo',
                data_3: 'vivo',
                data_4: 'huawei',
                data_7: 'mi',
                data_8: 'iqiyi',
                data_9: 'apple',
                data_10: 'huaweiads',
                data_11: 'honor',
                data_37: 'mi',
                data_12: 'mi_global',
            };
            this.platName = platNameMap[routeName];
            this.platId = routeName == 'data_all' ? '' : routeName.replace('data_', '');
            this.isPlatAll =  routeName == 'data_all';

            if(this.platId=='9'||this.isPlatAll){
                this.formItem.time_zone = 'UTC';
            }
            if((this.isPageAllowed&&this.platId)||this.isPlatAll){
                this.updateDisableDate();
            }
            if(this.platId=='3'){
                this.getVivoCostDecimalConfig();
            }
        },
        mounted() {
            this.calcFilterDisplayCounts();
            let _this = this;

            $('body').on('mouseover', '.td-disabled-date', function (e) {
                let $target = $(e.target);
                let tipStr = _this.dataDays>0?'当前权限仅可查询近'+_this.dataDays+'天数据,若需查询该日请向上级领导申请':'';
                $target.attr('title', tipStr);
            }).on('mouseover','.td-disabled-date-time',function(e){
                let $target = $(e.target);
                $target.attr('title', '分时数据仅支持查询近'+_this.hourSearchDays+'天')
            }).on('mouseover', '.td-empty-date', function (e) {
                let $target = $(e.target);
                $target.attr('title', '所选筛选条件在该日期无任何数据')
            }).on('mouseover','.td-disabled-same-start-date',function(e){
                let $target = $(e.target);
                $target.attr('title', '该日期与数据开始日期一致')
            }).on('mouseover','td.available',function(e){
                let $target = $(e.target);
                let oldTitle = $target.attr('title');
                if(oldTitle){
                    $target.attr('title', '');
                    let children = Array.from($target.find('*'));
                    children.forEach(node=>{
                        let title = $(node).attr('title');
                        if(title){
                            $(node).attr('title','');
                        }
                    })
                }
            });

            let $elTable = document.querySelector('.data-table-wrap .el-table__body-wrapper');
            $elTable&&$elTable.addEventListener('scroll',_this.hideTdPop);
            $('.sidebar-container,.fixed-header,.tab-bar,.left-wrap,.right-top,.table-tool-bar').on('mouseenter.tdPop',()=>{
                if(_this.actionColTd&&_this.actionColTd.col){
                    _this.hideTdPopNow();
                }
            });
        },
        methods: {
            onHeaderDragend() {
                setTimeout(()=> {
                    this.$refs.pageWrap.calcBottomHeight()
                }, 500)
            },
            handleCustomColWidthChange(value) {
                window.localStorage.setItem('customColWidth', value);
                setTimeout(()=> {
                    this.$refs.pageWrap.calcBottomHeight()
                }, 500)
            },
            initPage(){
                console.log('initPage');
                // this.getPageAllowAction();      // 重新获取条件配置
                // this.resetFilters();        // 重置筛选条件
                // this.dataList = [];

            },
            getPageAllowAction() {
                let navId = this.$route.meta.pid;
                let navTabId = this.$route.meta.id;
                if (navId) {
                    this.conditionLoading = true;
                    HomeAPI.getPageAllowAction({
                        action_id: navId,
                    }).then(res => {
                        let resData = res.data || {};

                        this.dataDays = resData.data_days;
                        this.hourSearchDays = resData.hour_search_days||31;
                        let actionData = (resData.page_action || []).find(item => item.id == navTabId);

                        /* 后端传回的config为JSON字符串，需要parse成json */
                        this.fieldList = this._formatDataConfig(actionData.fields);
                        let costName = this.platId=='9'?'local_spend':'cost';
                        if(this.platId=='11'){
                            costName = 'ad_billing';
                        }
                        let costField =  this._findFieldByName(this.fieldList, costName);
                        /* 产品要求，有消耗字段时默认选中 */
                        if(costField){
                            this.$set(costField, 'checked', true);
                            this.changeCheckItem(costField, true, 'field');
                        }


                        this.dimensionList = utils.deepClone(this._formatDataConfig(actionData.dimension));
                        this.conditionList = utils.deepClone(this._formatDataConfig(actionData.dimension));
                        let dateCondition = this._findFieldByName(this.conditionList, 'date');
                        let dateDimension = this._findFieldByName(this.dimensionList, 'date');
                        if (dateCondition) {
                            this.$set(dateCondition, 'checked', true);
                            this.$set(dateCondition, 'disabled', true);
                        }
                        if (dateDimension) {
                            this.$set(dateDimension, 'checked', true);
                            this.changeCheckItem(dateDimension, true, 'group');
                        }

                        /*Tab中默认展开所有项*/
                        this.filterTabCondition = actionData.dimension.map(item => item.name);
                        this.filterTabDimension = actionData.dimension.map(item => item.name);
                        this.filterTabField = actionData.fields.map(item => item.name);
                        this.lastDataTime = dayjs().format('YYYY-MM-DD');

                        // 个性化配置：1-昨日，0-今日，默认昨日
                        let pageConfigDateType = this.pageConfig.data_query_analysis_default_date_type||'1';
                        let dayStr = dayjs().subtract(+pageConfigDateType,'day').format('YYYY-MM-DD');
                        this.formItem.range_time = [dayStr,dayStr];

                        /* 根据最后更新日期 修正日期 */
                        let todayOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'today');
                        let yesterdayOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'yesterday');
                        let last7Options = this.basePickerOptions.shortcuts.find(item => item.name == 'last7');
                        let last14Options = this.basePickerOptions.shortcuts.find(item => item.name == 'last14');
                        let last30Options = this.basePickerOptions.shortcuts.find(item => item.name == 'last30');


                        let thisWeekOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'thisWeek');
                        let thisMonthOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'thisMonth');
                        let thisQuarterOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'thisQuarter');
                        let thisYearOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'thisYear');

                        let lastWeekOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'lastWeek');
                        let lastMonthOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'lastMonth');
                        let lastQuarterOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'lastQuarter');
                        let lastYearOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'lastYear');
                        let firstHalfYearOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'firstHalfYear');
                        let secondHalfYearOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'secondHalfYear');
                        let lastFirstHalfYearOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'lastFirstHalfYear');
                        let lastSecondHalfYearOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'lastSecondHalfYear');
                        let allDateOptions = this.basePickerOptions.shortcuts.find(item => item.name == 'all');

                        todayOptions.onClick = (picker)=>{
                            let startDate = dayjs().format('YYYY-MM-DD');

                            if(this.notHasCostDate.includes(startDate)){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else{
                                setTimeout(()=>{
                                    this.formItem.quick_date='今天';
                                },300);
                                picker.$emit('pick', [startDate,startDate]);
                            }
                        };
                        yesterdayOptions.onClick = (picker)=>{
                            let lastTime = new Date(this.lastDataTime);
                            const date = new Date();
                            let startDate = date.setTime(date.getTime() - 3600 * 1000 * 24);
                            let endDate = startDate;
                            endDate = dayjs(lastTime).valueOf()<=dayjs(endDate).valueOf()?lastTime:endDate;

                            /*
                            * if(有权限设置){
                            *   开始日期 = 最早权限日期<开始日期?开始日期: 最早权限日期;
                            *     if(结束日期<最早权限日期){
                            *       提示 无权限
                            *     }
                            * }
                            *
                            * if(所选时间段有数据){
                            *     选中时间段
                            * }else{
                            *     提示：所选时间段无数据
                            * }
                            * */

                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }
                            //
                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            //
                            if(!this.hasCostDate.includes(startStr)){
                                return this.$message.error('所选筛选在该日期无任何数据');
                            }

                            if(dayjs(startDate).valueOf()<dayjs(this.startDate+'').valueOf()){
                                this.$message.error('部分日期超过查看权限~');
                            }else if(dayjs(lastTime).isBefore(startDate,'day')||this.notHasCostDate.includes(startDate)){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else{
                                setTimeout(()=>{
                                    this.formItem.quick_date='昨天';
                                },300);
                                picker.$emit('pick', [dayjs(startDate).format('YYYY-MM-DD'),dayjs(startDate).format('YYYY-MM-DD')]);
                            }
                        };


                        last7Options.onClick = picker=>{
                            const date = new Date();
                            let lastTime = new Date(this.lastDataTime);
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 6);
                            let endDate = new Date();
                            endDate = lastTime.getTime()<=endDate.getTime()?lastTime:endDate;

                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');

                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }

                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='最近7天';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };
                        last14Options.onClick = picker=>{
                            const date = new Date();
                            let lastTime = new Date(this.lastDataTime);
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 13);
                            let endDate = new Date();
                            endDate = lastTime.getTime()<=endDate.getTime()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');

                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='最近14天';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        last30Options.onClick = picker=>{
                            const date = new Date();
                            let lastTime = new Date(this.lastDataTime);
                            let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 29);
                            let endDate = new Date();
                            endDate = lastTime.getTime()<=endDate.getTime()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');

                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='最近30天';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        thisWeekOptions.onClick = picker=>{

                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;
                            let day = date.getDate();
                            let weekDay = date.getDay();
                            let endDate = year+'-'+month+'-'+day;
                            let startD = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                            let startDate = startD.getFullYear()+'-'+(startD.getMonth()+1)+'-'+startD.getDate();
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');

                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='本周';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        thisMonthOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;
                            let startDate = year+'-'+month+'-1';
                            let day = date.getDate();
                            let endDate = year+'-'+month+'-'+day;
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='本月';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        thisQuarterOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;
                            let startDate='';
                            if([1,2,3].includes(month)){
                                startDate = year+'-01-01';
                            }else if([4,5,6].includes(month)){
                                startDate = year+'-04-01';
                            }else if([7,8,9].includes(month)){
                                startDate = year+'-07-01';
                            }else if([10,11,12].includes(month)){
                                startDate = year+'-10-01';
                            }
                            let day = date.getDate();
                            let endDate = year+'-'+month+'-'+day;
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);


                            // 分时数据-快捷日期判断
                            if(this.isTimeFilter){
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour,'day');
                                if(diffHour>this.hourSearchDays){
                                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                }
                            }



                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='本季度';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        thisYearOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;
                            let day = date.getDate();
                            let startDate= year+'-01-01';
                            let endDate = year+'-'+month+'-'+day;
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;

                            // 分时数据-快捷日期判断
                            if(this.isTimeFilter){
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour,'day');
                                if(diffHour>this.hourSearchDays){
                                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                }
                            }


                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='本年';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        lastWeekOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date(new Date().getTime()-1000*60*60*24*7);
                            let weekDay = date.getDay();
                            let startDate = new Date(date.getTime()-1000*60*60*24*(weekDay===0?6:weekDay-1));
                            let endDate = new Date(startDate.getTime() + 1000*60*60*24*6);
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='上周';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        lastMonthOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            // let startDate = new Date(year+'-'+month+'-01');
                            let startDate = dayjs().subtract(1,'month').startOf('month').format('YYYY-MM-DD');
                            let endDate = new Date(new Date(year+'-'+(month+1)+'-01').getTime()-1000*60*60*24);
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;

                            // 分时数据-快捷日期判断
                            if(this.isTimeFilter){
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour,'day');
                                if(diffHour>this.hourSearchDays){
                                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                }
                            }

                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);
                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='上月';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        // lastQuarterOptions.onClick = dateShortcuts.getLastQuarter(this.lastDataTime).onClick;
                        lastQuarterOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth()+1;

                            let startDateStr='';
                            let endDateStr = '';
                            if([1,2,3].includes(month)){
                                startDateStr = (year-1)+'-10-01';
                                endDateStr = (year-1)+'-12-31';
                            }else if([4,5,6].includes(month)){
                                startDateStr = year+'-01-01';
                                endDateStr = year+'-03-31';
                            }else if([7,8,9].includes(month)){
                                startDateStr = year+'-04-01';
                                endDateStr = year+'-06-30';
                            }else if([10,11,12].includes(month)){
                                startDateStr = year+'-07-01';
                                endDateStr = year+'-09-30';
                            }
                            let startDate = new Date(startDateStr);
                            let endDate = new Date(endDateStr);
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);

                            // 分时数据-快捷日期判断
                            if(this.isTimeFilter){
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour,'day');
                                if(diffHour>this.hourSearchDays){
                                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                }
                            }

                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='上季度';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        lastYearOptions.onClick = picker=>{
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear()-1;
                            let startDate= year+'-01-01';
                            let endDate = year+'-12-31';
                            endDate = lastTime.getTime()<=dayjs(endDate).valueOf()?lastTime:endDate;
                            // startDate = dayjs(startDate).valueOf() > dayjs(this.startDate).valueOf()?startDate:dayjs(this.startDate);

                            // 分时数据-快捷日期判断
                            if(this.isTimeFilter){
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour,'day');
                                if(diffHour>this.hourSearchDays){
                                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                }
                            }

                            if(this.earliestPermissionDate){
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf()?startDate:dayjs(this.earliestPermissionDate);
                                if(dayjs(endDate).isBefore(this.earliestPermissionDate)){
                                    return this.$message.error('当前权限仅可查询近'+this.dataDays+'天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                            let diffDateArr = [];
                            for(let i=0;i<=diff;i++){
                                diffDateArr.push(dayjs(startDate).add(i,'day').format('YYYY-MM-DD'));
                            }
                            if(this.dateAllDisabled){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else if(diffDateArr.every(item=>!this.hasCostDate.includes(item))){
                                this.$message.error('所选筛选在该日期无任何数据');
                            }else {
                                setTimeout(()=>{
                                    this.formItem.quick_date='去年';
                                },300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        };

                        firstHalfYearOptions && (firstHalfYearOptions.onClick = picker => {
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-01-01';
                            let endDate = month <= 6 ? (year + '-' + month + '-' + day) : (year + '-06-30');
                            endDate = lastTime.getTime() <= dayjs(endDate).valueOf() ? lastTime : dayjs(endDate).format('YYYY-MM-DD');

                            if (this.isTimeFilter) {
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour, 'day');
                                if (diffHour > this.hourSearchDays) {
                                    return this.$message.error('分时段数据仅支持查询最多' + this.hourSearchDays + '天，请修改数据日期后重试！');
                                }
                            }

                            if (this.earliestPermissionDate) {
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf() ? startDate : dayjs(this.earliestPermissionDate);
                                if (dayjs(endDate).isBefore(this.earliestPermissionDate)) {
                                    return this.$message.error('当前权限仅可查询近' + this.dataDays + '天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr)) / (1000 * 60 * 60 * 24);
                            let diffDateArr = [];
                            for (let i = 0; i <= diff; i++) {
                                diffDateArr.push(dayjs(startDate).add(i, 'day').format('YYYY-MM-DD'));
                            }
                            if (this.dateAllDisabled) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else if (diffDateArr.every(item => !this.hasCostDate.includes(item))) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else {
                                setTimeout(() => {
                                    this.formItem.quick_date = '上半年';
                                }, 300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        });

                        secondHalfYearOptions && (secondHalfYearOptions.onClick = picker => {
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear();
                            let month = date.getMonth() + 1;
                            let day = date.getDate();
                            let startDate = year + '-07-01';
                            let endDate = month >= 7 ? (year + '-' + month + '-' + day) : (year + '-12-31');
                            endDate = lastTime.getTime() <= dayjs(endDate).valueOf() ? lastTime : dayjs(endDate).format('YYYY-MM-DD');

                            if (this.isTimeFilter) {
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour, 'day');
                                if (diffHour > this.hourSearchDays) {
                                    return this.$message.error('分时段数据仅支持查询最多' + this.hourSearchDays + '天，请修改数据日期后重试！');
                                }
                            }

                            if (this.earliestPermissionDate) {
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf() ? startDate : dayjs(this.earliestPermissionDate);
                                if (dayjs(endDate).isBefore(this.earliestPermissionDate)) {
                                    return this.$message.error('当前权限仅可查询近' + this.dataDays + '天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr)) / (1000 * 60 * 60 * 24);
                            let diffDateArr = [];
                            for (let i = 0; i <= diff; i++) {
                                diffDateArr.push(dayjs(startDate).add(i, 'day').format('YYYY-MM-DD'));
                            }
                            if (this.dateAllDisabled) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else if (diffDateArr.every(item => !this.hasCostDate.includes(item))) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else {
                                setTimeout(() => {
                                    this.formItem.quick_date = '下半年';
                                }, 300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        });

                        lastFirstHalfYearOptions && (lastFirstHalfYearOptions.onClick = picker => {
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-01-01';
                            let endDate = year + '-06-30';
                            endDate = lastTime.getTime() <= dayjs(endDate).valueOf() ? lastTime : endDate;

                            if (this.isTimeFilter) {
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour, 'day');
                                if (diffHour > this.hourSearchDays) {
                                    return this.$message.error('分时段数据仅支持查询最多' + this.hourSearchDays + '天，请修改数据日期后重试！');
                                }
                            }

                            if (this.earliestPermissionDate) {
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf() ? startDate : dayjs(this.earliestPermissionDate);
                                if (dayjs(endDate).isBefore(this.earliestPermissionDate)) {
                                    return this.$message.error('当前权限仅可查询近' + this.dataDays + '天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr)) / (1000 * 60 * 60 * 24);
                            let diffDateArr = [];
                            for (let i = 0; i <= diff; i++) {
                                diffDateArr.push(dayjs(startDate).add(i, 'day').format('YYYY-MM-DD'));
                            }
                            if (this.dateAllDisabled) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else if (diffDateArr.every(item => !this.hasCostDate.includes(item))) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else {
                                setTimeout(() => {
                                    this.formItem.quick_date = '去年上半年';
                                }, 300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        });

                        lastSecondHalfYearOptions && (lastSecondHalfYearOptions.onClick = picker => {
                            let lastTime = new Date(this.lastDataTime);
                            let date = new Date();
                            let year = date.getFullYear() - 1;
                            let startDate = year + '-07-01';
                            let endDate = year + '-12-31';
                            endDate = lastTime.getTime() <= dayjs(endDate).valueOf() ? lastTime : endDate;

                            if (this.isTimeFilter) {
                                let startHour = dayjs(startDate);
                                let endHour = dayjs(endDate);
                                let diffHour = endHour.diff(startHour, 'day');
                                if (diffHour > this.hourSearchDays) {
                                    return this.$message.error('分时段数据仅支持查询最多' + this.hourSearchDays + '天，请修改数据日期后重试！');
                                }
                            }

                            if (this.earliestPermissionDate) {
                                startDate = dayjs(startDate).valueOf() > dayjs(this.earliestPermissionDate).valueOf() ? startDate : dayjs(this.earliestPermissionDate);
                                if (dayjs(endDate).isBefore(this.earliestPermissionDate)) {
                                    return this.$message.error('当前权限仅可查询近' + this.dataDays + '天数据,若需查询该日请向上级领导申请');
                                }
                            }

                            let startStr = dayjs(startDate).format('YYYY-MM-DD');
                            let endStr = dayjs(endDate).format('YYYY-MM-DD');
                            let diff = (dayjs(endStr) - dayjs(startStr)) / (1000 * 60 * 60 * 24);
                            let diffDateArr = [];
                            for (let i = 0; i <= diff; i++) {
                                diffDateArr.push(dayjs(startDate).add(i, 'day').format('YYYY-MM-DD'));
                            }
                            if (this.dateAllDisabled) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else if (diffDateArr.every(item => !this.hasCostDate.includes(item))) {
                                this.$message.error('所选筛选在该日期无任何数据');
                            } else {
                                setTimeout(() => {
                                    this.formItem.quick_date = '去年下半年';
                                }, 300);
                                picker.$emit('pick', [startStr, endStr]);
                            }
                        });

                        allDateOptions.onClick = picker=>{
                            if(this.isPlatAll){
                                this.formItem.quick_date='所有有数据日期';
                                /* 点击【所有数据日期】，更新disableDate时需要传quick_date参数 */
                                this.updateDisableDate('quick_date').then(()=>{
                                    picker.$emit('pick', [dayjs(this.startDate).format('YYYY-MM-DD'), dayjs(this.endDate).format('YYYY-MM-DD')]);
                                })
                            }else{
                                setTimeout(()=>{
                                    this.formItem.quick_date='所有有数据日期';
                                },300);
                                // 分时数据-快捷日期判断
                                if(this.isTimeFilter){
                                    let startHour = dayjs(this.startDate);
                                    let endHour = dayjs(this.endDate);
                                    let diffHour = endHour.diff(startHour,'day');
                                    if(diffHour>this.hourSearchDays){
                                        return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                    }
                                }
                                if(this.dateAllDisabled){
                                    this.$message.error('所选筛选在该日期无任何数据');
                                }else if(dayjs(this.startDate).isAfter(dayjs(this.endDate))){
                                    picker.$emit('pick', [dayjs(this.startDate).format('YYYY-MM-DD'), dayjs(this.startDate).format('YYYY-MM-DD')]);
                                }else{
                                    if(this.hasCostDate.length>0){
                                        let costDateStart = this.hasCostDate[0];
                                        if(dayjs(this.startDate).isAfter(dayjs(costDateStart))){
                                            picker.$emit('pick', [dayjs(costDateStart).format('YYYY-MM-DD'), dayjs(this.endDate).format('YYYY-MM-DD')]);
                                        }else{
                                            picker.$emit('pick', [dayjs(this.startDate).format('YYYY-MM-DD'), dayjs(this.endDate).format('YYYY-MM-DD')]);
                                        }
                                    }else{
                                        picker.$emit('pick', [dayjs(this.startDate).format('YYYY-MM-DD'), dayjs(this.endDate).format('YYYY-MM-DD')]);
                                    }
                                }
                            }
                        };

                        this.pageFunc = actionData.func || [];
                        this.conditionLoading = false;

                        /* 判断是否是复制Tab页面,如有本地存储数据就执行复制操作 */
                        let copyTabData = window.localStorage.getItem('copyTab');
                        if(copyTabData){
                            this.doCopyTab(JSON.parse(copyTabData));
                        }else{
                            /* 如果是复制Tab页就不用获取模板了  */
                            this.getDefaultTemplate();
                        }
                        window.localStorage.removeItem('copyTab');

                    }, (err) => {
                        console.log('getPageAllowAction error', err);

                        this.isPageAllowed = false;
                        this.fieldList = [];
                        this.dimensionList = [];
                        this.conditionLoading = false;
                        this.pageFunc = [];
                    });
                }else{
                    this.isPageAllowed = false;
                }
            },
            confirmCompareSumFields() {
                return new Promise((resolve, reject)=>{
                    if(this.disableDateLoading){
                        return reject();
                    }else if(this.isCompare===false){
                        /*先判断有没有累计字段或维度排序*/
                        let sumFieldList = this.fieldList.find(item=>item.name==this.platName+'_sum_data')||{};
                        let sumFieldNameList = (sumFieldList.children||[]).map(item=>item.name);

                        let checkedSumFields = this.formItem.field.filter(item=>{
                            return sumFieldNameList.includes(item.name);
                        });
                        let checkedSumDimensions = this.formItem.group.filter(item=>{
                            let dimensionValue = item.dimensionValue||{};
                            let orderBy = dimensionValue.order_by||'';
                            if(orderBy){
                                let fieldItem = this._findFieldByName(this.fieldList,orderBy);
                                if(fieldItem){
                                    return sumFieldNameList.includes(fieldItem.name);
                                }
                                return false;
                            }
                            return false;
                        });

                        if(checkedSumFields.length>0||checkedSumDimensions.length>0){
                            let htmlStr = '<div><p>累计数据指标暂不支持对比与对比时维度排序，是否继续？</p><p class="text-color-error text-bold">继续将删除不支持的数据指标（若应用了维度排序,则同时删除）！</p><div class="font12px mt8" style="max-height: 150px;overflow-y: auto;">';
                            if(checkedSumFields.length>0){
                                htmlStr += '<p class="mt10"><span class="text-bold">指标：</span>'+checkedSumFields.map(item=>item.display_name).join('、')+'<p>';
                            }
                            if(checkedSumDimensions.length>0){
                                let tipArr = checkedSumDimensions.map(item=>{
                                    let dimensionValue = item.dimensionValue||{};
                                    let orderBy = dimensionValue.order_by||'';
                                    let orderField = this._findFieldByName(this.fieldList,orderBy);
                                    if(orderBy&&orderField){
                                        return item.display_name+'(排序：'+orderField.display_name+')';
                                    }else{
                                        return item.display_name;
                                    }
                                });
                                htmlStr += '<p class="mt10"><span class="text-bold">维度：</span>'+tipArr.join('、')+'<p>';
                            }

                            htmlStr += '</div></div>';

                            this.$confirm(htmlStr,'提示',{
                                confirmButtonText: '继续',
                                cancelButtonText: '取消',
                                type: 'warning',
                                dangerouslyUseHTMLString: true,
                                customClass:'wide-confirm-box-550',
                            }).then(()=>{
                                console.log('继续');
                                checkedSumFields.forEach(sumField=>{
                                    this.removeField(sumField);
                                });
                                checkedSumDimensions.forEach(sumField=>{
                                    this.removeDimensionOrderField(sumField);
                                });
                                this.toggleIsCompare();
                                resolve();
                            }).catch(()=>{
                                reject();
                            })
                        }else{
                            this.toggleIsCompare();
                            resolve();
                        }
                    }else{
                        this.toggleIsCompare();
                        resolve();
                    }
                }).catch(()=>{
                    console.log('confirmCompareSumFields err');
                });
            },
            toggleIsCompare(){
                this.isCompare = !this.isCompare;
                if (this.isCompare) {
                    // this.formItem.compare_type = this.formItem.compare_type||'MoM';
                    this.formItem.compare_type = 'MoM';
                    this.setMoMDate();
                    this.checkCompareDateTip();
                }
            },
            getCycleDates(date,weekMode){
                // 解析输入日期，支持多种格式
                const currentDate = dayjs(date);
                // 获取当前日期的星期几（dayjs中0=周日，1=周一，...，6=周六）
                let dayOfWeek = currentDate.day();
                // 转换为1-7表示法（1=周一，7=周日）与参数统一
                dayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
                
                // 计算与周期起始日的差值
                let diffToStart;
                if (dayOfWeek >= weekMode) {
                    // 当前日期在起始日之后或当天
                    diffToStart = weekMode - dayOfWeek;
                } else {
                    // 当前日期在起始日之前，需要向前推到上一周
                    diffToStart = (weekMode - dayOfWeek) - 7;
                }
                
                // 计算周期开始日期（起始日）
                const startDate = currentDate.add(diffToStart, 'day');
                
                // 计算周期结束日期（起始日加6天）
                const endDate = startDate.add(6, 'day');
                
                return {
                    start: startDate.format('YYYY-MM-DD'),
                    end: endDate.format('YYYY-MM-DD'),
                    weekMode: weekMode,
                };
            },
            setMoMDate() {
                let baseDate = this.formItem.range_time;
                let dimensionDate = this.formItem.group.find(item => item.name == 'date');
                let dateSumType = dimensionDate && dimensionDate.dimensionValue.sum_type;
                let [baseDateStart, baseDateEnd] = baseDate;
                if (!dateSumType) {
                    let diff = dayjs(baseDateEnd).diff(baseDateStart, 'day') + 1;
                    this.formItem.range_time1 = [dayjs(baseDateStart).subtract(diff, 'day').format('YYYY-MM-DD'), dayjs(baseDateEnd).subtract(diff, 'day').format('YYYY-MM-DD')];
                } else if (dateSumType === 'day') {
                    this.formItem.range_time1 = [dayjs(baseDateStart).subtract(1, 'day').format('YYYY-MM-DD'), dayjs(baseDateEnd).subtract(1, 'day').format('YYYY-MM-DD')];
                } else if (dateSumType === 'week') {
                    let pageConfigWeekMode = this.pageConfig.data_query_analysis_week_mode;
                    let end = dayjs(baseDateEnd).subtract(1, 'week');
                    let start = dayjs(baseDateStart).subtract(1, 'week');
                    let endDayNum = end.get('day');     
                    let startDayNum = start.get('day'); 
                    if(pageConfigWeekMode&&pageConfigWeekMode!='1'){    // 配置的周模式：不为周一
                        let startDate = this.getCycleDates(start,pageConfigWeekMode).start;
                        let endDate = this.getCycleDates(end,pageConfigWeekMode).end;
                        this.formItem.range_time1 = [startDate, endDate];
                    }else{
                        let diffStart = startDayNum === 0 ? 6 : startDayNum - 1;
                        let diffEnd = endDayNum === 0 ? 0 : 7 - endDayNum;
                        this.formItem.range_time1 = [dayjs(start).subtract(diffStart, 'day').format('YYYY-MM-DD'), dayjs(end).add(diffEnd, 'day').format('YYYY-MM-DD')];
                    }
                } else if (dateSumType === 'month') {
                    let end = dayjs(baseDateEnd).endOf('month');
                    let start = dayjs(baseDateStart).startOf('month');
                    this.formItem.range_time1 = [dayjs(start).subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), dayjs(end).subtract(1, 'month').endOf('month').format('YYYY-MM-DD')];
                } else if (dateSumType === 'quarter') {
                    let end = dayjs(baseDateEnd).endOf('quarter');
                    let start = dayjs(baseDateStart).startOf('quarter');
                    this.formItem.range_time1 = [dayjs(start).subtract(1, 'quarter').startOf('quarter').format('YYYY-MM-DD'), dayjs(end).subtract(1, 'quarter').endOf('quarter').format('YYYY-MM-DD')];
                } else if (dateSumType === 'year') {
                    let end = dayjs(baseDateEnd).endOf('year');
                    let start = dayjs(baseDateStart).startOf('year');
                    this.formItem.range_time1 = [dayjs(start).subtract(1, 'year').startOf('year').format('YYYY-MM-DD'), dayjs(end).subtract(1, 'year').endOf('year').format('YYYY-MM-DD')];
                }

                let startTime = dayjs(this.formItem.range_time1[0]);
                let curStartDate = dayjs().subtract(this.dataDays,'day');
                if(this.dataDays>0&&startTime.isBefore(dayjs(curStartDate))){
                    this.$message.error('对比日期超出日期权限，请选择自定义对比日期');
                    this.formItem.compare_type = 'self';
                    this.formItem.range_time1 = [];
                    return false;
                }

            },
            setYoYDate() {
                let baseDate = this.formItem.range_time;
                let dimensionDate = this.formItem.group.find(item => item.name == 'date');
                let dateSumType = dimensionDate && dimensionDate.dimensionValue.sum_type;
                let [baseDateStart, baseDateEnd] = baseDate;
                let curStartDate = dayjs().subtract(this.dataDays,'day');
                if (dateSumType === 'month') {
                    let start = dayjs(baseDateStart).subtract(1, 'year').startOf('month');
                    let end = dayjs(baseDateEnd).subtract(1, 'year').endOf('month');

                    if(this.dataDays>0&&start.isBefore(dayjs(curStartDate))){
                        this.$message.error('对比日期超出日期权限，请选择自定义对比日期');
                        this.formItem.compare_type = 'self';
                        this.formItem.range_time1 = [];
                        return false;
                    }

                    this.formItem.range_time1 = [start.format('YYYY-MM-DD'),end.format('YYYY-MM-DD')];
                } else if (dateSumType === 'quarter') {
                    let start = dayjs(baseDateStart).subtract(1, 'year').startOf('quarter');
                    let end = dayjs(baseDateEnd).subtract(1, 'year').endOf('quarter');

                    if(this.dataDays>0&&start.isBefore(dayjs(curStartDate))){
                        this.$message.error('对比日期超出日期权限，请选择自定义对比日期');
                        this.formItem.compare_type = 'self';
                        this.formItem.range_time1 = [];
                        return false;
                    }
                    this.formItem.range_time1 = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
                } else {
                    this.formItem.range_time1 = [];
                    this.$message.error('当前汇总方式不可以进行同比');
                    this.formItem.compare_type = 'MoM';
                    this.setMoMDate();
                }
            },
            setSelfDate(){
                let rangeTime1 = this.formItem.range_time1||[];
                if(rangeTime1.length<=0) return;
                let startDate = dayjs(rangeTime1[0]);
                let baseDate = this.formItem.range_time;
                let diff = dayjs(baseDate[1]).diff(dayjs(baseDate[0]), 'day');
                this.formItem.range_time1 = [startDate.format('YYYY-MM-DD'), dayjs(startDate).add(diff, 'day').format('YYYY-MM-DD')];
            },
            changeRangeTime1(val) {
                let baseDate = this.formItem.range_time;
                let compDate = this.formItem.range_time1;
                let dimensionDate = this.formItem.group.find(item => item.name === 'date');
                let dateSumType = dimensionDate && dimensionDate.dimensionValue.sum_type;
                let [baseDateStart, baseDateEnd] = baseDate;
                let [compDateStart, compDateEnd] = compDate;
                if (['week', 'month', 'quarter', 'year'].includes(dateSumType) && this.formItem.data_display_type === 'sum_up') {
                    let diff = dayjs(baseDateEnd).diff(baseDateStart, 'day');
                    let compDiff = dayjs(compDateEnd).diff(compDateStart, 'day');
                    if (diff !== compDiff) {
                        this.$message({
                            duration: 15 * 1000,
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true,
                            message: '<p class="text-color-normal">您当前选择的对比日期为<span class="text-color-error">不完整日期对比</span>，建议您切换数据汇总方式为日均，进行日均数据对比。</p>'
                        });
                    }
                }
                this.checkCompareDateTip();
            },
            changeRangeTime(val) {
                let isCompareOver31day = false;
                let start = dayjs(this.formItem.range_time[0]);
                let end = dayjs(this.formItem.range_time[1]);
                let diff = end.diff(start,'day');
                if(this.isCompare){
                    let start1 = dayjs(this.formItem.range_time1[0]);
                    let end1 = dayjs(this.formItem.range_time1[1]);
                    let diff1 = end1.diff(start1,'day');
                    isCompareOver31day = diff1>this.hourSearchDays;
                }

                if(this.isTimeFilter&&(diff>this.hourSearchDays||isCompareOver31day)){
                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                }

                this.formItem.quick_date = '';
                if (!this.isCompare) return;
                if (this.formItem.compare_type === 'MoM') {
                    this.setMoMDate();
                } else if (this.formItem.compare_type === 'YoY') {
                    this.setYoYDate();
                } else {
                    this.formItem.range_time1 = [];
                }
                this.checkCompareDateTip();

            },
            changeCompareType(val) {
                if (val === 'YoY') {
                    this.setYoYDate();
                    this.checkCompareDateTip();
                } else if (val === 'MoM') {
                    this.setMoMDate();
                    this.checkCompareDateTip();
                } else {
                    this.formItem.range_time1 = [];
                }
            },
            checkCompareDateTip(){
                let dimensionDate = this.formItem.group.find(item=>item.name=='date');
                if(!dimensionDate) return;
                if(!this.isCompare) return;
                let dimValue = dimensionDate.dimensionValue||{};
                let sumType = dimValue.sum_type;
                let dataDisplayType = this.formItem.data_display_type;
                if(dataDisplayType!=='sum_up') return;
                if(!['week','month','quarter','year'].includes(sumType)) return;
                let rangeTime = this.formItem.range_time;
                let rangeTime1 = this.formItem.range_time1;
                if(rangeTime1.length<=0) return;

                let diffRangeTime = this.getDiffDates(rangeTime);
                let diffRangeTime1 = this.getDiffDates(rangeTime1);
                if(diffRangeTime!=diffRangeTime1){
                    // this.$refs.dateTips.show();
                    let htmlStr = `<p class="font14px mt10 mb10">您当前选择的对比日期为 <span class="text-color-error">不完整日期</span> 对比，建议您切换数据汇总方式为日均，进行日均数据对比。</p>`;
                    this.$notify({
                        duration: 1000*10,
                        dangerouslyUseHTMLString:true,
                        title: '提示',
                        message: htmlStr,
                        type: 'error',
                    });
                }
            },
            setCompareDate(){
                if(this.isCompare){
                    if(this.formItem.compare_type!='self'){
                        this.changeCompareType(this.formItem.compare_type);
                    }else{
                        this.setSelfDate();
                    }
                }
            },
            getDiffDates([start,end]){
                let startStr = dayjs(start).format('YYYY-MM-DD');
                let endStr = dayjs(end).format('YYYY-MM-DD');
                let diff = (dayjs(endStr) - dayjs(startStr))/(1000*60*60*24);
                let diffCount = 0;

                for(let i=0;i<=diff;i++){
                    let dateStr = dayjs(startStr).add(i,'day').format('YYYY-MM-DD');
                    if(!this.notHasCostDate.includes(dateStr)){
                        diffCount++;
                    }
                }
                return diffCount;
            },
            handleMenuClick(field) {
                // this.$set(field, 'checked', true);
                // 添加分时维度
                if(field.name == 'time_interval'){

                    this.confirmHourFields().then((res)=>{
                        let checkedNotHourFields = res[0]||[];
                        let checkedNotHourDimensions = res[1]||[];
                        checkedNotHourFields.forEach(hourField=>{
                            this.removeField(hourField);
                        });
                        checkedNotHourDimensions.forEach(hourDimension=>{
                            this.removeDimensionOrderField(hourDimension);
                        });

                        let isCompareOver31day = false;
                        let start = dayjs(this.formItem.range_time[0]);
                        let end = dayjs(this.formItem.range_time[1]);
                        let diff = end.diff(start,'day');
                        if(this.isCompare){
                            let start1 = dayjs(this.formItem.range_time1[0]);
                            let end1 = dayjs(this.formItem.range_time1[1]);
                            let diff1 = end1.diff(start1,'day');
                            isCompareOver31day = diff1>this.hourSearchDays;
                        }

                        if(diff>this.hourSearchDays||isCompareOver31day){
                            return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                        }

                        this.confirmPlatCostType().then(res=>{
                            console.log('confirmPlatCostType.then',res);
                            let conditionField = this._findFieldByName(this.conditionList,field.name);
                            this.showFilterModal(conditionField);
                        },err=>{
                            console.log('confirmPlatCostType.err',err);
                            this.changeCheckItem(field, false, 'condition');
                            field.checked = false;
                            return false;
                        });


                    },()=>{
                        this.changeCheckItem(field, false, 'condition');
                        field.checked = false;

                        return false;
                    });





                }else if(this.platId=='9'){
                    /* 关键词系列维度 与 广告维度  不能一起选择 */
                    let formGroup = this.formItem.group;
                    let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                    let groupStartDate = formGroup.find(item=>item.name=='start_date');
                    let groupYYType = formGroup.find(item=>item.name=='yy_type');
                    let isGroupYYTypeKeywords = (groupYYType?.dimensionValue?.yy_type_dimension||'') == 'keyword_yy_type';
                    let isGroupCreateDateKeywords = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'keyword_create_date';
                    let isGroupStartDateKeywords = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'keyword';
                    let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';
                    let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                    let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';

                    let formCondition = this.formItem.condition;
                    let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                    let conditionStartDate = formCondition.find(item=>item.name=='start_date');
                    let conditionYYType = formCondition.find(item=>item.name=='yy_type');
                    let isConditionYYTypeKeywords = (conditionYYType?.selectValue||'') == 'keyword_yy_type';
                    let isConditionCreateDateKeywords = (conditionCreateDate?.selectValue||'') == 'keyword_create_date';
                    let isConditionStartDateKeywords = (conditionStartDate?.selectValue||'') == 'keyword';
                    let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';
                    let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                    let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';

                    // 当前点击的是否是关键词 或 广告
                    let checkedKeywordsField = this.appleKeywordsFieldList.includes(field.name);
                    let checkedAdField = this.appleAdFieldList.includes(field.name);

                    if(checkedKeywordsField&&this.isAppleAdChecked){
                        // 当前是 关键字维度，找出广告相关维度和筛选
                        console.log('当前点击：关键词维度，是否删除广告？');

                        let groupAdList = [];
                        let conditionAdList = [];
                        formGroup.forEach(item=>{
                            if(this.appleAdFieldList.includes(item.name)){
                                groupAdList.push({...item});
                            }
                        });
                        formCondition.forEach(item=>{
                            if(this.appleAdFieldList.includes(item.name)){
                                conditionAdList.push({...item});
                            }
                        });


                        let groupTextList = groupAdList.map(item=>item.display_name);
                        let conditionTextList = conditionAdList.map(item=>item.display_name);
                        if(isGroupCreateDateAd){
                            groupTextList.push('创建日期(按广告)')
                        }
                        if(isGroupStartDateAd){
                            groupTextList.push('开投日期(按广告)')
                        }
                        if(isConditionCreateDateAd){
                            conditionTextList.push('创建日期(按广告)')
                        }
                        if(isConditionStartDateAd){
                            conditionTextList.push('开投日期(按广告)')
                        }

                        let baseSearchTermTextFields = ['impression_share','impression_rank','search_popularity'];
                        let formBaseSearchTermTextFields = this.formItem.field.filter(item=>baseSearchTermTextFields.includes(item.name));

                        let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                        let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                        let fieldText = formBaseSearchTermTextFields.length>0?`<p><span class="text-bold">指标：</span>${formBaseSearchTermTextFields.map(item=>item.display_name).join('、')}</p>`:'';

                        let htmlStr = `<div><p>${this.isAppleSearchTermChecked ?'搜索词':'关键词'}相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}${fieldText}</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBaseSearchTermTextFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });
                            if(isGroupCreateDateAd){
                                this.removeDimension(groupCreateDate)
                            }
                            if(isGroupStartDateAd){
                                this.removeDimension(groupStartDate)
                            }
                            if(isConditionCreateDateAd){
                                this.removeCondition(conditionCreateDate)
                            }
                            if(isConditionStartDateAd){
                                this.removeCondition(conditionStartDate)
                            }

                            groupAdList.forEach(item=>{
                                this.removeDimension(item);
                            });
                            conditionAdList.forEach(item=>{
                                this.removeCondition(item);
                            });

                            let conditionField = this._findFieldByName(this.conditionList,field.name);
                            this.showFilterModal(conditionField);

                        }).catch(()=>{
                            console.log('取消');
                        })

                    }else if(checkedAdField&&this.isAppleKeywordsChecked){
                        // 当前是 广告维度，找出关键词相关维度和筛选
                        console.log('当前点击：广告维度，是否删除关键词？');

                        let groupKeywordList = [];
                        let conditionKeywordList = [];
                        formGroup.forEach(item=>{
                            if(this.appleKeywordsFieldList.includes(item.name)){
                                groupKeywordList.push({...item});
                            }
                        });
                        formCondition.forEach(item=>{
                            if(this.appleKeywordsFieldList.includes(item.name)){
                                conditionKeywordList.push({...item});
                            }
                        });


                        let groupTextList = groupKeywordList.map(item=>item.display_name);
                        let conditionTextList = conditionKeywordList.map(item=>item.display_name);
                        if(isGroupYYTypeKeywords){
                            groupTextList.push('运营类型(关键词)')
                        }
                        if(isGroupCreateDateKeywords){
                            groupTextList.push('创建日期(关键词)')
                        }
                        if(isGroupStartDateKeywords){
                            groupTextList.push('开投日期(关键词)')
                        }
                        if(isGroupStartDateSearchTerm){
                            groupTextList.push('开投日期(搜索词)')
                        }

                        if(isConditionYYTypeKeywords){
                            conditionTextList.push('运营类型(关键词)')
                        }
                        if(isConditionCreateDateKeywords){
                            conditionTextList.push('创建日期(关键词)')
                        }
                        if(isConditionStartDateKeywords){
                            conditionTextList.push('开投日期(关键词)')
                        }
                        if(isConditionStartDateSearchTerm){
                            conditionTextList.push('开投日期(搜索词)')
                        }

                        let baseSearchTermTextFields = ['impression_share','impression_rank','search_popularity'];
                        let formBaseSearchTermTextFields = this.formItem.field.filter(item=>baseSearchTermTextFields.includes(item.name));
                        let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                        let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                        let fieldText = formBaseSearchTermTextFields.length>0?`<p><span class="text-bold">指标：</span>${formBaseSearchTermTextFields.map(item=>item.display_name).join('、')}</p>`:'';

                        let htmlStr = `<div><p>${this.isAppleSearchTermChecked ?'搜索词':'关键词'}相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}${fieldText}</div>`;
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBaseSearchTermTextFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });
                            if(isGroupYYTypeKeywords){
                                this.removeDimension(groupYYType)
                            }
                            if(isGroupCreateDateKeywords){
                                this.removeDimension(groupCreateDate)
                            }
                            if(isGroupStartDateKeywords||isGroupStartDateSearchTerm){
                                this.removeDimension(groupStartDate)
                            }
                            if(isConditionYYTypeKeywords){
                                this.removeCondition(conditionYYType)
                            }
                            if(isConditionCreateDateKeywords){
                                this.removeCondition(conditionCreateDate)
                            }
                            if(isConditionStartDateKeywords||isConditionStartDateSearchTerm){
                                this.removeCondition(conditionStartDate)
                            }

                            groupKeywordList.forEach(item=>{
                                this.removeDimension(item);
                            });
                            conditionKeywordList.forEach(item=>{
                                this.removeCondition(item);
                            });

                            let conditionField = this._findFieldByName(this.conditionList,field.name);
                            this.showFilterModal(conditionField);
                        }).catch(()=>{
                            console.log('取消');
                        })
                    }else{
                        let conditionField = this._findFieldByName(this.conditionList,field.name);
                        this.showFilterModal(conditionField);
                    }

                }else{
                    let conditionField = this._findFieldByName(this.conditionList,field.name);
                    this.showFilterModal(conditionField);
                }
            },
            handleDimensionMenuClick(field) {
                this.showDimensionModal(field);
            },
            checkAllFields(list){
                let children = list.children||[];
                if(this.isTimeFilter){
                    if(list.name=='vivo_data_company_info'||list.name=='oppo_data_company_info'||list.name=='honor_data_company_info'){
                        return this.$message.error('部分指标需要依赖某些维度，暂不支持全选，请手动逐个选择指标');
                    }
                    console.log('checkAllFields isTimeFilter',children);
                    children.forEach(item=>{
                        let fieldCon = item.config||{};
                        let isHourField = (fieldCon.time_type||[]).includes('hour');
                        if(isHourField){
                            // item.checked = true;
                            this.$set(item,'checked',true);
                            if(!this.formItem.field.includes(item)){
                                this.formItem.field.push(item);
                            }
                        }
                    });
                }else if(this.isCompare&&list.name==this.platName+'_sum_data'){
                    return this.$message.error('累计指标暂不支持对比与对比时维度排序');
                }else{
                    if(list.name=='vivo_data_company_info'||list.name=='oppo_data_company_info'||list.name=='honor_data_company_info'||list.name=='apple_sov_data'){
                        return this.$message.error('部分指标需要依赖某些维度，暂不支持全选，请手动逐个选择指标');
                    }else{
                        this._setListValue(children,'checked',true);
                        children.forEach(item=>{
                            if(!this.formItem.field.includes(item)){
                                this.formItem.field.push(item);
                            }
                        });
                    }
                }
            },
            clearAllFields(list){
                let children = list.children||[];

                if(this.isTimeFilter){
                    console.log('clearAllFields isTimeFilter',children);
                    children.forEach(item=>{
                        let fieldCon = item.config||{};
                        let isHourField = (fieldCon.time_type||[]).includes('hour');
                        if(isHourField){
                            // item.checked = false;
                            this.$set(item,'checked',false);
                            let index = this.formItem.field.findIndex(field=>item===field);
                            if(index>=0){
                                this.formItem.field.splice(index,1);
                            }
                        }
                    });

                }else{
                    this._setListValue(children,'checked',false);
                    children.forEach(item=>{
                        let index = this.formItem.field.findIndex(field=>item===field);
                        if(index>=0){
                            this.formItem.field.splice(index,1);
                        }
                    });
                }
            },
            filterActionDimensionCheck(field){
                this.$set(field, 'checked', true);
                this.changeCheckItem(field, true, 'group');
            },
            filterActionFieldCheck(field){
                this.$set(field, 'checked', true);
                this.changeCheckItem(field, true, 'field');
            },
            confirmPlatCostType(){
                let costFieldName = 'cost';
                if(this.platId=='9'){
                    costFieldName = 'local_spend';
                }else if(this.platId=='11'){
                    costFieldName = 'ad_billing';
                }


                /* OPPO&爱奇艺 规则一致 */
                return new Promise((resolve, reject)=>{
                    if(this.platId!='8'&&this.platId!='10'){
                        resolve();
                    }else if(this.formItem.cost_type==costFieldName){
                        resolve();
                    }else{
                        let otherTip = this.platId=='10'?'、赠送金、返利金消耗':'消耗';
                        console.log(otherTip, 'otherTip');
                        let htmlStr = `<div><p>分时段数据暂不支持现金、虚拟金${otherTip}的数据计算方式，需要切换为${this.platId=='10'?'花费':'总消耗'}并查看分时数据吗？</p></div>`;

                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            this.formItem.cost_type = costFieldName;
                            resolve();
                        }).catch(()=>{
                            console.log('取消');
                            reject();
                        });
                    }
                })
            },
            confirmHourFields(isAlert){
                return new Promise((resolve, reject)=>{
                    let checkedNotHourFields = this.formItem.field.filter(item=>{
                        let fieldCon = item.config||{};
                        return !(fieldCon.time_type||[]).includes('hour');
                    });
                    let checkedNotHourDimensions = this.formItem.group.filter(item=>{
                        let dimensionValue = item.dimensionValue||{};
                        let orderBy = dimensionValue.order_by||'';
                        if(orderBy){
                            let fieldItem = this._findFieldByName(this.fieldList,orderBy);
                            if(fieldItem){
                                let fieldCon = fieldItem.config||{};
                                return !(fieldCon.time_type||[]).includes('hour');
                            }
                            return false;
                        }
                        return false;
                    });

                    if(checkedNotHourFields.length>0||checkedNotHourDimensions.length>0){
                        let htmlStr = '<div><p>以下数据指标不支持分时段数据，是否继续？</p><p class="text-color-error text-bold">继续将删除不支持的数据指标（若应用了维度排序，则同时删除）！</p><div class="font12px mt8" style="max-height: 150px;overflow-y: auto;">';
                        if(isAlert){
                            htmlStr = '<div><p>以下数据指标不支持分时段数据</p><p class="text-color-error text-bold">不支持的数据指标将被删除（若应用了维度排序，则同时删除）！</p><div class="font12px mt8" style="max-height: 150px;overflow-y: auto;">';
                        }
                        if(checkedNotHourFields.length>0){
                            htmlStr += '<p class="mt10"><span class="text-bold">指标：</span>'+checkedNotHourFields.map(item=>item.display_name).join('、')+'<p>';
                        }
                        if(checkedNotHourDimensions.length>0){
                            let tipArr = checkedNotHourDimensions.map(item=>{
                                let dimensionValue = item.dimensionValue||{};
                                let orderBy = dimensionValue.order_by||'';
                                let orderField = this._findFieldByName(this.fieldList,orderBy);
                                if(orderBy&&orderField){
                                    return item.display_name+'(排序：'+orderField.display_name+')';
                                }else{
                                    return item.display_name;
                                }
                            });
                            htmlStr += '<p class="mt10"><span class="text-bold">维度：</span>'+tipArr.join('、')+'<p>';
                        }

                        htmlStr += '</div></div>';

                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: isAlert?'确定':'继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                            closeOnPressEscape:false,
                            closeOnClickModal:false,
                            showClose:!isAlert,
                            showCancelButton:!isAlert,
                        }).then(()=>{
                            console.log('继续');
                            resolve([checkedNotHourFields,checkedNotHourDimensions]);
                        }).catch(()=>{
                            console.log('取消');
                            reject();
                        })
                    }else if(this.platId=='9'){

                        /* 搜素词维度&搜索词筛选条件*/
                        let searchTermDimension = this.formItem.group.find(item=>item.name=='search_term_text');
                        let searchTermSourceDimension =  this.formItem.group.find(item=>item.name=='search_term_source');
                        let adIdDimension = this.formItem.group.find(item=>item.name=='ad_id');
                        let adNameDimension = this.formItem.group.find(item=>item.name=='ad_name');
                        let searchTermCondition = this.formItem.condition.find(item=>item.name=='search_term_text');
                        let searchTermSourceCondition =  this.formItem.condition.find(item=>item.name=='search_term_source');
                        let adIdCondition = this.formItem.condition.find(item=>item.name=='ad_id');
                        let adNameCondition = this.formItem.condition.find(item=>item.name=='ad_name');

                        let groupCreateDate = this.formItem.group.find(item=>item.name=='create_date');
                        let groupStartDate = this.formItem.group.find(item=>item.name=='start_date');
                        let groupYYType = this.formItem.group.find(item=>item.name=='yy_type');
                        let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                        let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';
                        let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';

                        let conditionCreateDate = this.formItem.condition.find(item=>item.name=='create_date');
                        let conditionStartDate = this.formItem.condition.find(item=>item.name=='start_date');
                        let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                        let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';
                        let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';

                        let isGroupHasAd = this.formItem.group.map(item=>item.name).some(item=>this.appleAdFieldList.includes(item));
                        let isConditionHasAd = this.formItem.condition.map(item=>item.name).some(item=>this.appleAdFieldList.includes(item));

                        let isAppleAdChecked = isGroupHasAd||isGroupCreateDateAd||isGroupStartDateAd||isConditionHasAd||isConditionCreateDateAd||isConditionStartDateAd;
                        let isAppleSearchTermChecked = isGroupStartDateSearchTerm||searchTermDimension||searchTermSourceDimension||searchTermCondition||searchTermSourceCondition||isConditionStartDateSearchTerm;





                        if(isAppleAdChecked||isAppleSearchTermChecked){
                            console.log('苹果，有搜索词');
                            let dimensionTipText = [];
                            let conditionTipText = [];
                            if(searchTermDimension){
                                dimensionTipText.push('搜索词');
                            }
                            if(searchTermSourceDimension){
                                dimensionTipText.push('匹配来源');
                            }
                            if(adIdDimension){
                                dimensionTipText.push('广告ID');
                            }
                            if(adNameDimension){
                                dimensionTipText.push('广告名称');
                            }
                            if(isGroupStartDateSearchTerm){
                                dimensionTipText.push('开投日期(按搜索词)');
                            }
                            if(isGroupStartDateAd){
                                dimensionTipText.push('开投日期(按广告)');
                            }
                            if(isGroupCreateDateAd){
                                dimensionTipText.push('创建日期(按广告)');
                            }
                            if(searchTermCondition){
                                conditionTipText.push('搜索词');
                            }
                            if(searchTermSourceCondition){
                                conditionTipText.push('匹配来源');
                            }
                            if(adIdCondition){
                                conditionTipText.push('广告ID');
                            }
                            if(adNameCondition){
                                conditionTipText.push('广告名称');
                            }
                            if(isConditionCreateDateAd){
                                conditionTipText.push('创建日期(按广告)');
                            }
                            if(isConditionStartDateAd){
                                conditionTipText.push('开投日期(按广告)');
                            }
                            if(isConditionStartDateSearchTerm){
                                conditionTipText.push('开投日期(按搜索词)');
                            }

                            let groupText = dimensionTipText.length>0?`<p><span class="text-bold">维度：</span>${dimensionTipText.join('、')}</p>`:'';
                            let conditionText = conditionTipText.length>0?`<p><span class="text-bold">筛选：</span>${conditionTipText.join('、')}</p>`:'';

                            let htmlStr = `<div><p>以下维度或筛选暂不支持分时段数据，是否继续？</p><p class="text-color-error text-bold">继续将删除以下维度或筛选！</p>${groupText}${conditionText}</div>`;
                            this.$confirm(htmlStr,'提示',{
                                confirmButtonText: '继续',
                                cancelButtonText: '取消',
                                type: 'warning',
                                dangerouslyUseHTMLString: true,
                                customClass:'wide-confirm-box-550',
                            }).then(()=>{
                                console.log('继续');
                                if(searchTermDimension){
                                    this.removeDimensionItem(searchTermDimension);
                                }
                                if(searchTermSourceDimension){
                                    this.removeDimensionItem(searchTermSourceDimension);
                                }
                                if(adIdDimension){
                                    this.removeDimensionItem(adIdDimension);
                                }
                                if(adNameDimension){
                                    this.removeDimensionItem(adNameDimension);
                                }
                                if(isGroupStartDateSearchTerm||isGroupStartDateAd){
                                    this.removeDimensionItem(groupStartDate);
                                }
                                if(isGroupCreateDateAd){
                                    this.removeDimensionItem(groupCreateDate);
                                }


                                if(searchTermCondition){
                                    this.removeCondition(searchTermCondition);
                                }
                                if(searchTermSourceCondition){
                                    this.removeCondition(searchTermSourceCondition);
                                }
                                if(adIdCondition){
                                    this.removeCondition(adIdCondition);
                                }
                                if(adNameCondition){
                                    this.removeCondition(adNameCondition);
                                }
                                if(isConditionCreateDateAd){
                                    this.removeCondition(conditionCreateDate);
                                }
                                if(isConditionStartDateAd||isConditionStartDateSearchTerm){
                                    this.removeCondition(conditionStartDate);
                                }
                                resolve([[],[]]);
                            }).catch(()=>{
                                console.log('取消');
                                reject();
                            })
                        }else{
                            resolve([[],[]]);
                        }
                    }else{
                        resolve([[],[]]);
                    }
                })
            },
            changeCheckItem(field, val, type) {
                console.log('changeCheckItem',field, val, type);
                let index = this.formItem[type].findIndex(item => item.id == field.id);
                if (val) {
                    if (index == '-1') {
                        if (type == 'condition') {
                            this.showFilterModal(field);
                        } else if (type == 'group') {
                            // 添加分时维度
                            if(field.name == 'time_interval'){
                                let start = dayjs(this.formItem.range_time[0]);
                                let end = dayjs(this.formItem.range_time[1]);
                                let diff = end.diff(start,'day');

                                let isCompareOver31day = false;
                                if(this.isCompare){
                                    let start1 = dayjs(this.formItem.range_time1[0]);
                                    let end1 = dayjs(this.formItem.range_time1[1]);
                                    let diff1 = end1.diff(start1,'day');
                                    isCompareOver31day = diff1>this.hourSearchDays;
                                }

                                if(diff>this.hourSearchDays||isCompareOver31day){
                                    field.checked = false;
                                    return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                                }

                                /* 搜素词维度&搜索词筛选条件*/
                                let searchTermDimension = this.formItem.group.find(item=>item.name=='search_term_text');
                                let searchTermSourceDimension =  this.formItem.group.find(item=>item.name=='search_term_source');
                                let adIdDimension = this.formItem.group.find(item=>item.name=='ad_id');
                                let adNameDimension = this.formItem.group.find(item=>item.name=='ad_name');
                                let searchTermCondition = this.formItem.condition.find(item=>item.name=='search_term_text');
                                let searchTermSourceCondition =  this.formItem.condition.find(item=>item.name=='search_term_source');
                                let adIdCondition = this.formItem.condition.find(item=>item.name=='ad_id');
                                let adNameCondition = this.formItem.condition.find(item=>item.name=='ad_name');

                                let groupCreateDate = this.formItem.group.find(item=>item.name=='create_date');
                                let groupStartDate = this.formItem.group.find(item=>item.name=='start_date');
                                let groupYYType = this.formItem.group.find(item=>item.name=='yy_type');
                                let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                                let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';
                                let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';

                                let conditionCreateDate = this.formItem.condition.find(item=>item.name=='create_date');
                                let conditionStartDate = this.formItem.condition.find(item=>item.name=='start_date');
                                let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                                let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';
                                let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';

                                let isGroupHasAd = this.formItem.group.map(item=>item.name).some(item=>this.appleAdFieldList.includes(item));
                                let isConditionHasAd = this.formItem.condition.map(item=>item.name).some(item=>this.appleAdFieldList.includes(item));

                                let isAppleAdChecked = isGroupHasAd||isGroupCreateDateAd||isGroupStartDateAd||isConditionHasAd||isConditionCreateDateAd||isConditionStartDateAd;
                                let isAppleSearchTermChecked = isGroupStartDateSearchTerm||searchTermDimension||searchTermSourceDimension||searchTermCondition||searchTermSourceCondition||isConditionStartDateSearchTerm;

                                if(this.platId=='9'&&(isAppleAdChecked||isAppleSearchTermChecked)){
                                    console.log('苹果，有搜索词');
                                    let dimensionTipText = [];
                                    let conditionTipText = [];
                                    if(searchTermDimension){
                                        dimensionTipText.push('搜索词');
                                    }
                                    if(searchTermSourceDimension){
                                        dimensionTipText.push('匹配来源');
                                    }
                                    if(adIdDimension){
                                        dimensionTipText.push('广告ID');
                                    }
                                    if(adNameDimension){
                                        dimensionTipText.push('广告名称');
                                    }
                                    if(isGroupStartDateSearchTerm){
                                        dimensionTipText.push('开投日期(按搜索词)');
                                    }
                                    if(isGroupStartDateAd){
                                        dimensionTipText.push('开投日期(按广告)');
                                    }
                                    if(isGroupCreateDateAd){
                                        dimensionTipText.push('创建日期(按广告)');
                                    }
                                    if(searchTermCondition){
                                        conditionTipText.push('搜索词');
                                    }
                                    if(searchTermSourceCondition){
                                        conditionTipText.push('匹配来源');
                                    }
                                    if(adIdCondition){
                                        conditionTipText.push('广告ID');
                                    }
                                    if(adNameCondition){
                                        conditionTipText.push('广告名称');
                                    }
                                    if(isConditionCreateDateAd){
                                        conditionTipText.push('创建日期(按广告)');
                                    }
                                    if(isConditionStartDateAd){
                                        conditionTipText.push('开投日期(按广告)');
                                    }
                                    if(isConditionStartDateSearchTerm){
                                        conditionTipText.push('开投日期(按搜索词)');
                                    }

                                    let groupText = dimensionTipText.length>0?`<p><span class="text-bold">维度：</span>${dimensionTipText.join('、')}</p>`:'';
                                    let conditionText = conditionTipText.length>0?`<p><span class="text-bold">筛选：</span>${conditionTipText.join('、')}</p>`:'';

                                    let htmlStr = `<div><p>以下维度或筛选暂不支持分时段数据，是否继续？</p><p class="text-color-error text-bold">继续将删除以下维度或筛选！</p>${groupText}${conditionText}</div>`;
                                    this.$confirm(htmlStr,'提示',{
                                        confirmButtonText: '继续',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        if(searchTermDimension){
                                            this.removeDimensionItem(searchTermDimension);
                                        }
                                        if(searchTermSourceDimension){
                                            this.removeDimensionItem(searchTermSourceDimension);
                                        }
                                        if(adIdDimension){
                                            this.removeDimensionItem(adIdDimension);
                                        }
                                        if(adNameDimension){
                                            this.removeDimensionItem(adNameDimension);
                                        }
                                        if(isGroupStartDateSearchTerm||isGroupStartDateAd){
                                            this.removeDimensionItem(groupStartDate);
                                        }
                                        if(isGroupCreateDateAd){
                                            this.removeDimensionItem(groupCreateDate);
                                        }


                                        if(searchTermCondition){
                                            this.removeCondition(searchTermCondition);
                                        }
                                        if(searchTermSourceCondition){
                                            this.removeCondition(searchTermSourceCondition);
                                        }
                                        if(adIdCondition){
                                            this.removeCondition(adIdCondition);
                                        }
                                        if(adNameCondition){
                                            this.removeCondition(adNameCondition);
                                        }
                                        if(isConditionCreateDateAd){
                                            this.removeCondition(conditionCreateDate);
                                        }
                                        if(isConditionStartDateAd||isConditionStartDateSearchTerm){
                                            this.removeCondition(conditionStartDate);
                                        }

                                        this.confirmHourFields(isAppleSearchTermChecked).then((res)=>{
                                            let checkedNotHourFields = res[0]||[];
                                            let checkedNotHourDimensions = res[1]||[];
                                            checkedNotHourFields.forEach(hourField=>{
                                                this.removeField(hourField);
                                            });
                                            checkedNotHourDimensions.forEach(hourDimension=>{
                                                this.removeDimensionOrderField(hourDimension);
                                            });

                                            this.confirmPlatCostType().then(res=>{
                                                console.log('confirmPlatCostType.then',res);
                                                this.updateDisableDate();

                                            },err=>{
                                                console.log('confirmPlatCostType.err',err);
                                                this.changeCheckItem(field, false, type);
                                                field.checked = false;
                                            });


                                        },()=>{
                                            console.log('confirmHourFields err');
                                            this.changeCheckItem(field, false, type);
                                            field.checked = false;
                                        }).catch(err=>{
                                            console.log('confirmHourFields catch',err);
                                            this.changeCheckItem(field, false, type);
                                            field.checked = false;
                                        })
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.removeDimensionItem(field);
                                    })
                                }else{
                                    this.confirmHourFields().then((res)=>{
                                        let checkedNotHourFields = res[0]||[];
                                        let checkedNotHourDimensions = res[1]||[];
                                        checkedNotHourFields.forEach(hourField=>{
                                            this.removeField(hourField);
                                        });
                                        checkedNotHourDimensions.forEach(hourDimension=>{
                                            this.removeDimensionOrderField(hourDimension);
                                        });

                                        this.confirmPlatCostType().then(res=>{
                                            console.log('confirmPlatCostType.then',res);
                                            this.updateDisableDate();

                                        },err=>{
                                            console.log('confirmPlatCostType.err',err);
                                            this.changeCheckItem(field, false, type);
                                            field.checked = false;
                                        });


                                    },()=>{
                                        console.log('confirmHourFields err');
                                        this.changeCheckItem(field, false, type);
                                        field.checked = false;
                                    }).catch(err=>{
                                        console.log('confirmHourFields catch',err);
                                        this.changeCheckItem(field, false, type);
                                        field.checked = false;
                                    })
                                }
                            }


                            if(this.platId == '9'){
                                /* 关键词系列维度 与 广告维度  不能一起选择 */
                                let formGroup = this.formItem.group;
                                let groupCreateDate = formGroup.find(item=>item.name=='create_date');
                                let groupStartDate = formGroup.find(item=>item.name=='start_date');
                                let groupYYType = formGroup.find(item=>item.name=='yy_type');
                                let isGroupYYTypeKeywords = (groupYYType?.dimensionValue?.yy_type_dimension||'') == 'keyword_yy_type';
                                let isGroupCreateDateKeywords = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'keyword_create_date';
                                let isGroupStartDateKeywords = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'keyword';
                                let isGroupStartDateSearchTerm = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'search_term';
                                let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                                let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';

                                let formCondition = this.formItem.condition;
                                let conditionCreateDate = formCondition.find(item=>item.name=='create_date');
                                let conditionStartDate = formCondition.find(item=>item.name=='start_date');
                                let conditionYYType = formCondition.find(item=>item.name=='yy_type');
                                let isConditionYYTypeKeywords = (conditionYYType?.selectValue||'') == 'keyword_yy_type';
                                let isConditionCreateDateKeywords = (conditionCreateDate?.selectValue||'') == 'keyword_create_date';
                                let isConditionStartDateKeywords = (conditionStartDate?.selectValue||'') == 'keyword';
                                let isConditionStartDateSearchTerm = (conditionStartDate?.selectValue||'') == 'search_term';
                                let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                                let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';

                                // 当前选中的是否是关键词 或 广告
                                let checkedKeywordsField = this.appleKeywordsFieldList.includes(field.name);
                                let checkedAdField = this.appleAdFieldList.includes(field.name);

                                if(checkedKeywordsField&&(isGroupCreateDateAd||isGroupStartDateAd||isConditionCreateDateAd||isConditionStartDateAd||this.isAppleAdChecked)){
                                    // 当前是 关键字维度，找出广告相关维度和筛选
                                    console.log('当前选择：关键词维度，是否删除广告？');

                                    let groupAdList = [];
                                    let conditionAdList = [];
                                    formGroup.forEach(item=>{
                                        if(this.appleAdFieldList.includes(item.name)){
                                            groupAdList.push({...item});
                                        }
                                    });
                                    formCondition.forEach(item=>{
                                        if(this.appleAdFieldList.includes(item.name)){
                                            conditionAdList.push({...item});
                                        }
                                    });


                                    let groupTextList = groupAdList.map(item=>item.display_name);
                                    let conditionTextList = conditionAdList.map(item=>item.display_name);
                                    if(isGroupCreateDateAd){
                                        groupTextList.push('创建日期(按广告)')
                                    }
                                    if(isGroupStartDateAd){
                                        groupTextList.push('开投日期(按广告)')
                                    }
                                    if(isConditionCreateDateAd){
                                        conditionTextList.push('创建日期(按广告)')
                                    }
                                    if(isConditionStartDateAd){
                                        conditionTextList.push('开投日期(按广告)')
                                    }

                                    let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                                    let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';

                                    let htmlStr = `<div><p>${this.isAppleSearchTermChecked ?'搜索词':'关键词'}相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}</div>`;
                                    this.$confirm(htmlStr,'提示',{
                                        confirmButtonText: '继续',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        if(isGroupCreateDateAd){
                                            this.removeDimension(groupCreateDate)
                                        }
                                        if(isGroupStartDateAd){
                                            this.removeDimension(groupStartDate)
                                        }
                                        if(isConditionCreateDateAd){
                                            this.removeCondition(conditionCreateDate)
                                        }
                                        if(isConditionStartDateAd){
                                            this.removeCondition(conditionStartDate)
                                        }

                                        groupAdList.forEach(item=>{
                                            this.removeDimension(item);
                                        });
                                        conditionAdList.forEach(item=>{
                                            this.removeCondition(item);
                                        })
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.removeDimensionItem(field);
                                    })


                                }

                                if(checkedAdField&&(this.isAppleKeywordsChecked||isGroupYYTypeKeywords||isGroupCreateDateKeywords||isGroupStartDateKeywords||isConditionYYTypeKeywords||isConditionCreateDateKeywords||isConditionStartDateKeywords||isConditionStartDateSearchTerm)){
                                    // 当前是 广告维度，找出关键词相关维度和筛选
                                    console.log('当前选择：广告维度，是否删除关键词？');

                                    let groupKeywordList = [];
                                    let conditionKeywordList = [];
                                    formGroup.forEach(item=>{
                                        if(this.appleKeywordsFieldList.includes(item.name)){
                                            groupKeywordList.push({...item});
                                        }
                                    });
                                    formCondition.forEach(item=>{
                                        if(this.appleKeywordsFieldList.includes(item.name)){
                                            conditionKeywordList.push({...item});
                                        }
                                    });


                                    let groupTextList = groupKeywordList.map(item=>item.display_name);
                                    let conditionTextList = conditionKeywordList.map(item=>item.display_name);
                                    if(isGroupYYTypeKeywords){
                                        groupTextList.push('运营类型(关键词)')
                                    }
                                    if(isGroupCreateDateKeywords){
                                        groupTextList.push('创建日期(关键词)')
                                    }
                                    if(isGroupStartDateKeywords){
                                        groupTextList.push('开投日期(关键词)')
                                    }
                                    if(isGroupStartDateSearchTerm){
                                        groupTextList.push('开投日期(搜索词)')
                                    }

                                    if(isConditionYYTypeKeywords){
                                        conditionTextList.push('运营类型(关键词)')
                                    }
                                    if(isConditionCreateDateKeywords){
                                        conditionTextList.push('创建日期(关键词)')
                                    }
                                    if(isConditionStartDateKeywords){
                                        conditionTextList.push('开投日期(关键词)')
                                    }
                                    if(isConditionStartDateSearchTerm){
                                        conditionTextList.push('开投日期(搜索词)')
                                    }

                                    let baseSearchTermTextFields = ['impression_share','impression_rank','search_popularity'];
                                    let formBaseSearchTermTextFields = this.formItem.field.filter(item=>baseSearchTermTextFields.includes(item.name));

                                    let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                                    let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';
                                    let fieldText = formBaseSearchTermTextFields.length>0?`<p><span class="text-bold">指标：</span>${formBaseSearchTermTextFields.map(item=>item.display_name).join('、')}</p>`:'';

                                    let htmlStr = `<div><p>${this.isAppleSearchTermChecked ?'搜索词':'关键词'}相关维度与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}${fieldText}</div>`;
                                    this.$confirm(htmlStr,'提示',{
                                        confirmButtonText: '继续',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        formBaseSearchTermTextFields.forEach(inner=>{
                                            this.$set(inner,'checked',false);
                                            this.removeField(inner);
                                        });
                                        if(isGroupYYTypeKeywords){
                                            this.removeDimension(groupYYType)
                                        }
                                        if(isGroupCreateDateKeywords){
                                            this.removeDimension(groupCreateDate)
                                        }
                                        if(isGroupStartDateKeywords||isGroupStartDateSearchTerm){
                                            this.removeDimension(groupStartDate)
                                        }
                                        if(isConditionYYTypeKeywords){
                                            this.removeCondition(conditionYYType)
                                        }
                                        if(isConditionCreateDateKeywords){
                                            this.removeCondition(conditionCreateDate)
                                        }
                                        if(isConditionStartDateKeywords||isConditionStartDateSearchTerm){
                                            this.removeCondition(conditionStartDate)
                                        }

                                        groupKeywordList.forEach(item=>{
                                            this.removeDimension(item);
                                        });
                                        conditionKeywordList.forEach(item=>{
                                            this.removeCondition(item);
                                        });
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.removeDimensionItem(field);
                                    })
                                }
                            }


                            field.dimensionValue = {
                                sum_type: field.name == 'date' ? 'day' : '',
                                start_date_dimension: field.name == 'start_date' ? (this.isPlatAll||this.platId=='10'||this.platId=='11'?'subproject_name': this.platId=='12'?'account_name': 'app_name')  : '',     // 开投日期默认维度：按产品
                                create_date_dimension: field.name == 'create_date' ? ((this.platId=='9' || this.platId=='12')?'plan_create_date':'account_create_time') : '',
                                yy_type_dimension: field.name == 'yy_type' ? 'account_yy_type' : '',       // 运营类型默认维度：按账户
                                order_by: field.name=='time_interval'?'time_interval':field.name=='date'?'date':'',
                                order_type: 'desc',
                                show_type: '1',
                                show_num: null,
                            };
                            this.$set(field, 'subText', this.getDimensionSubText(field));
                            this.formItem[type].push(field);
                            if(field.name == 'date'&&this.isCompare){
                                if(this.formItem.compare_type!='self'){
                                    this.setMoMDate();
                                }else{
                                    this.setSelfDate();
                                }
                            }

                        } else {
                            /* 选中的是指标 */
                            let isHasDateDimension =  this.formItem.group.find(item=>item.name=='date');
                            let dateDimension =  this._findFieldByName(this.dimensionList,'date');
                            let formGroupName = this.formItem.group.map(item=>item.name);

                            // 有效预算&有效预算利用率
                            if(field.name=='effective_budget'||field.name=='effective_budget_rate'){
                                let isHasCondition = this.formItem.condition.map(item=>item.name).includes('time_interval');
                                let isHasGroup = this.formItem.group.map(item=>item.name).includes('time_interval');

                                let timeIntervalDimension =  this._findFieldByName(this.dimensionList,'time_interval');

                                if(isHasCondition&&!isHasGroup){
                                    this.$confirm('有效预算指标分时数据需按时段展开观测，需要帮您选择【数据时段】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        timeIntervalDimension.dimensionValue = {
                                            sum_type: '' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'time_interval',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(timeIntervalDimension, 'subText', this.getDimensionSubText(timeIntervalDimension));

                                        this.formItem[type].push(field);
                                        this.formItem.group.push(timeIntervalDimension);
                                        this.changeCheckItem(timeIntervalDimension, true, 'group')
                                        this.$set(timeIntervalDimension,'checked',true);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else{
                                    this.formItem[type].push(field);
                                }
                            }else if(['account_balance','account_cash_balance','account_vir_balance','account_daily_budget','account_day_budget'].includes(field.name)){
                                // 账户总余额、账户现金余额、账户虚拟金余额、账户日预算
                                let isHasAccountDimension = formGroupName.includes('account_id')||formGroupName.includes('account_name');
                                let accountIdDimension = this._findFieldByName(this.dimensionList,'account_id');
                                let accountNameDimension = this._findFieldByName(this.dimensionList,'account_name');
                                if(!isHasDateDimension&&!isHasAccountDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【账户】与【数据日期】维度展开观测，需要帮您选择【账户】与【数据日期】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        dateDimension.dimensionValue = {
                                            sum_type: 'day' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'date',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                        this.formItem.group.push(dateDimension);
                                        this.changeCheckItem(dateDimension, true, 'group');
                                        this.$set(dateDimension,'checked',true);

                                        this.formItem.group.push(accountIdDimension);
                                        this.changeCheckItem(accountIdDimension, true, 'group');
                                        this.$set(accountIdDimension,'checked',true);

                                        this.formItem.group.push(accountNameDimension);
                                        this.changeCheckItem(accountNameDimension, true, 'group');
                                        this.$set(accountNameDimension,'checked',true);

                                        this.formItem[type].push(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else if(!isHasDateDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【账户】与【数据日期】维度展开观测，需要帮您选择【数据日期】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续',dateDimension);
                                        dateDimension.dimensionValue = {
                                            sum_type: 'day' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'date',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                        this.formItem[type].push(field);
                                        this.formItem.group.push(dateDimension);
                                        this.changeCheckItem(dateDimension, true, 'group');
                                        this.$set(dateDimension,'checked',true);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else if(!isHasAccountDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【账户】与【数据日期】维度展开观测，需要帮您选择【账户名称】与【账户ID】吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        this.formItem.group.push(accountIdDimension);
                                        this.changeCheckItem(accountIdDimension, true, 'group');
                                        this.$set(accountIdDimension,'checked',true);
                                        this.formItem.group.push(accountNameDimension);
                                        this.changeCheckItem(accountNameDimension, true, 'group');
                                        this.$set(accountNameDimension,'checked',true);

                                        this.formItem[type].push(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else{
                                    this.formItem[type].push(field);
                                }
                            }else if(['plan_daily_budget','campaign_day_budget'].includes(field.name)){
                                // 计划预算
                                let isHasPlanDimension = formGroupName.includes('plan_id')||formGroupName.includes('plan_name');
                                let planIdDimension = this._findFieldByName(this.dimensionList,'plan_id');
                                let planNameDimension = this._findFieldByName(this.dimensionList,'plan_name');

                                if(this.platId=='11'){
                                    isHasPlanDimension = formGroupName.includes('campaign_id')||formGroupName.includes('campaign_name');
                                    planIdDimension = this._findFieldByName(this.dimensionList,'campaign_id');
                                    planNameDimension = this._findFieldByName(this.dimensionList,'campaign_name');
                                }
                                if(this.platId=='11'){
                                    isHasPlanDimension = formGroupName.includes('campaign_id')||formGroupName.includes('campaign_name');
                                    planIdDimension = this._findFieldByName(this.dimensionList,'campaign_id');
                                    planNameDimension = this._findFieldByName(this.dimensionList,'campaign_name');
                                }


                                if(!isHasDateDimension&&!isHasPlanDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【计划】与【数据日期】维度展开观测，需要帮您选择【计划】与【数据日期】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        dateDimension.dimensionValue = {
                                            sum_type: 'day' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'date',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                        this.formItem.group.push(dateDimension);
                                        this.changeCheckItem(dateDimension, true, 'group');
                                        this.$set(dateDimension,'checked',true);

                                        this.formItem.group.push(planIdDimension);
                                        this.changeCheckItem(planIdDimension, true, 'group');
                                        this.$set(planIdDimension,'checked',true);

                                        this.formItem.group.push(planNameDimension);
                                        this.changeCheckItem(planNameDimension, true, 'group');
                                        this.$set(planNameDimension,'checked',true);

                                        this.formItem[type].push(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else if(!isHasDateDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【计划】与【数据日期】维度展开观测，需要帮您选择【数据日期】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续',dateDimension);
                                        dateDimension.dimensionValue = {
                                            sum_type: 'day' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'date',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                        this.formItem[type].push(field);
                                        this.formItem.group.push(dateDimension);
                                        this.changeCheckItem(dateDimension, true, 'group');
                                        this.$set(dateDimension,'checked',true);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else if(!isHasPlanDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【计划】与【数据日期】维度展开观测，需要帮您选择【计划名称】与【计划ID】吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        this.formItem.group.push(planIdDimension);
                                        this.changeCheckItem(planIdDimension, true, 'group');
                                        this.$set(planIdDimension,'checked',true);
                                        this.formItem.group.push(planNameDimension);
                                        this.changeCheckItem(planNameDimension, true, 'group');
                                        this.$set(planNameDimension,'checked',true);

                                        this.formItem[type].push(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else{
                                    this.formItem[type].push(field);
                                }
                            }else if(['adgroup_daily_budget','adgroup_day_budget'].includes(field.name)){
                                // 组预算
                                let isHasAdGroupDimension = formGroupName.includes('adgroup_id')||formGroupName.includes('adgroup_name');
                                let adGroupIdDimension = this._findFieldByName(this.dimensionList,'adgroup_id');
                                let adGroupNameDimension = this._findFieldByName(this.dimensionList,'adgroup_name');

                                if(!isHasDateDimension&&!isHasAdGroupDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【广告组】与【数据日期】维度展开观测，需要帮您选择【广告组】与【数据日期】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        dateDimension.dimensionValue = {
                                            sum_type: 'day' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'date',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                        this.formItem.group.push(dateDimension);
                                        this.changeCheckItem(dateDimension, true, 'group');
                                        this.$set(dateDimension,'checked',true);

                                        this.formItem.group.push(adGroupIdDimension);
                                        this.changeCheckItem(adGroupIdDimension, true, 'group');
                                        this.$set(adGroupIdDimension,'checked',true);

                                        this.formItem.group.push(adGroupNameDimension);
                                        this.changeCheckItem(adGroupNameDimension, true, 'group');
                                        this.$set(adGroupNameDimension,'checked',true);

                                        this.formItem[type].push(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else if(!isHasDateDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【广告组】与【数据日期】维度展开观测，需要帮您选择【数据日期】维度吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续',dateDimension);
                                        dateDimension.dimensionValue = {
                                            sum_type: 'day' ,
                                            start_date_dimension: '',
                                            create_date_dimension: '',
                                            yy_type_dimension: '',
                                            order_by: 'date',
                                            order_type: 'desc',
                                            show_type: '1',
                                            show_num: null,
                                        };
                                        this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                        this.formItem[type].push(field);
                                        this.formItem.group.push(dateDimension);
                                        this.changeCheckItem(dateDimension, true, 'group');
                                        this.$set(dateDimension,'checked',true);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else if(!isHasAdGroupDimension){
                                    this.$confirm('【'+field.display_name+'】指标需按【广告组】与【数据日期】维度展开观测，需要帮您选择【广告组名称】与【广告组ID】吗？','提示',{
                                        confirmButtonText: '选择',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        this.formItem.group.push(adGroupIdDimension);
                                        this.changeCheckItem(adGroupIdDimension, true, 'group');
                                        this.$set(adGroupIdDimension,'checked',true);
                                        this.formItem.group.push(adGroupNameDimension);
                                        this.changeCheckItem(adGroupNameDimension, true, 'group');
                                        this.$set(adGroupNameDimension,'checked',true);

                                        this.formItem[type].push(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                }else{
                                    this.formItem[type].push(field);
                                }
                            }else if(this.platId=='9'&&['impression_share','impression_rank','search_popularity'].includes(field.name)) {
                                /* 苹果渠道选中的是指标：展示次数份额、排名、搜索热度，要求：维度勾选搜索词、数据日期(天） */

                                /* 已经选择了广告相关维度 */
                                if(this.isAppleAdChecked){
                                    let formGroup = this.formItem.group;
                                    let formCondition = this.formItem.condition;
                                    let groupAdList = [];
                                    let conditionAdList = [];
                                    formGroup.forEach(item=>{
                                        if(this.appleAdFieldList.includes(item.name)){
                                            groupAdList.push({...item});
                                        }
                                    });
                                    formCondition.forEach(item=>{
                                        if(this.appleAdFieldList.includes(item.name)){
                                            conditionAdList.push({...item});
                                        }
                                    });


                                    let groupCreateDate = this.formItem.group.find(item=>item.name=='create_date');
                                    let groupStartDate = this.formItem.group.find(item=>item.name=='start_date');
                                    let isGroupCreateDateAd = (groupCreateDate?.dimensionValue?.create_date_dimension||'') == 'ad_create_date';
                                    let isGroupStartDateAd = (groupStartDate?.dimensionValue?.start_date_dimension||'') == 'ad_name';

                                    let conditionCreateDate = this.formItem.condition.find(item=>item.name=='create_date');
                                    let conditionStartDate = this.formItem.condition.find(item=>item.name=='start_date');
                                    let isConditionCreateDateAd = (conditionCreateDate?.selectValue||'') == 'ad_create_date';
                                    let isConditionStartDateAd = (conditionStartDate?.selectValue||'') == 'ad_name';


                                    let groupTextList = groupAdList.map(item=>item.display_name);
                                    let conditionTextList = conditionAdList.map(item=>item.display_name);
                                    if(isGroupCreateDateAd){
                                        groupTextList.push('创建日期(按广告)')
                                    }
                                    if(isGroupStartDateAd){
                                        groupTextList.push('开投日期(按广告)')
                                    }
                                    if(isConditionCreateDateAd){
                                        conditionTextList.push('创建日期(按广告)')
                                    }
                                    if(isConditionStartDateAd){
                                        conditionTextList.push('开投日期(按广告)')
                                    }

                                    let groupText = groupTextList.length>0?`<p><span class="text-bold">维度：</span>${groupTextList.join('、')}</p>`:'';
                                    let conditionText = conditionTextList.length>0?`<p><span class="text-bold">筛选：</span>${conditionTextList.join('、')}</p>`:'';

                                    let htmlStr = `<div><p>${field.display_name}指标与广告相关维度不能同时维度分组或筛选，是否继续？</p><p class="text-color-error text-bold">继续将删除以下已选维度或筛选！</p>${groupText}${conditionText}</div>`;
                                    this.$confirm(htmlStr,'提示',{
                                        confirmButtonText: '继续',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        if(isGroupCreateDateAd){
                                            this.removeDimension(groupCreateDate)
                                        }
                                        if(isGroupStartDateAd){
                                            this.removeDimension(groupStartDate)
                                        }
                                        if(isConditionCreateDateAd){
                                            this.removeCondition(conditionCreateDate)
                                        }
                                        if(isConditionStartDateAd){
                                            this.removeCondition(conditionStartDate)
                                        }

                                        groupAdList.forEach(item=>{
                                            this.removeDimension(item);
                                        });
                                        conditionAdList.forEach(item=>{
                                            this.removeCondition(item);
                                        })
                                        this.changeCheckItem(field, val, type)
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.changeCheckItem(field, false, 'field');
                                    })
                                } else{
                                    let isHasSearchTermTextDimension = formGroupName.includes('search_term_text');
                                    let searchTermTextDimension = this._findFieldByName(this.dimensionList,'search_term_text');
                                    let isDateSumTypeDay = isHasDateDimension ?(dateDimension.dimensionValue||{}).sum_type==='day':false;

                                    if(!isDateSumTypeDay&&!isHasSearchTermTextDimension){
                                        this.$confirm('【'+field.display_name+'】指标需按【搜索词】与【数据日期(天)】维度展开观测，需要帮您选择【搜索词】与【数据日期(天)】维度吗？','提示',{
                                            confirmButtonText: '选择',
                                            cancelButtonText: '取消',
                                            type: 'warning',
                                            dangerouslyUseHTMLString: true,
                                            customClass:'wide-confirm-box-550',
                                        }).then(()=>{
                                            if(isHasDateDimension){
                                                this.$set(dateDimension.dimensionValue, 'sum_type', 'day');
                                                this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                            }else{
                                                dateDimension.dimensionValue = {
                                                    sum_type: 'day' ,
                                                    start_date_dimension: '',
                                                    create_date_dimension: '',
                                                    yy_type_dimension: '',
                                                    order_by: 'date',
                                                    order_type: 'desc',
                                                    show_type: '1',
                                                    show_num: null,
                                                };
                                                this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                                this.formItem.group.push(dateDimension);
                                                this.changeCheckItem(dateDimension, true, 'group');
                                                this.$set(dateDimension,'checked',true);
                                            }

                                            this.formItem.group.push(searchTermTextDimension);
                                            this.changeCheckItem(searchTermTextDimension, true, 'group');
                                            this.$set(searchTermTextDimension,'checked',true);
                                            this.formItem[type].push(field);
                                            this.setCompareDate();
                                            this.isDisabledYoY = true;
                                        }).catch(()=>{
                                            console.log('取消');
                                            this.changeCheckItem(field, false, 'field');
                                        })
                                    }else if(!isDateSumTypeDay){
                                        this.$confirm('【'+field.display_name+'】指标需按【搜索词】与【数据日期(天)】维度展开观测，需要帮您选择【数据日期(天)】维度吗？','提示',{
                                            confirmButtonText: '选择',
                                            cancelButtonText: '取消',
                                            type: 'warning',
                                            dangerouslyUseHTMLString: true,
                                            customClass:'wide-confirm-box-550',
                                        }).then(()=>{
                                            console.log('继续',dateDimension);
                                            if(isHasDateDimension){
                                                this.$set(dateDimension.dimensionValue, 'sum_type', 'day');
                                                this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                                this.formItem[type].push(field);
                                            }else{
                                                dateDimension.dimensionValue = {
                                                    sum_type: 'day' ,
                                                    start_date_dimension: '',
                                                    create_date_dimension: '',
                                                    yy_type_dimension: '',
                                                    order_by: 'date',
                                                    order_type: 'desc',
                                                    show_type: '1',
                                                    show_num: null,
                                                };
                                                this.$set(dateDimension, 'subText', this.getDimensionSubText(dateDimension));
                                                this.formItem.group.push(dateDimension);
                                                this.changeCheckItem(dateDimension, true, 'group');
                                                this.$set(dateDimension,'checked',true);
                                                this.formItem[type].push(field);
                                            }
                                            this.setCompareDate();
                                            this.isDisabledYoY = true;
                                        }).catch(()=>{
                                            console.log('取消');
                                            this.changeCheckItem(field, false, 'field');
                                        })
                                    }else if(!isHasSearchTermTextDimension){
                                        this.$confirm('【'+field.display_name+'】指标需按【搜索词】与【数据日期(天)】维度展开观测，需要帮您选择【搜索词】维度吗？','提示',{
                                            confirmButtonText: '选择',
                                            cancelButtonText: '取消',
                                            type: 'warning',
                                            dangerouslyUseHTMLString: true,
                                            customClass:'wide-confirm-box-550',
                                        }).then(()=>{
                                            this.formItem.group.push(searchTermTextDimension);
                                            this.changeCheckItem(searchTermTextDimension, true, 'group');
                                            this.$set(searchTermTextDimension,'checked',true);

                                            this.formItem[type].push(field);
                                        }).catch(()=>{
                                            console.log('取消');
                                            this.changeCheckItem(field, false, 'field');
                                        })
                                    }else{
                                        this.formItem[type].push(field);
                                    }
                                }
                            }else{
                                this.formItem[type].push(field);
                            }
                        }
                    }
                } else {
                    if (index != '-1') {
                        if (type == 'condition') {
                            this.formItem[type].splice(index, 1);
                            this.removeCondition(field);
                        }else if(type == 'group'){
                            if(this.formItem.group.length<=0){
                                this.formItem.display_sum_dimension = '';
                            }
                            if(field.name == 'date'&&this.isCompare){
                                if(this.formItem.compare_type!='self'){
                                    this.setMoMDate();
                                }
                            }

                            // 取消分时维度
                            if(field.name == 'time_interval'){
                                console.log('取消分时维度');
                                // this.updateDisableDate();
                                this.removeDimension(field);
                            }else{
                                let actionItem = this._findFieldByName(this.dimensionList, field.name);

                                // 依赖[账户|计划|广告组|数据日期]维度的指标
                                let baseAccountFields = ['account_balance','account_cash_balance','account_vir_balance','account_daily_budget','account_day_budget'];
                                let basePlanFields = ['plan_daily_budget','campaign_day_budget'];
                                let baseAdGroupFields = ['adgroup_daily_budget','adgroup_day_budget'];
                                let baseDateGroupFields = ['impression_share','impression_rank','search_popularity'];
                                let baseDateFields = [].concat(baseAccountFields,basePlanFields,baseAdGroupFields,baseDateGroupFields);

                                // 表单中已选的依赖[数据日期|账户|计划|广告组]维度的指标
                                let formBaseDateFields = this.formItem.field.filter(item=>baseDateFields.includes(item.name));
                                let formBaseAccountFields = this.formItem.field.filter(item=>baseAccountFields.includes(item.name));
                                let formBasePlanFields = this.formItem.field.filter(item=>basePlanFields.includes(item.name));
                                let formBaseAdGroupFields = this.formItem.field.filter(item=>baseAdGroupFields.includes(item.name));

                                // 当前要移除的维度是否[账户|计划|广告组]维度
                                let isAccountDimension = field.name=='account_id'||field.name=='account_name';
                                let isPlanDimension = field.name=='plan_id'||field.name=='plan_name';
                                let isAdGroupDimension = field.name=='adgroup_id'||field.name=='adgroup_name';

                                // 表单中已选的[账户|计划|广告组]维度
                                let formAccountDimension = this.formItem.group.filter(item=>['account_id','account_name'].includes(item.name));
                                let formPlanDimension = this.formItem.group.filter(item=>['plan_id','plan_name'].includes(item.name));
                                let formAdGroupDimension = this.formItem.group.filter(item=>['adgroup_id','adgroup_name'].includes(item.name));

                                if(this.platId=='11'){
                                    isPlanDimension = field.name=='campaign_id'||field.name=='campaign_name';
                                    formPlanDimension = this.formItem.group.filter(item=>['campaign_id','campaign_name'].includes(item.name));
                                }
                                if(this.platId=='11'){
                                    isPlanDimension = field.name=='campaign_id'||field.name=='campaign_name';
                                    formPlanDimension = this.formItem.group.filter(item=>['campaign_id','campaign_name'].includes(item.name));
                                }

                                // 当前要移除的维度是否[搜索词]维度
                                let isSearchTermTextDimension = field.name=='search_term_text';
                                let baseSearchTermTextFields = ['impression_share','impression_rank','search_popularity'];
                                // 表单中已选的[账户|计划|广告组]维度
                                let formBaseSearchTermTextFields = this.formItem.field.filter(item=>baseSearchTermTextFields.includes(item.name));


                                if(this.platId=='9'&&isSearchTermTextDimension&&formBaseSearchTermTextFields.length>0){
                                    let fieldNameStr = formBaseSearchTermTextFields.map(item=>'【'+item.display_name+'】').join('');
                                    this.$confirm('已选'+fieldNameStr+'指标，取消【搜索词】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                                        confirmButtonText: '删除',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        this.formItem[type].splice(index, 1);
                                        formBaseSearchTermTextFields.forEach(inner=>{
                                            this.$set(inner,'checked',false);
                                            this.removeField(inner);
                                        });

                                        this.updateDisableDate();
                                        this.removeDimensionItem(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.$set(actionItem, 'checked', true);
                                    })
                                }else if(field.name=='date'&&formBaseDateFields.length>0){
                                    let fieldNameStr = formBaseDateFields.map(item=>'【'+item.display_name+'】').join('');
                                    this.$confirm('已选'+fieldNameStr+'指标，取消【数据日期】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                                        confirmButtonText: '删除',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        this.formItem[type].splice(index, 1);
                                        formBaseDateFields.forEach(inner=>{
                                            this.$set(inner,'checked',false);
                                            this.removeField(inner);
                                        });

                                        this.updateDisableDate();
                                        this.removeDimensionItem(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.$set(actionItem, 'checked', true);
                                    })
                                }else if(isAccountDimension&&formAccountDimension.length<2&&formBaseAccountFields.length>0){
                                    let fieldNameStr = formBaseAccountFields.map(item=>'【'+item.display_name+'】').join('');
                                    this.$confirm('已选'+fieldNameStr+'指标，取消【'+field.display_name+'】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                                        confirmButtonText: '删除',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        this.formItem[type].splice(index, 1);
                                        formBaseAccountFields.forEach(inner=>{
                                            this.$set(inner,'checked',false);
                                            this.removeField(inner);
                                        });

                                        this.updateDisableDate();
                                        this.removeDimensionItem(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.$set(actionItem, 'checked', true);
                                    })
                                }else if(isPlanDimension&&formPlanDimension.length<2&&formBasePlanFields.length>0){
                                    let fieldNameStr = formBasePlanFields.map(item=>'【'+item.display_name+'】').join('');
                                    this.$confirm('已选'+fieldNameStr+'指标，取消【'+field.display_name+'】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                                        confirmButtonText: '删除',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        this.formItem[type].splice(index, 1);
                                        formBasePlanFields.forEach(inner=>{
                                            this.$set(inner,'checked',false);
                                            this.removeField(inner);
                                        });

                                        this.updateDisableDate();
                                        this.removeDimensionItem(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.$set(actionItem, 'checked', true);
                                    })
                                }else if(isAdGroupDimension&&formAdGroupDimension.length<2&&formBaseAdGroupFields.length>0){
                                    let fieldNameStr = formBaseAdGroupFields.map(item=>'【'+item.display_name+'】').join('');
                                    this.$confirm('已选'+fieldNameStr+'指标，取消【'+field.display_name+'】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                                        confirmButtonText: '删除',
                                        cancelButtonText: '取消',
                                        type: 'warning',
                                        dangerouslyUseHTMLString: true,
                                        customClass:'wide-confirm-box-550',
                                    }).then(()=>{
                                        console.log('继续');
                                        this.formItem[type].splice(index, 1);
                                        formBaseAdGroupFields.forEach(inner=>{
                                            this.$set(inner,'checked',false);
                                            this.removeField(inner);
                                        });

                                        this.updateDisableDate();
                                        this.removeDimensionItem(field);
                                    }).catch(()=>{
                                        console.log('取消');
                                        this.$set(actionItem, 'checked', true);
                                    })
                                } else{
                                    this.formItem[type].splice(index, 1);
                                }
                            }
                        }else{
                            let actionItem = this._findFieldById(this.fieldList, field.id);
                            if (actionItem) {
                                this.$set(actionItem, 'checked', false);
                            }
                            this.formItem[type].splice(index, 1);
                        }
                    }else{
                        let actionItem = this._findFieldById(this.fieldList, field.id);
                        if (actionItem) {
                            this.$set(actionItem, 'checked', false);
                        }
                    }
                }
            },
            showFilterModal(field) {
                let modalType = (field.config || {}).type;
                this.actionFilterModal.title = field.display_name;
                this.actionFilterModal.id = field.id;
                this.actionFilterModal.name = field.name;
                this.actionFilterModal.isExclude = !!field.isExclude;

                if (modalType == 'time'||modalType == 'time_interval') {
                    this.actionFilterModal.timeValue = field.timeValue;
                    this.$refs.timeModal.showModal();
                } else if (modalType == 'date') {
                    this.actionFilterModal.dateValue = field.dateValue;
                    this.$refs.dateModal.showModal();
                } else if (modalType == 'date_select') {
                    this.actionFilterModal.dateValue = field.dateValue;
                    this.actionFilterModal.selectValue = field.selectValue;
                    this.$refs.dateSelectModal.showModal();
                } else if (modalType == 'select') {
                    this.actionFilterModal.selectValue = field.selectValue;
                    this.$refs.selectModal.showModal();
                } else if (modalType == 'content') {
                    this.actionFilterModal.contentValue = field.contentValue;
                    if(field.name=="yy_type"){
                        this.actionFilterModal.selectValue = field.selectValue;
                    }
                    this.$refs.contentModal.showModal();
                }
            },
            showDimensionModal(field) {
                this.actionDimensionModal.title = field.display_name;
                this.actionDimensionModal.id = field.id;
                this.actionDimensionModal.name = field.name;
                this.actionDimensionModal.dimensionValue = field.dimensionValue;
                this.$refs.dimensionModal.showModal();
            },
            _formatDataConfig(list) {
                let copyList = JSON.parse(JSON.stringify(list));
                return (copyList || []).map(item => {
                    let configStr = item.config || "{}";
                    item.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                    if (item.children && item.children.length > 0) {
                        item.children = item.children.map(child => {
                            let configStr = child.config || "{}";
                            try {
                                child.config = JSON.parse(configStr.replace(/\r|\n/g, ' '));
                            } catch (error) {
                                console.log(child, 'error');
                            }
                            return child;
                        })
                    }
                    return item;
                });
            },
            clearFilter(type,isNoUpdate) {
                if (type === 'field') {
                    this.formItem.field = [];
                    this._setListValue(this.fieldList, 'checked', false);
                } else if (type === 'condition') {
                    this.formItem.condition.forEach(condition=>{
                        this.$set(condition,'contentValue',[]);
                        this.$set(condition,'dateValue',[]);
                        this.$set(condition,'selectValue','');
                        this.$set(condition,'selectLabel','');
                    });

                    this.formItem.condition = [];
                    this._setListValue(this.conditionList, 'checked', false);
                    let dateCondition = this._findFieldByName(this.conditionList, 'date');
                    if (dateCondition) {
                        this.$set(dateCondition, 'checked', true);
                    }
                } else if (type === 'dimension') {
                    this.formItem.group.forEach(group=>{
                        this.$set(group,'dimensionValue',{
                            sum_type: group.name == 'date' ? 'day' : '',
                            start_date_dimension: group.name == 'start_date' ? (this.isPlatAll?'subproject_name': this.platId=='12'?'account_name': 'app_name') : '',     //开投日期默认维度：按产品
                            create_date_dimension: group.name == 'create_date' ? 'account_create_time' : '',
                            yy_type_dimension: group.name == 'yy_type' ? 'account_yy_type' : '',        //运营类型默认维度：按账户
                            order_by: group.name=='time_interval'?'time_interval':group.name=='date'?'date':'',
                            order_type: 'desc',
                            show_type: '1',
                            show_num: null,
                        });
                    });
                    this.formItem.group = [];
                    this.formItem.display_sum_dimension = '';
                    this._setListValue(this.dimensionList, 'checked', false);

                    if(!isNoUpdate&&this.isCompare){
                        if(this.formItem.compare_type!='self'){
                            this.formItem.compare_type = 'MoM';
                            this.isDisabledYoY = true;
                            this.setMoMDate();
                        }
                    }
                }
                if(!isNoUpdate){
                    this.updateDisableDate();
                }
            },
            confirmAppleSearchTerm(field){
                return new Promise((resolve, reject)=>{
                    let searchTermDimension = this.formItem.group.find(item=>item.name=='search_term_text');
                    let searchTermSourceDimension =  this.formItem.group.find(item=>item.name=='search_term_source');

                    let tipText = [];
                    if(searchTermDimension){
                        tipText.push('搜索词');
                    }
                    if(searchTermSourceDimension){
                        tipText.push('匹配来源');
                    }

                    if(this.platId=='9'&&field.name=='time_interval'&&(searchTermDimension||searchTermSourceDimension)){
                        let htmlStr = '<div><p>'+tipText.join('、')+'暂不支持分时段数据，是否继续？</p><p class="text-color-error text-bold">继续将删除'+tipText.join('、')+'维度！</p></div>';
                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');

                            if(searchTermDimension){
                                this.removeDimensionItem(searchTermDimension);
                            }
                            if(searchTermSourceDimension){
                                this.removeDimensionItem(searchTermSourceDimension);
                            }
                            resolve()
                        }).catch(()=>{
                            console.log('取消');
                            reject();
                        })
                    }else{
                        resolve();
                    }
                })
            },
            saveConditionValue(field, val, valueType) {
                console.log('saveConditionValue',field, val, valueType);
                this.confirmAppleSearchTerm(field).then(()=>{

                    let fieldItem = this.formItem.condition.find(item => item.id == field.id);
                    let formGroupItem = this.formItem.group.find(item =>item.id == field.id);
                    let conditionItem = this._findFieldById(this.conditionList, field.id);
                    if (!fieldItem) {
                        if(!formGroupItem){
                            /* 勾选筛选条件的字段时，自动勾选该字段维度 */
                            let dimensionField =  this._findFieldById(this.dimensionList, field.id);
                            if(field.name=='start_date'||field.name=='create_date'){
                                if((val.date||[]).length>0){
                                    this.$set(dimensionField,'checked',true);
                                    this.changeCheckItem(dimensionField,true,'group');
                                }
                            }else{
                                if(val.length>0){
                                    this.$set(dimensionField,'checked',true);
                                    this.changeCheckItem(dimensionField,true,'group');
                                }
                            }


                            /*如果是初次选中开投日期、则维度的开投日期维度保持一致*/
                            if(valueType=='date_select'){
                                if(field.name=='start_date'){
                                    let startDateDimension = this.formItem.group.find(item=>item.name=='start_date');
                                    if(startDateDimension){
                                        this.$set(startDateDimension.dimensionValue,'start_date_dimension',val.select);
                                        this.$set(startDateDimension, 'subText', val.selectLabel);
                                    }
                                }else if(field.name=='create_date'){
                                    let createDateDimension = this.formItem.group.find(item=>item.name=='create_date');
                                    if(createDateDimension){
                                        this.$set(createDateDimension.dimensionValue,'create_date_dimension',val.select);
                                        this.$set(createDateDimension, 'subText', val.selectLabel);
                                    }
                                }

                            }
                            /*如果是初次选中运营类型、则维度的运营类型维度保持一致*/
                            if(field.name=='yy_type'){
                                let yyTypeDimension = this.formItem.group.find(item=>item.name=='yy_type');
                                if(yyTypeDimension){
                                    this.$set(yyTypeDimension.dimensionValue,'yy_type_dimension',field.select);
                                    this.$set(yyTypeDimension, 'subText', field.selectLabel);
                                }
                            }
                        }
                        this.formItem.condition.push(conditionItem);
                        fieldItem = this.formItem.condition.find(item => item.id == field.id);
                    }
                    if (valueType == 'content') {
                        this.$set(fieldItem, 'contentValue', val.length > 0 ? val : []);
                        this.$set(fieldItem,'isExclude',val.length > 0 ? field.isExclude : false);
                        if(field.name=='yy_type'){
                            this.$set(fieldItem, 'selectValue', field.select);
                            this.$set(fieldItem, 'selectLabel', field.selectLabel);
                        }
                    } else if (valueType == 'time') {
                        this.$set(fieldItem, 'timeValue', val);
                    } else if (valueType == 'date') {
                        this.$set(fieldItem, 'dateValue', val);
                    } else if (valueType == 'select') {
                        this.$set(fieldItem, 'selectValue', val.select);
                        this.$set(fieldItem, 'selectLabel', val.selectLabel);
                    } else {
                        this.$set(fieldItem, 'timeValue', val.time);
                        this.$set(fieldItem, 'dateValue', val.date);
                        this.$set(fieldItem, 'selectValue', val.select);
                        this.$set(fieldItem, 'selectLabel', val.selectLabel);
                    }

                    if (val <= 0) {
                        this.removeCondition(fieldItem);
                        // this.removeDimension(fieldItem);
                    } else {
                        this.$set(fieldItem, 'checked', true);
                        this.updateDisableDate();
                    }
                },()=>{
                    console.log('取消');
                });
            },
            addTemplate(data){
                let reqData = data||this.getSubmitData();
                let $templateModal = this.$refs.addTemplateModal;
                data.range_time = '';
                data.range_time1 = '';
                data.compare_type = '';

                API.addTemplate(Object.assign({},reqData,data)).then(res=>{
                    this.$message.success(res.info||'操作成功');
                    // let $templateModal = this.$refs.templateModal;
                    $templateModal.submitLoading = false;
                    $templateModal.handleClose();
                },err=>{
                    console.log('addTemplate err',err);
                    this.$message.error(err.info||'请求有误');
                    $templateModal.submitLoading = false;
                    let errData = err.data||{};
                    let errInfo = errData.error || {};

                    let errCondition = errInfo.condition_config || [];
                    let errDimension = errInfo.dimension_config || [];
                    let errField = errInfo.field_config || [];
                    if (errCondition.length > 0 || errDimension.length > 0 || errField.length > 0) {
                        let conditionHtml = errCondition.length > 0 ? '<p class="pb6"><span class="text-bold">筛选条件：</span>' + errCondition.join('，') + '</p>' : '';
                        let dimensionHtml = errDimension.length > 0 ? '<p class="pb6"><span class="text-bold">维度分组：</span>' + errDimension.join('，') + '</p>' : '';
                        let fieldHtml = errField.length > 0 ? '<p class="pb6"><span class="text-bold">数据指标：</span>' + errField.join('，') + '</p>' : '';
                        let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${conditionHtml}${dimensionHtml}${fieldHtml}</div>`;

                        this.$confirm(htmlStr, '以下已选条件无权限，保存失败', {
                            showCancelButton: false,
                            confirmButtonText: '我知道了',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        }).then(() => {
                            // this.handleClose();
                        });
                    }

                    this.submitLoading = false;
                });
            },
            closeConditionModal(field) {
                let fieldItem = this.formItem.condition.find(item => item.id == field.id);
                if (!fieldItem) {
                    this.removeCondition(field);
                }
            },
            addFilterDate(dateArr){
                return new Promise((resolve,reject)=>{
                    let conditionData = {};
                    this.formItem.condition.forEach(item => {
                        let config = item.config || {};
                        if (config.type == 'date_select') {
                            conditionData[item.name] = item.dateValue.join('/');
                            if (item.name == 'start_date') {
                                conditionData.start_date_dimension = item.selectValue;
                            }else if(item.name == 'create_date'){
                                conditionData.create_date_dimension = item.selectValue;
                            }
                        } else if (config.type == 'date') {
                            conditionData[item.name] = item.dateValue.join('/');
                        } else if(config.type == 'time'){
                            conditionData[item.name] = item.timeValue.join('/');
                        } else if (config.type == 'select') {
                            conditionData[item.name] = item.selectValue;
                        } else {
                            if(item.name == 'yy_type'){
                                conditionData.yy_type_dimension = item.selectValue;
                            }
                            conditionData[item.name] = (item.contentValue || []).map(item => item.id);
                        }
                    });
                    this.disableDateLoading = true;


                    let apiType = 'getPlatDisableDate';
                    if(this.platId == '1'){
                        apiType = 'getOPPODisableDate';
                    }else if(this.platId == '3'){
                        apiType = 'getVivoDisableDate';
                    }else if(this.platId == '4'){
                        apiType = 'getHuaweiDisableDate';
                    }else if(this.platId == '7'){
                        apiType = 'getMiDisableDate';
                    }else if(this.platId == '8'){
                        apiType = 'getIQiYiDisableDate';
                    }else if(this.platId == '9'){
                        apiType = 'getAppleDisableDate';
                    }else if(this.platId == '10'){
                        apiType = 'getHuaweiADSDisableDate';
                    }else if(this.platId == '11'){
                        apiType = 'getHonorDisableDate';
                    }else if(this.platId == '37'){
                        apiType = 'getMiv4DisableDate';
                    }else if(this.platId == '12'){
                        apiType = 'getMiGlobalDisableDate';
                    }
                    let reqData = {
                        condition: conditionData,
                        range_time: dateArr.join('/'),
                    };
                    if(this.platId=='9'||this.isPlatAll){
                        reqData.time_zone = this.formItem.time_zone;
                    }
                    if(this.isTimeFilter){
                        reqData.time_interval = this.platTimeInterval;
                    }

                    API[apiType](reqData).then(res => {
                        this.disableDateLoading = false;
                        let resData = res.data||{};
                        resolve(resData.has_cost_date||[]);

                    }, err => {
                        console.log(apiType,' err', err);
                        this.disableDateLoading = false;
                        reject();
                    })
                })
            },
            getDefaultTemplate(){
                console.log('getDefaultTemplate');
                API.getDefaultTemplate({
                    plat_id:this.platId||'0',
                }).then(res=>{
                    console.log('getDefaultTemplate',res);
                    let resData = res.data||{};
                    let templateInfo = resData.info||{};
                    if(templateInfo.id){
                        this.useTemplate(templateInfo,true);
                    }
                },err=>{
                    console.log('getDefaultTemplate err',err);
                })
            },
            getVivoCostDecimalConfig() {
                API.getVivoCostDecimal().then(res => {
                    let data = res.data || {};
                    this.costDecimalConfig = {
                        unified: data.unified==0?0:1,
                        cost: data.cost==null?5:Number(data.cost),
                        cash_cost: data.cash_cost==null?5:Number(data.cash_cost),
                        vir_cost: data.vir_cost==null?5:Number(data.vir_cost),
                    };
                }, err => {
                    console.log('getVivoCostDecimal error',err);
                });
            },
            changeCostDecimalUnified() {
                // 关闭统一设置时，补齐独立的小数位默认值（复用当前统一值）
                if(this.costDecimalConfig.unified==0){
                    if(this.costDecimalConfig.cash_cost==null||this.costDecimalConfig.cash_cost===''){
                        this.costDecimalConfig.cash_cost = this.costDecimalConfig.cost;
                    }
                    if(this.costDecimalConfig.vir_cost==null||this.costDecimalConfig.vir_cost===''){
                        this.costDecimalConfig.vir_cost = this.costDecimalConfig.cost;
                    }
                }
                this.saveCostDecimal();
            },
            changeCostDecimal() {
                this.saveCostDecimal();
            },
            saveCostDecimal() {
                let params = {
                    unified: this.costDecimalConfig.unified,
                    cost: this.costDecimalConfig.cost,
                };
                if(this.costDecimalConfig.unified==0){
                    params.cash_cost = this.costDecimalConfig.cash_cost;
                    params.vir_cost = this.costDecimalConfig.vir_cost;
                }
                API.setVivoCostDecimal(params).then(() => {
                }, err => {
                    this.$message.error(err.info || '保存失败');
                });
            },
            updateDisableDate(quickDate) {
                /* quickDate：仅整体tab页里 点击【所有数据日期】时需要携带该参数 */

                let conditionData = {};
                this.formItem.condition.forEach(item => {
                    let config = item.config || {};
                    if (config.type == 'date_select') {
                        conditionData[item.name] = item.dateValue.join('/');
                        if (item.name == 'start_date') {
                            conditionData.start_date_dimension = item.selectValue;
                        }else if(item.name == 'create_date'){
                            conditionData.create_date_dimension = item.selectValue;
                        }
                    } else if (config.type == 'date') {
                        conditionData[item.name] = item.dateValue.join('/');
                    } else if(config.type == 'time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    } else if (config.type == 'select') {
                        conditionData[item.name] = item.selectValue;
                    } else {
                        if(item.name == 'yy_type'){
                            conditionData.yy_type_dimension = item.selectValue;
                        }
                        conditionData[item.name] = (item.contentValue || []).map(item => item.id);
                    }
                });
                this.disableDateLoading = true;


                let apiType = 'getPlatDisableDate';
                if(this.platId == '1'){
                    apiType = 'getOPPODisableDate';
                }else if(this.platId == '3'){
                    apiType = 'getVivoDisableDate';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiDisableDate';
                }else if(this.platId == '7'){
                    apiType = 'getMiDisableDate';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiDisableDate';
                }else if(this.platId == '9'){
                    apiType = 'getAppleDisableDate';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSDisableDate';
                }else if(this.platId == '11'){
                    apiType = 'getHonorDisableDate';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4DisableDate';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalDisableDate';
                }
                let reqData = {
                    // range_time: this.formItem.range_time.join('/'),
                    condition: conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                };
                if(this.isPlatAll||this.platId=='9'){
                    reqData.time_zone = this.formItem.time_zone;
                }
                if(this.isPlatAll&&quickDate){
                    reqData.quick_date = this.formItem.quick_date;
                }
                if(this.platId=='9'||this.platId=='4'){
                    /* 后端分表查询需要用到group数据，仅Apple渠道和华为渠道 */
                    reqData.group = this.formItem.group.map(item => {
                        let value = item.dimensionValue || {};
                        let groupVal = {
                            group_by: item.name,
                        };
                        if(value.start_date_dimension){
                            groupVal.start_date_dimension = value.start_date_dimension;
                        }
                        if(value.create_date_dimension){
                            groupVal.create_date_dimension = value.create_date_dimension;
                        }
                        if(value.yy_type_dimension){
                            groupVal.yy_type_dimension = value.yy_type_dimension;
                        }
                        return groupVal;
                    });
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }

                return API[apiType](reqData).then(res => {
                    let resData = res.data||{};
                    this.notHasCostDate = (resData.not_has_cost_date || []).map(item=>{
                        return dayjs(''+item).format('YYYY-MM-DD');
                    });
                    this.hasCostDate = (resData.has_cost_date || []).map(item=>{
                        return dayjs(''+item).format('YYYY-MM-DD');
                    });
                    this.startDate = resData.start_date+'';
                    this.endDate = resData.end_date+'';
                    this.dateAllDisabled = resData.all_disabled;
                    this.disableDateLoading = false;
                }, err => {
                    console.log(apiType,' err', err);
                    this.disableDateLoading = false;
                })
            },
            saveDimensionValue(field, val) {
                let fieldItem = this.formItem.group.find(item => item.id == field.id);
                let isDateDimension = field.name=='date';
                let isSumTypeDay = isDateDimension?val.sum_type==='day':false;
                let appleBaseDateFields = ['impression_share','impression_rank','search_popularity'];
                let formAppleBaseDateFields = this.formItem.field.filter(item=>appleBaseDateFields.includes(item.name));
                if(this.platId=='9'&&isDateDimension&&!isSumTypeDay&&formAppleBaseDateFields.length>0){
                    let fieldNameStr = formAppleBaseDateFields.map(item=>'【'+item.display_name+'】').join('');
                    this.$confirm('已选'+fieldNameStr+'指标，取消【数据日期(天)】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                        confirmButtonText: '删除',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true,
                        customClass:'wide-confirm-box-550',
                    }).then(()=>{
                        console.log('继续');
                        formAppleBaseDateFields.forEach(inner=>{
                            this.$set(inner,'checked',false);
                            this.removeField(inner);
                        });
                        if (fieldItem) {
                            this.$set(fieldItem, 'dimensionValue', {
                                sum_type: val.sum_type,
                                start_date_dimension: val.start_date_dimension,
                                create_date_dimension: val.create_date_dimension,
                                yy_type_dimension: val.yy_type_dimension,
                                order_by: val.order_by,
                                order_type: val.order_type,
                                show_type: val.show_type,
                                show_num: val.show_num,
                            });
                            if (this.formItem.compare_type == 'MoM') {
                                this.setMoMDate();
                            } else if (this.formItem.compare_type == 'YoY') {
                                this.setYoYDate();

                            }
                            this.$set(fieldItem, 'subText', this.getDimensionSubText(fieldItem));
                            this.isDisabledYoY = !(val.sum_type==='month'||val.sum_type==='quarter');
                        }
                        this.checkCompareDateTip();
                        this.updateDisableDate();
                    }).catch(()=>{
                        console.log('取消');
                    });
                }else{
                    let fieldItem = this.formItem.group.find(item => item.id == field.id);
                    if (fieldItem) {
                        this.$set(fieldItem, 'dimensionValue', {
                            sum_type: val.sum_type,
                            start_date_dimension: val.start_date_dimension,
                            create_date_dimension: val.create_date_dimension,
                            yy_type_dimension: val.yy_type_dimension,
                            order_by: val.order_by,
                            order_type: val.order_type,
                            show_type: val.show_type,
                            show_num: val.show_num,
                        });
                        if (this.formItem.compare_type == 'MoM') {
                            this.setMoMDate();
                        } else if (this.formItem.compare_type == 'YoY') {
                            this.setYoYDate();

                        }
                        this.$set(fieldItem, 'subText', this.getDimensionSubText(fieldItem));
                        this.isDisabledYoY = !(val.sum_type==='month'||val.sum_type==='quarter');
                    }
                    if(isDateDimension){
                        this.checkCompareDateTip();
                    }
                }
            },
            moveField(evt){
                /* 处理跨条件、跨纬度、跨指标的胡乱拖动 */
                let draggedItem = evt.dragged;
                let relatedItem = evt.related;

                let draggedClassName = draggedItem.className.match(/filter-item-\w*/g)||[];
                let relatedClassName = relatedItem.className.match(/filter-item-\w*/g)||[];

                if(draggedClassName.length>0&&relatedClassName.length>0){
                    if(relatedClassName[0]!==draggedClassName[0]){
                        return false;
                    }
                }else{
                    return false;
                }
            },
            dragField(type, val) {
                if (val.added) {
                    if (type === 'fields') {
                        if (this.shownFields.length > 4) {
                            this.hiddenFields.unshift(this.shownFields.pop());
                        }
                    } else if (type === 'dimensions') {
                        if (this.shownDimensions.length > 4) {
                            this.hiddenDimensions.unshift(this.shownDimensions.pop());
                        }
                    } else if (type === 'conditions') {
                        if (this.shownConditions.length > 4) {
                            this.hiddenConditions.unshift(this.shownConditions.pop());
                        }
                    }
                } else if (val.removed) {
                    if (type === 'fields') {
                        this.shownFields.push(this.hiddenFields.shift());
                    } else if (type === 'dimensions') {
                        this.shownDimensions.push(this.hiddenDimensions.shift());
                    } else if (type === 'conditions') {
                        this.shownConditions.push(this.hiddenConditions.shift());
                    }
                }else if(val.removed){
                    console.log('drag,removed',val.removed)
                }

                if (type === 'fields') {
                    this.formItem.field = [].concat(this.shownFields,this.hiddenFields);
                } else if (type === 'dimensions') {
                    this.formItem.group = [].concat(this.shownDimensions,this.hiddenDimensions);
                } else if (type === 'conditions') {
                    this.formItem.condition = [].concat(this.shownConditions,this.hiddenConditions);
                }


            },
            removeField(field) {
                let index = this.formItem.field.findIndex(item => item.name == field.name);

                if(index!=-1){
                    this.formItem.field.splice(index, 1);
                    this.changeCheckItem(field, false, 'field');
                    let actionItem = this._findFieldById(this.fieldList, field.id);
                    if (actionItem) {
                        this.$set(actionItem, 'checked', false);
                    }
                }

            },
            removeDimensionOrderField(field){
                let actionDimension = this._findFieldByName(this.formItem.group,field.name);
                console.log('removeDimensionOrderField',actionDimension);
                let dimensionValue = actionDimension.dimensionValue||{};
                if(dimensionValue.order_by){
                    dimensionValue.order_by = '';
                    dimensionValue.order_type = '';
                    dimensionValue.show_type = '1';
                    dimensionValue.show_num = null;
                    dimensionValue.order_type = 'desc';
                    actionDimension.subText = this.getDimensionSubText(actionDimension);
                }
            },
            removeDimension(field) {
                console.log('removeDimension',field);

                if(field.name=='time_interval'){
                    let hasTimeCondition = !!this.formItem.condition.find(item=>item.name==='time_interval');
                    let effectiveBudgetField = this.formItem.field.find(item=>item.name==='effective_budget');
                    let effectiveBudgetRateField = this.formItem.field.find(item=>item.name==='effective_budget_rate');
                    if(hasTimeCondition&&(effectiveBudgetField||effectiveBudgetRateField)){
                        this.$confirm('有效预算指标分时数据需按时段展开观测，删除数据时段维度将同时删除有效预算指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            // this.changeCheckItem(effectiveBudgetField, false, 'field');
                            if(effectiveBudgetField){
                                this.$set(effectiveBudgetField,'checked',false);
                                this.removeField(effectiveBudgetField);
                            }
                            if(effectiveBudgetRateField){
                                this.$set(effectiveBudgetRateField,'checked',false);
                                this.removeField(effectiveBudgetRateField);
                            }
                            this.removeDimensionItem(field);
                            this.updateDisableDate();
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field,'checked',true);
                        })
                    }else{
                        this.removeDimensionItem(field);
                        this.updateDisableDate();
                    }
                }else{
                    // 依赖[账户|计划|广告组|数据日期]维度的指标
                    let baseAccountFields = ['account_balance','account_cash_balance','account_vir_balance','account_daily_budget','account_day_budget'];
                    let basePlanFields = ['plan_daily_budget','campaign_day_budget','campaign_day_budget'];
                    let baseAdGroupFields = ['adgroup_daily_budget','adgroup_day_budget'];
                    let baseDateFields = [].concat(baseAccountFields,basePlanFields,baseAdGroupFields);

                    // 表单中已选的依赖[数据日期|账户|计划|广告组]维度的指标
                    let formBaseDateFields = this.formItem.field.filter(item=>baseDateFields.includes(item.name));
                    let formBaseAccountFields = this.formItem.field.filter(item=>baseAccountFields.includes(item.name));
                    let formBasePlanFields = this.formItem.field.filter(item=>basePlanFields.includes(item.name));
                    let formBaseAdGroupFields = this.formItem.field.filter(item=>baseAdGroupFields.includes(item.name));

                    // 当前要移除的维度是否[账户|计划|广告组]维度
                    let isAccountDimension = field.name=='account_id'||field.name=='account_name';
                    let isPlanDimension = field.name=='plan_id'||field.name=='plan_name';
                    let isAdGroupDimension = field.name=='adgroup_id'||field.name=='adgroup_name';

                    // 表单中已选的[账户|计划|广告组]维度
                    let formAccountDimension = this.formItem.group.filter(item=>['account_id','account_name'].includes(item.name));
                    let formPlanDimension = this.formItem.group.filter(item=>['plan_id','plan_name'].includes(item.name));
                    let formAdGroupDimension = this.formItem.group.filter(item=>['adgroup_id','adgroup_name'].includes(item.name));

                    if(this.platId=='11'){
                        isPlanDimension = field.name=='campaign_id'||field.name=='campaign_name';
                        formPlanDimension = this.formItem.group.filter(item=>['campaign_id','campaign_name'].includes(item.name));
                    }

                    // 当前要移除的维度是否[搜索词]维度
                    let isSearchTermTextDimension = field.name=='search_term_text';
                    let baseSearchTermTextFields = ['impression_share','impression_rank','search_popularity'];
                    // 表单中已选的[账户|计划|广告组]维度
                    let formBaseSearchTermTextFields = this.formItem.field.filter(item=>baseSearchTermTextFields.includes(item.name));
                    let appleBaseDateFields = ['impression_share','impression_rank','search_popularity'];
                    let formAppleBaseDateFields = this.formItem.field.filter(item=>appleBaseDateFields.includes(item.name));


                    if(this.platId=='9'&&isSearchTermTextDimension&&formBaseSearchTermTextFields.length>0){
                        let fieldNameStr = formBaseSearchTermTextFields.map(item=>'【'+item.display_name+'】').join('');
                        this.$confirm('已选'+fieldNameStr+'指标，取消【搜索词】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBaseSearchTermTextFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });

                            this.updateDisableDate();
                            this.removeDimensionItem(field);
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field, 'checked', true);
                        })
                    }else if(this.platId=='9'&&field.name=='date'&&formAppleBaseDateFields.length>0){
                        let fieldNameStr = formAppleBaseDateFields.map(item=>'【'+item.display_name+'】').join('');
                        this.$confirm('已选'+fieldNameStr+'指标，取消【数据日期】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formAppleBaseDateFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });

                            this.updateDisableDate();
                            this.removeDimensionItem(field);
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field, 'checked', true);
                        })
                    }else if(field.name=='date'&&formBaseDateFields.length>0){
                        let fieldNameStr = formBaseDateFields.map(item=>'【'+item.display_name+'】').join('');
                        this.$confirm('已选'+fieldNameStr+'指标，取消【数据日期】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBaseDateFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });

                            this.updateDisableDate();
                            this.removeDimensionItem(field);
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field,'checked',true);
                        })
                    }else if(isAccountDimension&&formAccountDimension.length<2&&formBaseAccountFields.length>0){
                        let fieldNameStr = formBaseAccountFields.map(item=>'【'+item.display_name+'】').join('');
                        this.$confirm('已选'+fieldNameStr+'指标，取消【'+field.display_name+'】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBaseAccountFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });

                            this.updateDisableDate();
                            this.removeDimensionItem(field);
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field,'checked',true);
                        })
                    }else if(isPlanDimension&&formPlanDimension.length<2&&formBasePlanFields.length>0){
                        let fieldNameStr = formBasePlanFields.map(item=>'【'+item.display_name+'】').join('');
                        this.$confirm('已选'+fieldNameStr+'指标，取消【'+field.display_name+'】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBasePlanFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });

                            this.updateDisableDate();
                            this.removeDimensionItem(field);
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field,'checked',true);
                        })
                    }else if(isAdGroupDimension&&formAdGroupDimension.length<2&&formBaseAdGroupFields.length>0){
                        let fieldNameStr = formBaseAdGroupFields.map(item=>'【'+item.display_name+'】').join('');
                        this.$confirm('已选'+fieldNameStr+'指标，取消【'+field.display_name+'】维度，同时删除'+fieldNameStr+'指标，确认要删除吗？','提示',{
                            confirmButtonText: '删除',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            console.log('继续');
                            formBaseAdGroupFields.forEach(inner=>{
                                this.$set(inner,'checked',false);
                                this.removeField(inner);
                            });

                            this.updateDisableDate();
                            this.removeDimensionItem(field);
                        }).catch(()=>{
                            console.log('取消');
                            this.$set(field,'checked',true);
                        })
                    } else{
                        this.removeDimensionItem(field);
                    }
                }
            },
            removeDimensionItem(field){
                console.log('removeDimensionItem',field);
                let actionItem = this._findFieldById(this.dimensionList, field.id)||this._findFieldByName(this.dimensionList, field.name);
                actionItem && (actionItem.checked = false);
                // this.changeCheckItem(field, false, 'group');

                actionItem.dimensionValue = {
                    sum_type: '',
                    start_date_dimension: '',
                    create_date_dimension: '',
                    yy_type_dimension: '',
                    order_by: '',
                    order_type: 'desc',
                    show_type: '1',
                    show_num: null,
                };
                actionItem.subText = '';


                let index = this.formItem.group.findIndex(item => item.name == field.name);
                if(index>=0){
                    this.formItem.group.splice(index, 1);
                }

                if(field.name=='date'&&this.isCompare){
                    if(this.formItem.compare_type!='self'){
                        this.formItem.compare_type = 'MoM';
                        this.isDisabledYoY = true;
                        this.setMoMDate();
                    }
                }
                if(this.formItem.group.length<=0){
                    this.formItem.display_sum_dimension = '';
                }
            },
            removeCondition(field) {
                let index = this.formItem.condition.findIndex(item => item.name == field.name);
                if(index!=-1){
                    this.formItem.condition.splice(index, 1);
                }
                this.changeCheckItem(field, false, 'condition');
                let actionItem = this._findFieldById(this.conditionList, field.id);
                if (actionItem) {
                    this.$set(actionItem, 'checked', false);
                    this.$set(actionItem, 'contentValue', []);
                    this.$set(actionItem, 'selectValue', '');
                    this.$set(actionItem, 'dateValue', []);
                    this.$set(actionItem, 'timeValue', []);
                }

                let tempChangedIndex = this.tempChangedConditions.findIndex(item=>item==field.name);
                if(tempChangedIndex!=-1){
                    this.tempChangedConditions.splice(tempChangedIndex,1);
                }
                this.updateDisableDate();
            },
            getDimensionSubText(field) {
                let values = field.dimensionValue||{};
                let sumTypeMap = {
                    'day': '天',
                    'week': '周',
                    'month': '月',
                    'quarter': '季度',
                    'year': '年',
                };
                let dimensionMap = {
                    'bloc_name': '按集团',
                    'company_name': '按客户',
                    'account_name': this.platId=='9'?'按广告系列组':'按账户',
                    'app_name': '按产品',
                    'main_app_name': '按产品主名称',
                    'project_name': '按项目名称',
                    'subproject_name': '按推广',
                    'plan_name': this.platId=='8'||this.platId=='9'?'按广告系列':'按计划',
                    'adgroup_name':  this.platId=='8'?'按广告': this.platId=='10'? '按任务': this.platId=='11'?'按分组':'按广告组',
                    'ad_name': this.platId=='1'||this.platId=='8'||this.platId=='7'||this.platId=='12'||this.platId=='37'||this.platId=='10'||this.platId=='11'?'按创意':'按广告',
                    'idea_name':'按创意',
                    'task_name':'按任务',
                    'sub_task_name':'按子任务',
                    'keyword':'按关键词',
                    'search_term':'按搜索词',
                };
                // 补充创建日期维度map
                let createDimensionMap = {
                    'account_create_time': this.platId=='9'?'按广告系列组':'按账户',
                    'plan_create_date': this.platId=='8'||this.platId=='9'?'按广告系列':'按计划',
                    'adgroup_create_date': this.platId=='8'?'按广告': this.platId=='10'? '按任务': this.platId=='11'?'按分组':'按广告组',
                    'ad_create_date': this.platId=='1'||this.platId=='8'||this.platId=='7'||this.platId=='12'||this.platId=='37'||this.platId=='10'||this.platId=='11'?'按创意':'按广告',
                    'idea_create_date':'按创意',
                    'task_create_date':'按任务',
                    'sub_task_create_date':'按子任务',
                    'keyword_create_date':'按关键词',
                };
                // 补充运营类型维度map
                let yyTypeDimensionMap = {
                    'bloc_yy_type': '按集团',
                    'company_yy_type': '按客户',
                    'account_yy_type': this.platId=='9'?'按广告系列组':'按账户',
                    'app_yy_type': '按产品',
                    'main_app_yy_type': '按产品主名称',
                    'project_yy_type': '按项目',
                    'subproject_yy_type': '按推广',
                    'plan_yy_type': this.platId=='8'||this.platId=='9'?'按广告系列':'按计划',
                    'adgroup_yy_type': this.platId=='8'?'按广告': this.platId=='10'?'按任务':this.platId=='11'?'按分组':'按广告组',
                    'ad_yy_type': this.platId=='1'||this.platId=='8'||this.platId=='7'||this.platId=='12'||this.platId=='37'||this.platId=='10'||this.platId=='11'?'按创意':'按广告',
                    'idea_yy_type': '按创意',
                    'task_yy_type':'按任务',
                    'sub_task_yy_type':'按子任务',
                    'keyword_yy_type':'按关键词',
                    'search_term_yy_type':'按搜索词',
                };

                let dataArr = [];
                let sumTypeText = sumTypeMap[values.sum_type];
                let startDateDimensionText = dimensionMap[values.start_date_dimension];
                let createDateDimensionText = createDimensionMap[values.create_date_dimension];
                let yyTypeDimensionText = yyTypeDimensionMap[values.yy_type_dimension];
                let orderByText = (this._findFieldByName(this.fieldList,values.order_by)|| {}).display_name;
                let orderTypeText = values.order_type == 'desc' ? '降序' : values.order_type == 'asc' ? '升序' : '';
                let showNumText = values.show_type == '1' ? '全部展示' : values.show_num > 0 ? '展示' + values.show_num + '个' : '';
                if (sumTypeText && field.name == 'date') {
                    dataArr.push(sumTypeText);
                }
                if (startDateDimensionText && field.name == 'start_date') {
                    dataArr.push(startDateDimensionText);
                }
                if (createDateDimensionText && field.name == 'create_date') {
                    dataArr.push(createDateDimensionText);
                }
                if (yyTypeDimensionText && field.name == 'yy_type'){
                    dataArr.push(yyTypeDimensionText);
                }
                if (field.name === 'date' && !orderByText) {
                    dataArr.push('数据日期' + orderTypeText);
                } else if(field.name === 'time_interval' && !orderByText){
                    dataArr.push('数据时段' + orderTypeText);
                } else if (orderByText) {
                    dataArr.push(orderByText + orderTypeText);
                }
                if (field.name != 'date' && showNumText) {
                    dataArr.push(showNumText);
                }
                let dataStr = dataArr.join('/');
                return dataStr==='全部展示'?'':dataStr;
            },
            changeFilterSearch(val) {
                console.log('changeFilterSearch', val);
            },
            handleTableFreezeChange(val) {
                if(val>8){
                    this.$nextTick(()=>{
                        this.$set(this.tableSettings,'tableFreezeColNum',8);
                    });
                    return this.$message.error('冻结列数不能超过8列');
                }
                this.makeColumns();
            },
            resetFilters() {

                this.formItem.condition.forEach(item=>{
                    item.contentValue = [];
                    item.dateValue = [];
                    item.timeValue = [];
                    item.selectValue = '';
                });
                this.formItem.group.forEach(item=>{
                    item.dimensionValue = {
                        sum_type: '',
                        start_date_dimension: '',
                        create_date_dimension: '',
                        yy_type_dimension: '',
                        order_by: '',
                        order_type: 'desc',
                        show_type: '1',
                        show_num: null,
                    };
                });

                this._setListValue(this.conditionList,'checked',false);
                this._setListValue(this.dimensionList,'checked',false);
                this._setListValue(this.fieldList,'checked',false);

                this.isCompare = false;

                this.formItem.condition = [];
                this.formItem.group = [];
                this.formItem.field = [];
                let dateCondition = this._findFieldByName(this.conditionList, 'date');
                this.$set(dateCondition, 'checked', true);
                let dateDimension = this._findFieldByName(this.dimensionList, 'date');
                if (dateDimension) {
                    this.$set(dateDimension, 'checked', true);
                    this.changeCheckItem(dateDimension, true, 'group');
                }

                // this.formItem.range_time = [this.lastDataTime,this.lastDataTime];

                // let costField = this.fieldList.find(item=>item.name=='cost');
                let costStr = this.platId=='9'?'local_spend':this.platId=='11'?'ad_billing':'cost';
                let costField = this._findFieldByName(this.fieldList,costStr);

                if(costField){
                    this.$set(costField, 'checked', true);
                    this.changeCheckItem(costField,true,'field');
                }


                this.formItem.dimension_default_sort = '1';
                this.formItem.display_sum_dimension = '';
                this.formItem.data_display_type = 'sum_up';
                this.formItem.cost_type = this.costFieldList[0];

                this.updateDisableDate();

                this.$refs.pageWrap.showAllFilters();
            },
            hideExportModal(){
                console.log('hideExportModal');
            },
            hideDownloadTableModal(){
                console.log('hideDownloadTableModal');
            },
            exportFile(data){
                console.log('exportFile',data);
                if (this.formItem.field.length <= 0) {
                    return this.$message.error('请至少选择一个数据指标');
                }else if(this.isCompare&&this.formItem.range_time1.length<=0){
                    return this.$message.error('对比日期不能为空');
                }
                let submitData = utils.deepClone(this.getSubmitData());

                let apiType = 'exportPlatAnalysis';
                if(this.platId == '1'){
                    apiType = 'exportOPPOAnalysis';
                }else if(this.platId == '3'){
                    apiType = 'exportVivoAnalysis';
                }else if(this.platId == '4'){
                    apiType = 'exportHuaweiAnalysis';
                }else if(this.platId == '7'){
                    apiType = 'exportMiAnalysis';
                }else if(this.platId == '8'){
                    apiType = 'exportIQiYiAnalysis';
                }else if(this.platId == '9'){
                    apiType = 'exportAppleAnalysis';
                }else if(this.platId == '10'){
                    apiType = 'exportHuaweiADSAnalysis';
                }else if(this.platId == '11'){
                    apiType = 'exportHonorAnalysis';
                }else if(this.platId == '37'){
                    apiType = 'exportMiv4Analysis';
                }else if(this.platId == '12'){
                    apiType = 'exportMiGlobalAnalysis';
                }
                submitData.where = [];
                submitData.order_by = '';
                submitData.order_type = '';

                API[apiType](Object.assign({
                    export_filename:data,
                }, submitData)).then(() => {
                    this.$refs.exportModal.submitLoading = false;
                    this.$refs.exportModal.hideModal();

                    this.$message.success('已添加导出任务，请到右上角离线下载中心下载Excel文件');
                }, (err) => {
                    console.log('exportAnalysisList error', err);
                    // if(err.code==0&&(err.data||[]).length<=0){
                    //
                    // }
                    this.$message.error(err.info||'导出失败');
                    this.$refs.exportModal.submitLoading = false;
                });
            },
            copyTab(){
                console.log('copyTab',this.formItem, this.$route);
                let routeData = this.$router.resolve({
                    path: this.$route.name,
                    query: this.$route.query,
                });
                window.open(routeData.href, '_blank');
                let tabData = Object.assign({},this.formItem,{
                    isCompare:this.isCompare,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                });
                window.localStorage.setItem('copyTab',JSON.stringify(tabData));
            },
            restoreLastData(){
                let restoreDataStr = window.localStorage.getItem(this.platName+'RestoreData');
                if(!restoreDataStr) return;
                let restoreData = JSON.parse(restoreDataStr)||{};
                console.log('restoreLastData',restoreData);
                this.doCopyTab(restoreData);

            },
            showExportModal(){
                this.getExportName();
            },
            showDownloadTableModal(){
                this.$refs.downloadTableModal.showModal();
            },
            getExportName(){
                if (this.formItem.field.length <= 0) {
                    return this.$message.error('请至少选择一个数据指标');
                }else if(this.isCompare&&this.formItem.range_time1.length<=0){
                    return this.$message.error('对比日期不能为空');
                }

                this.exportFileName = '';
                this.exportLoading = true;
                let submitData = this.getSubmitData();
                let apiType = 'getPlatAnalysisList';
                if(this.platId == '1'){
                    apiType = 'getOPPOAnalysisList';
                }else if(this.platId == '3'){
                    apiType = 'getVivoAnalysisList';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiAnalysisList';
                }else if(this.platId == '7'){
                    apiType = 'getMiAnalysisList';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiAnalysisList';
                }else if(this.platId == '9'){
                    apiType = 'getAppleAnalysisList';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSAnalysisList';
                }else if(this.platId == '11'){
                    apiType = 'getHonorAnalysisList';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4AnalysisList';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalAnalysisList';
                }
                API[apiType](Object.assign({
                    return_filename:'1',
                },submitData)).then(res=>{
                    console.log('getExportName',res);
                    let resData = res.data||{};
                    this.exportFileName = resData.filename||"";
                    this.$refs.exportModal.showModal();
                    this.exportLoading = false;
                },err=>{
                    this.$message.error(err.info||'请求有误');
                    this.exportLoading = false;
                })
            },
            submitSearch() {
                this.hideTdPop();
                if (this.formItem.field.length <= 0) {
                    return this.$message.error('请至少选择一个数据指标');
                }else if(this.isCompare&&this.formItem.range_time1.length<=0){
                    return this.$message.error('对比日期不能为空');
                }

                if(this.platId=='9'&&this.isAppleKeywordsChecked&&this.isAppleAdChecked){
                    return this.$message.error('筛选条件中：[关键词维度/筛选]与[广告维度/筛选]不能同时搜索');
                }


                let start = dayjs(this.formItem.range_time[0]);
                let end = dayjs(this.formItem.range_time[1]);
                let diff = end.diff(start,'day');

                let isCompareOver31day = false;
                if(this.isCompare){
                    let start1 = dayjs(this.formItem.range_time1[0]);
                    let end1 = dayjs(this.formItem.range_time1[1]);
                    let diff1 = end1.diff(start1,'day');
                    isCompareOver31day = diff1>this.hourSearchDays;
                }
                if(this.isTimeFilter&&(diff>this.hourSearchDays||isCompareOver31day)){
                    let isCompStr = isCompareOver31day?'对比':'';
                    return this.$message.error(isCompStr+'分时段数据仅支持查询最多'+this.hourSearchDays+'天')
                }


                let sortDimensions = this.formItem.group.filter(item=>{
                    let dimensionValue = item.dimensionValue||{};
                    return !!dimensionValue.order_by;
                });
                if(sortDimensions.length>10){
                    return this.$message.error('最多可设置10个维度的排序!');
                }

                this.tableSettings.sortBy = '';
                this.tableSettings.sortOrder = null;

                this.tableFilterList = [];
                this.$refs.table&&this.$refs.table.clearSort();
                this.queryData.pn = 1;

                this.tableSettings.tableFreezeCol = '1';
                this.tableSettings.tableFreezeColNu = null;
                this.tableSettings.fixedTableHeight = true;
                this.getDataList();

                // 每次提交时重置临时数据
                this.tempChangedConditions = [];
            },
            makeColumns() {
                this.disabledFreezeDimension = false;
                // 是否显示维度汇总行
                let isShowSum = !!(this.lastSubmitRequestData.display_sum_dimension=='1');
                let groupLength = (JSON.parse(this.lastSubmitRequestData.group)||[]).length;
                groupLength = isShowSum?groupLength+1:groupLength;
                if(groupLength>8){
                    this.disabledFreezeDimension = true;
                }

                let displaySumDimension = this.lastSubmitRequestData.display_sum_dimension==='1';

                this.columns = [];
                let fieldColumns = [];
                this.dataColumns.forEach(item=>{
                    let isDimension = this.curTableDimensions.includes(item.field) || item.field === 'date' || item.field==='aggregate_type' ||item.field === 'compare_date';
                    /* Apple SOV 数据按内容类搜 */
                    let isAppleSOVDate = this.platId=='9'&&['impression_share','impression_rank','search_popularity','compare_impression_share','compare_impression_rank','compare_search_popularity'].includes(item.field);
                    fieldColumns.push({
                        name: item.field_name,
                        field: item.field,
                        sortable: displaySumDimension?null:!isDimension||item.field==='start_date'||item.field==='account_create_time'||item.field==='date'||item.field==='time_interval'||item.field==='compare_date'||item.field==='create_date',
                        colType: isDimension||isAppleSOVDate ? 'content' : 'number',
                    })
                });



                let freezeNum = 1;
                if(this.tableSettings.tableFreezeCol == '3'){
                    freezeNum = this.tableSettings.tableFreezeColNum;
                    let $freezeInput = this.$refs.freezeInput;
                    if($freezeInput){
                        $freezeInput.focus();
                    }
                }else if(this.tableSettings.tableFreezeCol == '2'){
                    /* 所有维度列 */
                    let isCompare = this.lastSubmitRequestData.compare_type&&(this.lastSubmitRequestData.range_time1.length>2);
                    let submitDimension = JSON.parse(this.lastSubmitRequestData.group)||[];
                    let dateDimension = submitDimension.find(item=>item.group_by=='date');
                    freezeNum = isCompare&&dateDimension?groupLength+1:groupLength;
                    freezeNum = freezeNum+1;    // 增加序号列，所以再次+1
                }

                this.columns = fieldColumns.map((item, index) => {
                    if (index < freezeNum) {
                        item.fixed = 'left';
                    }
                    if(item.field=='index'){
                        item.sortable = null;
                    }
                    this.$set(item,'contentList',item.contentList);
                    return item;
                });
            },
            getSubmitData() {
                let conditionData = {};

                let conditions = [].concat(this.shownConditions,this.hiddenConditions);
                conditions.forEach(item => {
                    let config = item.config || {};
                    if (config.type == 'date_select') {
                        conditionData[item.name] = item.dateValue.join('/');
                        if (item.name == 'start_date') {
                            conditionData.start_date_dimension = item.selectValue;
                        }else if(item.name == 'create_date'){
                            conditionData.create_date_dimension = item.selectValue;
                        }
                    } else if (config.type == 'date') {
                        conditionData[item.name] = item.dateValue.join('/');
                    } else if (config.type == 'time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if (config.type == 'select') {
                        conditionData[item.name] = item.selectValue;
                    } else {
                        conditionData[item.name] = (item.contentValue || []).map(item => item.id);
                        if(item.name == 'yy_type'){
                            conditionData.yy_type_dimension = item.selectValue;
                        }
                    }
                });

                let groups = this.formItem.group;


                // 如果开启了【维度默认排序】，要将【未设置排序的维度】设置成：第一个指标的降序 2023.6.30
                if(this.formItem.dimension_default_sort=='1'){
                    // 已经有几个维度有排序
                    let sortDimensionsNum = this.formItem.group.filter(item=>{
                        let dimensionValue = item.dimensionValue||{};
                        return !!dimensionValue.order_by;
                    }).length;
                    // 还有几个需要排序
                    let diffVal = 10-sortDimensionsNum;
                    let groupsNum = groups.length;  // 当前筛选条件中维度的个数
                    let targetLen = groupsNum>10?10:groupsNum;
                    let firstField = this.formItem.field[0];
                    for(let i=0;i<targetLen;i++){
                        /* 苹果渠道：展示次数份额，排名，搜索热度 不支持自动排序 2024.9.24 */
                        if(this.platId=='9'&&['impression_share','impression_rank','search_popularity'].includes(firstField.name)){
                            break;
                        }


                        let fieldItem = this._findFieldByName(this.dimensionList, groups[i].name);

                        if(!fieldItem.dimensionValue){
                            this.$set(fieldItem, 'dimensionValue', {
                                sum_type: fieldItem.name == 'date' ? 'day' : '',
                                start_date_dimension: fieldItem.name == 'start_date' ? (this.isPlatAll?'subproject_name': this.platId=='12'?'account_name': 'app_name') : '',     // 开投日期默认维度：按产品
                                create_date_dimension: fieldItem.name == 'create_date' ? (this.platId=='9'?'plan_create_date':'account_create_time') : '',
                                yy_type_dimension: fieldItem.name == 'yy_type' ? 'account_yy_type' : '',       // 运营类型默认维度：按账户
                                order_by: fieldItem.name == 'date'?'date':fieldItem.name == 'time_interval'?'time_interval':firstField.name,
                                order_type: 'desc',
                                show_type: '1',
                                show_num: null,
                            });
                            this.$set(fieldItem, 'subText', this.getDimensionSubText(fieldItem));
                            diffVal = diffVal-1;
                        }else if(!fieldItem.dimensionValue.order_by&&diffVal>0){
                            let dimensionValue = fieldItem.dimensionValue||{};
                            this.$set(dimensionValue,'order_by',firstField.name);
                            this.$set(dimensionValue,'order_type','desc');
                            this.$set(fieldItem, 'subText', this.getDimensionSubText(fieldItem));
                            diffVal = diffVal-1;
                        }
                    }
                }

                let groupData = groups.map(item => {
                    let value = item.dimensionValue || {};
                    return {
                        group_by: item.name,
                        order_by: (item.name==='date'&&!value.order_by)?'date':(item.name=='time_interval'&&!value.order_by)?'time_interval':value.order_by,
                        order_type: value.order_type,
                        show_type: value.show_type,
                        show_num: value.show_num,
                        sum_type: value.sum_type,
                        start_date_dimension:value.start_date_dimension,
                        create_date_dimension:value.create_date_dimension,
                        yy_type_dimension:value.yy_type_dimension,
                    };
                });

                let fields = [].concat(this.shownFields,this.hiddenFields);

                let reqData = {
                    condition: JSON.stringify(conditionData),
                    exclude_condition_fields: this.excludeConditionFields.join(','),
                    group: JSON.stringify(groupData),
                    field: JSON.stringify(fields.map(item => item.name)),
                    quick_date:this.formItem.quick_date,
                    range_time: this.formItem.range_time.join('/'),
                    display_sum_dimension: this.formItem.group.length>0?this.formItem.display_sum_dimension:'',       //各维度汇总行:1-显示，无值-不显示
                    data_display_type: this.formItem.data_display_type,       //数据显示方式，average-日均，sum_up-汇总
                    cost_type: this.formItem.cost_type||(this.platId=='9'?'local_spend':(this.platId=='11'?'ad_billing':'cost')),       //数据计算方式，cost / cash_cost / vir_cost
                    time_zone:(this.platId=='9'||this.isPlatAll)?this.formItem.time_zone:'',
                };
                if (this.isCompare) {
                    reqData.compare_type = this.formItem.compare_type;    //YoY 同比，MoM 环比，self自定义
                    reqData.range_time1 = this.formItem.range_time1.join('/');
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }
                reqData.order_by = this.tableSettings.sortOrder?this.tableSettings.sortBy:'';
                reqData.order_type = this.tableSettings.sortOrder=='descending'?'desc':this.tableSettings.sortOrder=='ascending'?'asc':'';

                let calcMap = {
                    greater:'>',
                    greater_than:'>=',
                    equal:'=',
                    less:'<',
                    less_than:'<=',
                    between:'>=<=',
                    eq0:'=0',
                    neq0:'!=0',
                };
                reqData.where = this.tableFilterList.map(item=>{
                    console.log(item);
                    let isAppleSOVDate = this.platId=='9'&&['impression_share','impression_rank','search_popularity','compare_impression_share','compare_impression_rank','compare_search_popularity'].includes(item.field);
                    let isGroup = item.colType==='content';
                    let isJudge0 = item.filterValue.calcType=='eq0'||item.filterValue.calcType=='neq0';

                    return {
                        field:item.field,
                        type:isGroup&&!isAppleSOVDate?'group':'data',
                        calc:isGroup?'':calcMap[item.filterValue.calcType],
                        val:isGroup?item.filterValue.map(inner=>inner.id):(isJudge0?'':item.filterValue.num1),
                        val1:isJudge0?'':item.filterValue.num2,
                    }
                });

                reqData.pn = this.queryData.pn;
                reqData.rn = this.queryData.rn;
                return reqData;
            },
            getDataList(type) {
                this.dataLoading = true;
                this.dataList = [];
                this.dataListCopy = [];
                this.sumTotalData = {};
                this.avgTotalData = {};
                if(!this.tableSettings.sortOrder&&!type){
                    this.columns = [];
                }

                let submitData = {};

                if(type){
                    if(type=='sort'){
                        submitData = this.lastSubmitRequestData;

                        let order = this.tableSettings.sortOrder;
                        submitData.order_by = order?this.tableSettings.sortBy:'';
                        submitData.order_type = order=='descending'?'desc':order=='ascending'?'asc':'';
                    }else if(type=='filter'){
                        submitData = this.lastSubmitRequestData;

                        this.queryData.pn = 1;
                    }else if(type=='changePage'){
                        submitData = this.lastSubmitRequestData;
                    }
                    submitData.pn = this.queryData.pn;
                    submitData.rn = this.queryData.rn;

                    let calcMap = {
                        greater:'>',
                        greater_than:'>=',
                        equal:'=',
                        less:'<',
                        less_than:'<=',
                        between:'>=<=',
                        eq0:'=0',
                        neq0:'!=0',
                    };
                    submitData.where = this.tableFilterList.map(item=>{
                        let isAppleSOVDate = this.platId=='9'&&['impression_share','impression_rank','search_popularity','compare_impression_share','compare_impression_rank','compare_search_popularity'].includes(item.field);
                        let isGroup = item.colType==='content';
                        let isJudge0 = item.filterValue.calcType=='eq0'||item.filterValue.calcType=='neq0';
                        return {
                            field:item.field,
                            type:isGroup&&!isAppleSOVDate?'group':'data',
                            calc:isGroup?'':calcMap[item.filterValue.calcType],
                            val:isGroup?item.filterValue.map(inner=>inner.id):(isJudge0?'':item.filterValue.num1),
                            val1:isJudge0?'':item.filterValue.num2,
                        }
                    });
                }else{
                    submitData = this.getSubmitData();
                    this.lastSubmitRequestData = utils.deepClone(submitData);
                }


                if(type!='sort'&&type!='filter'&&type!='changePage'){
                    if(this.lastSubmitRequestData.display_sum_dimension!='1' ){
                        this.tableSettings.showTotalRow = true;
                    }
                    this.tableSettings.showDailyTotalRow = true;
                }


                /* 如果本次查询没有维度分组、则总-汇总、总-日均取消勾选 */
                let lastGroupData = JSON.parse(this.lastSubmitRequestData.group)||[];
                if(lastGroupData.length<=0){
                    this.tableSettings.showDailyTotalRow = false;
                    this.tableSettings.showTotalRow = false;
                }


                this.curTableDimensions = this.formItem.group.map(item => item.name).filter(item => item !== 'date');


                let apiType = 'getPlatAnalysisList';
                if(this.platId == '1'){
                    apiType = 'getOPPOAnalysisList';
                }else if(this.platId == '3'){
                    apiType = 'getVivoAnalysisList';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiAnalysisList';
                }else if(this.platId == '7'){
                    apiType = 'getMiAnalysisList';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiAnalysisList';
                }else if(this.platId == '9'){
                    apiType = 'getAppleAnalysisList';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSAnalysisList';
                }else if(this.platId == '11'){
                    apiType = 'getHonorAnalysisList';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4AnalysisList';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalAnalysisList';
                }
                console.log('submitData',submitData);

                if(!type){
                    /* type不存在：表示默认查询，缓存下本次查询条件 */
                    let restoreData = Object.assign({},this.formItem,{
                        isCompare:this.isCompare,
                        exclude_condition_fields:this.excludeConditionFields.join(','),
                    });
                    window.localStorage.setItem(this.platName+'RestoreData',JSON.stringify(restoreData));
                }

                API[apiType](submitData,{
                    timeout:120*1000,
                }).then(res => {
                    let resData = res.data || {};
                    this.$refs['game-loading'].clearMap()

                    let baseIndex = submitData.rn * (submitData.pn-1);
                    setTimeout(()=> {
                        this.dataLoading = false;
                        this.dataList = (resData.list || []).map((item,index)=>{
                            item.index = baseIndex+index+1;
                            return item;
                        });
                        // 存储数据-取消排序时使用
                        this.dataListCopy = utils.deepClone(this.dataList);
                        this.$refs.pageWrap.calcBottomHeight()
                    })

                    let total = resData.total || {};
                    total.dataType = 'total';
                    let avg = resData.avg || {};
                    avg.dataType = 'total';
                    this.sumTotalData = Object.assign({},{
                        index:'总-汇总',
                    },total);
                    this.avgTotalData = Object.assign({},{
                        index:'总-日均',
                    },avg);
                    this.lastFileName = resData.file_name||'';

                    // 动态生成表格头部
                    this.dataColumns = (resData.field_list || []).length>0?[{
                        field:"index",
                        field_name:"序号",
                        format:null,
                        sortable:null,
                    }].concat(resData.field_list):[];

                    if(!this.tableSettings.sortOrder&&!type){
                        this.makeColumns();
                    }

                    this.$refs.pageWrap.hideAllFilters();
                    this.totalCnt = resData.totalCnt||resData.total_cnt||0;
                }, (err) => {
                    console.log('getAnalysisList error',err.stack);
                    if(err.data&&err.data.length>0){
                        let htmlStr = '<div class="tal" style="max-height: 300px;overflow: auto;">';
                        err.data.forEach(item=>{
                            htmlStr += `<p class="text-bold tal">${item.err_title}</p>`;
                            if(item.err_msg&&item.err_msg.length>0){
                                item.err_msg.forEach(err=>{
                                    htmlStr += `<p class="tal">${err}</p>`;
                                })
                            }
                        });
                        htmlStr +='</div>';
                        this.$confirm(htmlStr, err.info||'以下已选条件无权限，已自动剔除', {
                            showCancelButton: false,
                            confirmButtonText: '我知道了',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        });
                    }else if(err.code!=500){
                        this.$message.error(err.info || '请求失败');
                    }

                    this.dataList = [];
                    this.dataLoading = false;
                });

            },
            showAddTemplateModal() {
                if (this.formItem.field.length <= 0) {
                    return this.$message.error('请至少选择一个数据指标');
                }
                this.$refs.addTemplateModal.showModal();
            },
            showTemplateDrawer() {
                this.$refs.templateListDrawer.showDrawer();
            },
            hideTemplateDrawer() {
                this.$refs.templateListDrawer.hideDrawer();
            },
            useTemplate(template,isSubmit) {
                console.log('useTemplate',template);
                API.getTemplateInfo({
                    id: template.id,
                    plat_id:this.platId||'0',
                }).then(res => {
                    let resData = res.data || {};
                    let templateInfo = resData.info || {};
                    let fieldConfig = templateInfo.field_config || [];
                    let conditionConfig = templateInfo.condition_config || [];
                    let dimensionConfig = templateInfo.dimension_config || [];

                    let isHourTemplate = conditionConfig.map(item=>item.name).includes('time_interval')||dimensionConfig.map(item=>item.name).includes('time_interval');

                    if(isHourTemplate){
                        let start = dayjs(this.formItem.range_time[0]);
                        let end = dayjs(this.formItem.range_time[1]);
                        let diff = end.diff(start,'day');

                        let isCompareOver31day = false;
                        if(this.isCompare){
                            let start1 = dayjs(this.formItem.range_time1[0]);
                            let end1 = dayjs(this.formItem.range_time1[1]);
                            let diff1 = end1.diff(start1,'day');
                            isCompareOver31day = diff1>this.hourSearchDays;
                        }

                        if(diff>this.hourSearchDays||isCompareOver31day){
                            this.hideTemplateDrawer();
                            return this.$message.error('分时段数据仅支持查询最多'+this.hourSearchDays+'天，请修改数据日期后重试！')
                        }
                    }

                    // 应用模板时判断对比累计字段
                    let sumFieldList = this.fieldList.find(item=>item.name==this.platName+'_sum_data')||{};
                    let sumFieldNameList = (sumFieldList.children||[]).map(item=>item.name);
                    let checkedSumFields = fieldConfig.filter(item=>{
                        return sumFieldNameList.includes(item.name);
                    });
                    let checkedSumDimensions = dimensionConfig.filter(item=>{
                        let orderBy = item.order_by||'';
                        if(orderBy){
                            let fieldItem = this._findFieldByName(this.fieldList,orderBy);
                            if(fieldItem){
                                return sumFieldNameList.includes(fieldItem.name);
                            }
                            return false;
                        }
                        return false;
                    });

                    if(this.isCompare&&(checkedSumFields.length>0||checkedSumDimensions.length>0)){
                        let htmlStr = '<div><p>累计数据指标暂不支持对比与对比时维度排序，是否继续？</p><p class="text-color-error text-bold">继续将删除不支持的数据指标（若应用了维度排序,则同时删除）！</p><div class="font12px mt8" style="max-height: 150px;overflow-y: auto;">';
                        if(checkedSumFields.length>0){
                            htmlStr += '<p class="mt10"><span class="text-bold">指标：</span>'+checkedSumFields.map(item=>item.display_name).join('、')+'<p>';
                        }
                        if(checkedSumDimensions.length>0){
                            let tipArr = checkedSumDimensions.map(item=>{
                                let dimensionValue = item.dimensionValue||{};
                                let orderBy = dimensionValue.order_by||'';
                                let orderField = this._findFieldByName(this.fieldList,orderBy);
                                if(orderBy&&orderField){
                                    return item.display_name+'(排序：'+orderField.display_name+')';
                                }else{
                                    return item.display_name;
                                }
                            });
                            htmlStr += '<p class="mt10"><span class="text-bold">维度：</span>'+tipArr.join('、')+'<p>';
                        }

                        htmlStr += '</div></div>';

                        this.$confirm(htmlStr,'提示',{
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            customClass:'wide-confirm-box-550',
                        }).then(()=>{
                            this.setTemplateValues(res,checkedSumFields);
                            this.$nextTick(()=>{
                                checkedSumFields.forEach(sumField=>{
                                    this.removeField(sumField);
                                });
                                checkedSumDimensions.forEach(sumField=>{
                                    this.removeDimensionOrderField(sumField);
                                });
                            })
                        }).catch(()=>{
                            console.log('this.$confirm');
                            this.this.hideTemplateDrawer();
                        })
                    }else{
                        this.setTemplateValues(res,[],isSubmit);
                    }

                }, err => {
                    console.log('getTemplateInfo err', err);
                    this.$message.error(err.info || '请求失败');
                });
            },
            doCopyTab(data){
                console.log('doCopyTab',data);
                this.clearFilter('condition',true);
                this.clearFilter('dimension',true);
                this.clearFilter('field',true);

                this.isCompare = data.isCompare;
                this.formItem.compare_type = data.compare_type;
                this.formItem.quick_date = data.quick_date;
                this.formItem.range_type = data.range_type;
                this.formItem.range_time = data.range_time;
                this.formItem.range_time1 = data.range_time1;
                this.formItem.cost_type = data.cost_type;
                this.formItem.data_display_type = data.data_display_type;
                this.formItem.display_sum_dimension = data.display_sum_dimension;
                this.formItem.dimension_default_sort = data.dimension_default_sort;
                if(data.time_zone){
                    this.formItem.time_zone = data.time_zone;
                }

                let fieldConfig = data.field || [];
                let conditionConfig = data.condition || [];
                let dimensionConfig = data.group || [];

                fieldConfig.forEach(item => {
                    let fieldItem = this._findFieldByName(this.fieldList, item.name);
                    if(fieldItem){
                        this.$set(fieldItem, 'checked', true);
                        this.formItem.field.push(fieldItem);
                    }
                });

                let excludeConditions = (data.exclude_condition_fields||"").split(',');

                conditionConfig.forEach(item => {
                    let fieldItem = this._findFieldByName(this.conditionList, item.name);
                    if(fieldItem){
                        this.$set(fieldItem, 'checked', true);
                        this.$set(fieldItem, 'contentValue', item.contentValue);
                        this.$set(fieldItem, 'dateValue', item.dateValue);
                        this.$set(fieldItem, 'selectValue', item.selectValue);
                        this.$set(fieldItem, 'selectLabel', item.selectLabel);
                        this.$set(fieldItem, 'timeValue', item.timeValue);
                        this.$set(fieldItem, 'isExclude', excludeConditions.includes(item.name));
                        this.formItem.condition.push(fieldItem);
                    }
                });

                dimensionConfig.forEach(item => {
                    let fieldItem = this._findFieldByName(this.dimensionList, item.name);
                    this.$set(fieldItem, 'checked', true);
                    let dataVal = item.dimensionValue||{};

                    this.$set(fieldItem, 'dimensionValue', {
                        order_by: dataVal.order_by,
                        order_type: dataVal.order_type,
                        show_num: dataVal.show_num,
                        show_type: dataVal.show_type,
                        start_date_dimension: dataVal.start_date_dimension,
                        create_date_dimension: dataVal.create_date_dimension,
                        yy_type_dimension: dataVal.yy_type_dimension,
                        sum_type: dataVal.sum_type,
                    });
                    this.$set(fieldItem, 'subText', item.subText);
                    this.formItem.group.push(fieldItem);
                });

                this.updateDisableDate();
            },
            setTemplateValues(res,sumFields,isSubmit){
                let resData = res.data || {};
                let templateInfo = resData.info || {};
                let errInfo = resData.error || {};
                let fieldConfig = templateInfo.field_config || [];
                let conditionConfig = templateInfo.condition_config || [];
                let dimensionConfig = templateInfo.dimension_config || [];

                this.clearFilter('condition',true);
                this.clearFilter('dimension',true);
                this.clearFilter('field',true);

                let otherConfig = templateInfo.other_config || {};
                this.formItem.cost_type = otherConfig.cost_type;
                this.formItem.data_display_type = otherConfig.data_display_type;
                this.formItem.display_sum_dimension = otherConfig.display_sum_dimension;
                this.formItem.dimension_default_sort = otherConfig.dimension_default_sort;
                this.formItem.time_zone = (this.platId=='9'||this.isPlatAll)?otherConfig.time_zone||'UTC':'';

                let sumFieldNames = (sumFields||[]).map(item=>item.name);
                fieldConfig.forEach(item => {
                    let fieldItem = this._findFieldByName(this.fieldList, item.name);

                    if(sumFieldNames.length>0){
                        if(!sumFieldNames.includes(item.name)){
                            this.$set(fieldItem, 'checked', true);
                            this.formItem.field.push(fieldItem);
                        }
                    }else{
                        this.$set(fieldItem, 'checked', true);
                        this.formItem.field.push(fieldItem);
                    }
                });

                conditionConfig.forEach(item => {
                    let fieldItem = this._findFieldByName(this.conditionList, item.name);
                    let itemValue = item.value||{};
                    this.$set(fieldItem, 'checked', true);
                    this.$set(fieldItem, 'contentValue', itemValue.contentValue);
                    this.$set(fieldItem, 'dateValue', itemValue.dateValue);
                    this.$set(fieldItem, 'selectValue', itemValue.selectValue);
                    this.$set(fieldItem, 'selectLabel', itemValue.selectLabel);
                    this.$set(fieldItem, 'timeValue', itemValue.timeValue);
                    this.$set(fieldItem, 'isExclude', item.isExclude==='true');
                    this.formItem.condition.push(fieldItem);
                });

                dimensionConfig.forEach(item => {
                    let fieldItem = this._findFieldByName(this.dimensionList, item.name);
                    this.$set(fieldItem, 'checked', true);
                    let defaultOrderBy = item.name=='date'?item.order_by||'date':item.order_by;
                    this.$set(fieldItem, 'dimensionValue', {
                        order_by: defaultOrderBy,
                        order_type: item.order_type,
                        show_num: item.show_num,
                        show_type: item.show_type,
                        start_date_dimension: item.start_date_dimension,
                        create_date_dimension: item.create_date_dimension,
                        yy_type_dimension: item.yy_type_dimension,
                        sum_type: item.sum_type,
                    });
                    this.$set(fieldItem, 'subText', item.sub_text);
                    this.formItem.group.push(fieldItem);

                    if(this.isCompare&&item.sum_type){
                        if(this.formItem.compare_type=='YoY'){
                            if(item.sum_type=='month'||item.sum_type=='quarter'){
                                this.setYoYDate();
                            }else{
                                this.formItem.compare_type = 'MoM';
                                this.setMoMDate();
                            }
                        }else if(this.formItem.compare_type=='MoM'){
                            this.setMoMDate();
                        }else if(this.formItem.compare_type == 'YoY'){
                            this.formItem.compare_type = 'MoM';
                            this.changeCompareType('MoM');
                        }
                        this.isDisabledYoY = true;
                    }
                    if(item.name=='date'){
                        this.isDisabledYoY = !(item.sum_type==='month'||item.sum_type==='quarter');
                        // 模板中有数据日期，且当前为自定义对比，那么需要重置对比结束日期
                        if(this.isCompare&&this.formItem.compare_type=='self'){
                            this.setSelfDate();
                        }
                    }
                });
                /*模板维度中无数据日期，需要重置对比日期为环比*/
                if(this.isCompare&&!dimensionConfig.map(item=>item.name).includes('date')){
                    if(this.formItem.compare_type=='self'){
                        // 不作任何处理

                    }else if(this.formItem.compare_type == 'MoM'){
                        this.setMoMDate();
                    }else if(this.formItem.compare_type == 'YoY'){
                        this.formItem.compare_type = 'MoM';
                        this.changeCompareType('MoM');
                    }
                    this.isDisabledYoY = true;
                }

                this.updateDisableDate();
                this.$refs.pageWrap.showAllFilters();

                let errCondition = errInfo.condition_config || [];
                let errDimension = errInfo.dimension_config || [];
                let errField = errInfo.field_config || [];
                if (errCondition.length > 0 || errDimension.length > 0 || errField.length > 0) {
                    let conditionHtml = errCondition.length > 0 ? '<p class="pb6"><span class="text-bold">筛选条件：</span>' + errCondition.join('，') + '</p>' : '';
                    let dimensionHtml = errDimension.length > 0 ? '<p class="pb6"><span class="text-bold">维度分组：</span>' + errDimension.join('，') + '</p>' : '';
                    let fieldHtml = errField.length > 0 ? '<p class="pb6"><span class="text-bold">数据指标：</span>' + errField.join('，') + '</p>' : '';
                    let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${conditionHtml}${dimensionHtml}${fieldHtml}</div>`;

                    this.$confirm(htmlStr, '以下已选条件无权限，已自动剔除', {
                        showCancelButton: false,
                        confirmButtonText: '我知道了',
                        type: 'error',
                        center: true,
                        dangerouslyUseHTMLString: true,
                        showClose: false,
                        distinguishCancelAndClose: true,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                    }).then(() => {
                        this.hideTemplateDrawer();
                    });
                }else{
                    this.hideTemplateDrawer();
                }

                if(isSubmit){
                    this.$nextTick(()=>{
                        this.submitSearch();
                    });
                }
            },
            getDataDisplayTypeText(val){
                if(val=='average') return '日均';
                if(val=='sum_up') return '汇总';
                return '--';
            },
            getCostTypeText(val){
                if(val=='cost') return '总消耗';
                if(val=='local_spend') return '总消耗(支出)';
                if(val=='cash_cost') return '现金消耗';
                if(val=='vir_cost') return '虚拟金消耗';
                if(val=='gift_cost') return '赠送金消耗';
                if(val=='star_cost') return '耀星券消耗';
                if(val=='exchange_cost') return '置换金消耗';
                return '--';
            },
            tableSortChange( {prop, order}){
                console.log('tableSortChange',prop, order);
                this.tableSettings.sortBy = prop;
                this.tableSettings.sortOrder = order;

                this.getDataList('sort');
            },
            tableRowClassName({row}) {
                return row.dataType == 'total' ? 'total-data-row' : row.aggregate_type==='合计'?'sum-data-row':'';
            },
            tableUpdate(field, data) {
                console.log('tableUpdate',field,data);
                let colType = field.colType;
                let filterItem = this.tableFilterList.find(item => item.field == field.field);
                console.log('tableUpdate',field,data,filterItem);

                if ((colType === 'content' && data.length <= 0) || (colType==='number'&&data.num1===undefined && data.num2===undefined&&data.calcType!='eq0'&&data.calcType!='neq0')) {
                    if (filterItem) {
                        let index = this.tableFilterList.findIndex(item => item.field === field.field);
                        this.tableFilterList.splice(index, 1);
                    }else if(data.calcType=='eq0'||data.calcType=='neq0'){
                        this.tableFilterList.push({
                            field: field.field,
                            colType: colType,
                            filterValue: data,
                            name: field.name,
                        });
                    }
                } else {
                    if (filterItem) {
                        this.$set(filterItem, 'filterValue', data);
                    } else {
                        this.tableFilterList.push({
                            field: field.field,
                            colType: colType,
                            filterValue: data,
                            name: field.name,
                        });
                    }
                }
                this.getDataList('filter');
            },
            hideOtherPopover(col){
                let otherList = this.columns.filter(item=>item.field!=col);
                otherList.forEach(colData=>{
                    let $customHeader = this.$refs['customHeader-'+colData.field];
                    if($customHeader.length>0){
                        $customHeader.forEach(inner=>{
                            inner.hidePopover();
                        })
                    }
                })
            },
            showFilterPop(field){
                let $headerRefs = this.$refs['customHeader-'+field];
                if($headerRefs){
                    console.log('showFilterPop',field,$headerRefs);
                    $headerRefs[0].triggerPopover();
                }
            },
            exportToExcel(name){
                console.log('exportToExcel',name);
                let submitData = {};
                submitData = this.lastSubmitRequestData;
                submitData.order_by = this.tableSettings.sortBy;
                let order = this.tableSettings.sortOrder;
                submitData.order_type = order=='descending'?'desc':order=='ascending'?'asc':'';
                let calcMap = {
                    greater:'>',
                    greater_than:'>=',
                    equal:'=',
                    less:'<',
                    less_than:'<=',
                    between:'>=<=',
                    eq0:'=0',
                    neq0:'!=0',
                };
                submitData.where = this.tableFilterList.map(item=>{
                    let isAppleSOVDate = this.platId=='9'&&['impression_share','impression_rank','search_popularity','compare_impression_share','compare_impression_rank','compare_search_popularity'].includes(item.field);
                    let isGroup = item.colType==='content';
                    let isJudge0 = item.filterValue.calcType=='eq0'||item.filterValue.calcType=='neq0';
                    return {
                        field:item.field,
                        type:isGroup&&!isAppleSOVDate?'group':'data',
                        calc:isGroup?'':calcMap[item.filterValue.calcType],
                        val:isGroup?item.filterValue.map(inner=>inner.id):(isJudge0?'':item.filterValue.num1),
                        val1:isJudge0?'':item.filterValue.num2,
                    }
                });
                // submitData.export = '1';
                // submitData.export_filename = (this.lastFileName||'未命名');

                let apiType = 'getPlatAnalysisList';
                if(this.platId == '1'){
                    apiType = 'getOPPOAnalysisList';
                }else if(this.platId == '3'){
                    apiType = 'getVivoAnalysisList';
                }else if(this.platId == '4'){
                    apiType = 'getHuaweiAnalysisList';
                }else if(this.platId == '7'){
                    apiType = 'getMiAnalysisList';
                }else if(this.platId == '8'){
                    apiType = 'getIQiYiAnalysisList';
                }else if(this.platId == '9'){
                    apiType = 'getAppleAnalysisList';
                }else if(this.platId == '10'){
                    apiType = 'getHuaweiADSAnalysisList';
                }else if(this.platId == '11'){
                    apiType = 'getHonorAnalysisList';
                }else if(this.platId == '37'){
                    apiType = 'getMiv4AnalysisList';
                }else if(this.platId == '12'){
                    apiType = 'getMiGlobalAnalysisList';
                }
                API[apiType](Object.assign({},{
                    export:'1',
                    export_filename:name||this.lastFileName||'未命名',
                },submitData),{
                    timeout:120*1000,
                }).then(res=>{
                    let resData = res.data || {};
                    let resInfo = res.info||'';
                    console.log('exportToExcel',resData);
                    this.$message.success(resInfo||'请求成功');

                    this.$refs.downloadTableModal.submitLoading = false;
                    this.$refs.downloadTableModal.hideModal();
                },err=>{
                    console.log('exportToExcel err',err);
                    this.$message.error(err.info||'请求有误');
                })
            },
            clearTableData(){
                this.dataList = [];
                this.avgTotalData = {};
                this.sumTotalData = {};
                this.tableSettings.showDailyTotalRow = false;
                this.tableSettings.showTotalRow = false;
                this.columns = [];
                this.totalCnt = 0;
                this.queryData.pn = 1;
                this.lastSubmitRequestData = {};
            },
            calcTableHeight(isShowCondition,bottomHeight){
                this.$nextTick(()=> {
                    const refH = document.querySelector('.el-table__header-wrapper')?.clientHeight || 31;
                    console.log(refH, '111');
                    console.dir(document.querySelector('.el-table__header-wrapper'))
                    
                    this.tableMaxHeight = bottomHeight - 41 - refH -45;
                })
            },
            calcFilterDisplayCounts(){
                let oldCount = this.filterDisplayCounts;

                /*修正条件筛选区tab页激活项样式不正确*/
                let oldActive = this.activeFilterTab;
                this.activeFilterTab = 'first';
                this.$nextTick(()=>{
                    this.activeFilterTab = oldActive;
                    if(this.resizeTimer){
                        clearTimeout(this.resizeTimer);
                        this.resizeTimer = null;
                    }
                    this.resizeTimer = setTimeout(()=>{
                        let $rightTop = document.querySelector('.right-top-content');
                        if($rightTop){
                            let $rightTopWidth = $rightTop.clientWidth;
                            /* 60 - 60 - 50:左侧label,右侧+icon,更多按钮 */
                            /* 170:每一个item的宽度 */
                            this.filterDisplayCounts = parseInt(($rightTopWidth - 60 - 60 - 60)/170);
                            let newCount = this.filterDisplayCounts;

                            let diff = Math.abs(oldCount - newCount);
                            if(oldCount>newCount){
                                /* 需要把显示的->隐藏的 */

                                let actionConditions = this.shownConditions.slice(newCount,oldCount);
                                this.hiddenConditions = [].concat(actionConditions,this.hiddenConditions);
                                this.shownConditions.splice(newCount,diff);

                                let actionDimensions = this.shownDimensions.slice(newCount,oldCount);
                                this.hiddenDimensions = [].concat(actionDimensions,this.hiddenDimensions);
                                this.shownDimensions.splice(newCount,diff);

                                let actionFields = this.shownFields.slice(newCount,oldCount);
                                this.hiddenFields = [].concat(actionFields,this.hiddenFields);
                                this.shownFields.splice(newCount,diff);

                            }else if(oldCount<newCount){
                                /* 需要把隐藏的->显示的 */

                                let actionConditions = this.hiddenConditions.slice(0,diff);
                                this.shownConditions = this.shownConditions.concat(actionConditions);
                                this.hiddenConditions.splice(0,diff);

                                let actionDimensions = this.hiddenDimensions.slice(0,diff);
                                this.shownDimensions = this.shownDimensions.concat(actionDimensions);
                                this.hiddenDimensions.splice(0,diff);

                                let actionFields = this.hiddenFields.slice(0,diff);
                                this.shownFields = this.shownFields.concat(actionFields);
                                this.hiddenFields.splice(0,diff);
                            }
                        }
                    },300)
                })
            },
            showTdPop(event,field,row){
                if(!this.submitDimensionNameList.includes(field.field)||!row[field.field]||row[field.field]==='-'||row[field.field].includes('总-')||row[field.field].includes('计数：')){
                    return this.hideTdPop();
                }

                let type = '';
                if(['account_create_time','start_date','create_date'].includes(field.field)){
                    type = 'add';
                }else if(this.excludeConditionFields.includes(field.field)){
                    type = 'add';
                }else if(!this.tempChangedConditions.includes(field.field)){
                    type = 'add';
                }
                // !this.tempChangedConditions.includes(field.field)||['account_create_time','start_date','create_date'].includes(field.field)?'add':'';

                if(this.showTdPopTimer){
                    clearTimeout(this.showTdPopTimer);
                    this.showTdPopTimer = null;
                }

                if(this.hideTdPopTimer){
                    clearTimeout(this.hideTdPopTimer);
                    this.hideTdPopTimer = null;
                }

                this.showTdPopTimer = setTimeout(()=>{
                    this.actionColTd = {
                        row:row,
                        col:field,
                        event:event,
                        type:type,
                    }
                },200);
            },
            hideTdPop(){
                if(this.showTdPopTimer){
                    clearTimeout(this.showTdPopTimer);
                    this.showTdPopTimer = null;
                }
                // if(!this.hideTdPopTimer) return;
                this.hideTdPopTimer = setTimeout(()=>{
                    this.actionColTd = {
                        row:null,
                        col:null,
                        event:null,
                        type:'',
                    }
                },100);
            },
            hideTdPopNow(){
                this.actionColTd = {
                    row:null,
                    col:null,
                    event:null,
                    type:'',
                };
                clearTimeout(this.hideTdPopTimer);
                this.hideTdPopTimer = null;
                if(this.showTdPopTimer){
                    clearTimeout(this.showTdPopTimer);
                    this.showTdPopTimer = null;
                }
            },
            clearHideTDPopTimer(){
                if(this.hideTdPopTimer){
                    clearTimeout(this.hideTdPopTimer);
                    this.hideTdPopTimer = null;
                }
            },
            copyFilterContent(col,row){
                let value = row[col.field];
                utils.setClipboardText(value);
                this.$message.success('复制成功',value);
            },
            addFilter(col,row){
                return new Promise((resolve,reject)=>{
                    console.log('addFilter',col,row);
                    let value = row[col.field];

                    if(col.field=='date'){
                        let dateReg = /^\d{4}\/\d{2}\/\d{2}$/;
                        let rangeTimeArr = [];
                        if(dateReg.test(value)){
                            // 数据日期维度为天
                            let date = dayjs(value).format('YYYY-MM-DD');
                            rangeTimeArr = [date,date];
                        }else{
                            value = value.replace(/\r|\n/g,' ');

                            let rangeArr = value.match(/\d{4}\/\d{2}\/\d{2}/g);
                            if(rangeArr.length==2){
                                let start = dayjs(rangeArr[0]).format('YYYY-MM-DD');
                                let end = dayjs(rangeArr[1]).format('YYYY-MM-DD');
                                rangeTimeArr = [start,end];
                            }else{
                                this.$message.error('添加数据日期失败');
                                reject();
                                return;
                            }
                        }

                        this.addFilterDate(rangeTimeArr).then((res)=>{
                            if(res.length>0){
                                this.formItem.range_time = rangeTimeArr;
                                if(this.isCompare){
                                    console.log('isCompare',this.formItem.compare_type);
                                    this.changeCompareType(this.formItem.compare_type);
                                }
                                resolve();
                            }else{
                                this.$message.error('添加数据日期失败');
                                reject();
                                return;
                            }

                        },()=>{
                            this.$message.error('添加数据日期失败');
                            reject();
                            return;
                        });




                    }else{
                        let formCondition = this.formItem.condition||[];
                        let actionCondition = formCondition.find(item=>item.name==col.field);
                        if(!actionCondition){
                            let conditionItem = this._findFieldByName(this.conditionList, col.field);
                            this.$set(conditionItem,'isExclude',false);
                            this.formItem.condition.push(conditionItem);
                            actionCondition = formCondition.find(item=>item.name==col.field);
                        }
                        // 如果正在loading中,禁止添加
                        if(actionCondition.filterLoading) {
                            reject();
                            return false;
                        }

                        this.$set(actionCondition,'isExclude',false);
                        // 判断当前维度是否是第一次添加筛选
                        let isFirstAdd = !this.tempChangedConditions.includes(col.field)||['account_create_time','start_date','create_date'].includes(col.field);
                        if(isFirstAdd){
                            console.log('addFilter-添加筛选',col.field);
                            /*添加筛选*/
                            this.tempChangedConditions.push(col.field);
                        }else{
                            /*追加筛选*/
                            console.log('addFilter-追加筛选',col.field,actionCondition);
                            if(this.excludeConditionFields.includes(col.field)){
                                console.log('是排除字段',this.excludeConditionFields,col.field);
                                actionCondition.contentValue = [];
                            }else{
                                let fieldConfig = actionCondition.config||{};
                                if(fieldConfig.type=='content'){
                                    let contentValue = actionCondition.contentValue||[];
                                    if(contentValue.map(item=>item.name).includes(value)){
                                        this.$message.error(col.name+'中已存在'+value);
                                        reject();
                                        return;
                                    }
                                }
                            }
                        }

                        this.$set(actionCondition,'filterLoading',true);

                        this.$set(actionCondition, 'checked', true);
                        
                        let apiType = 'getPlatConditions';
                        if(this.platId == '1'){
                            apiType = 'getOPPOConditions';
                        }else if(this.platId == '3'){
                            apiType = 'getVivoConditions';
                        }else if(this.platId == '4'){
                            apiType = 'getHuaweiConditions';
                        }else if(this.platId == '7'){
                            apiType = 'getMiConditions';
                        }else if(this.platId == '8'){
                            apiType = 'getIQiYiConditions';
                        }else if(this.platId == '9'){
                            apiType = 'getAppleConditions';
                        }else if(this.platId == '10'){
                            apiType = 'getHuaweiADSConditions';
                        }else if(this.platId == '11'){
                            apiType = 'getHonorConditions';
                        }else if(this.platId == '37'){
                            apiType = 'getMiv4Conditions';
                        }else if(this.platId == '12'){
                            apiType = 'getMiGlobalConditions';
                        }
                        let conditionData = {};
                        let excludeConditionFields = [];
                        formCondition.forEach(item=>{
                            if(item.name!=col.field||!isFirstAdd){
                                let config = item.config||{};
                                let type = config.type;
                                if(type=='content'){
                                    conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                                    if(item.isExclude){
                                        excludeConditionFields.push(item.name);
                                    }
                                    if(item.name=='yy_type'){
                                        conditionData.yy_type_dimension =  item.selectValue||'';
                                    }
                                }else if(type=='time'){
                                    conditionData[item.name] = (item.timeValue||[]).join('/');
                                } else{
                                    conditionData[item.name] = (item.dateValue||[]).join('/');
                                    if(item.name=='start_date'){
                                        conditionData.start_date_dimension =  item.selectValue||'';
                                    }else if(item.name=='create_date'){
                                        conditionData.create_date_dimension =  item.selectValue||'';
                                    }
                                }

                            }
                        });
                        let searchText = value;
                        let returnCondition = col.field;
                        let submitDimension = JSON.parse(this.lastSubmitRequestData.group)||[];
                        if(col.field=='start_date'){
                            let startDimension = submitDimension.find(item=>item.group_by=='start_date');
                            if(startDimension){
                                returnCondition = returnCondition+'|'+(startDimension.start_date_dimension||'');
                            }
                        }else if(col.field=='create_date'){
                            let createDimension = submitDimension.find(item=>item.group_by=='create_date');
                            if(createDimension){
                                returnCondition = returnCondition+'|'+(createDimension.create_date_dimension||'');
                            }
                        }else if(col.field=='yy_type'){
                            let yyTypeDimension = submitDimension.find(item=>item.group_by=='yy_type');
                            if(yyTypeDimension){
                                returnCondition = returnCondition+'|'+(yyTypeDimension.yy_type_dimension||'');
                            }
                        }

                        // let conConditions = conditionData.filter(item=>{
                        //     let fieldConfig = item.config||{};
                        //     return fieldConfig.type==='content';
                        // });
                        // let excludeConditionFields = conConditions.filter(item=>item.isExclude).map(item=>item.name);

                        let reqData = {
                            search: searchText,
                            return_condition: returnCondition,
                            condition:conditionData,
                            exclude_condition_fields:excludeConditionFields.join(','),
                            range_time: this.formItem.range_time.join('/'),
                            last:'',
                        };
                        if(this.platId=='9'||this.isPlatAll){
                            reqData.time_zone = this.formItem.time_zone;
                        }
                        if(this.platId=='9'||this.platId=='4'||this.isPlatAll){
                            /* 后端分表查询需要用到group数据，仅Apple渠道和华为渠道*/
                            reqData.group = this.formItem.group.map(item => {
                                let value = item.dimensionValue || {};
                                let groupVal = {
                                    group_by: item.name,
                                };
                                if(value.start_date_dimension){
                                    groupVal.start_date_dimension = value.start_date_dimension;
                                }
                                if(value.create_date_dimension){
                                    groupVal.create_date_dimension = value.create_date_dimension;
                                }
                                if(value.yy_type_dimension){
                                    groupVal.yy_type_dimension = value.yy_type_dimension;
                                }
                                return groupVal;
                            });
                        }
                        if(this.isTimeFilter){
                            reqData.time_interval = this.platTimeInterval;
                        }
                        API[apiType](reqData).then(res=>{
                            console.log('getConditions', res);
                            this.$set(actionCondition,'filterLoading',false);

                            if(col.field=='account_create_time'||col.field=='start_date'||col.field=='create_date'){
                                //开户日期 或 开投日期
                                let resList = (res.data||{}).list||{};
                                let hasCostDate = (resList.has_cost_date||[]).map(item=>dayjs(item+'').format('YYYY-MM-DD'));
                                let valueDate = (value||'').replace(/\//g,'');
                                let date = dayjs(valueDate).format('YYYY-MM-DD');
                                if(hasCostDate.includes(date)){
                                    this.$set(actionCondition, 'dateValue', [date,date]);
                                }else{
                                    if(isFirstAdd){
                                        this.removeCondition(actionCondition);
                                    }
                                    this.$message.error('添加筛选失败，该条件在当前筛选场景下无任何数据');
                                    reject();
                                    return;
                                }
                                if(col.field=='start_date'){
                                    //开投日期
                                    let startDimension = submitDimension.find(item=>item.group_by=='start_date');
                                    if(startDimension){
                                        this.$set(actionCondition, 'selectValue', startDimension.start_date_dimension);

                                        let dimensionMap = {
                                            'bloc_name': '按集团',
                                            'company_name': '按客户',
                                            'account_name': this.platId=='9'?'按广告系列组':'按账户',
                                            'app_name': '按产品',
                                            'main_app_name': '按产品主名称',
                                            'project_name': '按项目名称',
                                            'subproject_name': '按推广',
                                            'plan_name': this.platId=='8'||this.platId=='9'?'按广告系列':'按计划',
                                            'adgroup_name': this.platId=='8'?'按广告': this.platId=='10'? '按任务': this.platId=='11'?'按分组':'按广告组',
                                            'ad_name': this.platId=='1'||this.platId=='8'||this.platId=='7'||this.platId=='12'||this.platId=='37'||this.platId=='10'||this.platId=='11'?'按创意':'按广告',
                                            'idea_name':'按创意',
                                            'task_name':'按任务',
                                            'sub_task_name':'按子任务',
                                            'keyword':'按关键词',
                                            'search_term':'按搜索词',
                                        };
                                        this.$set(actionCondition, 'selectLabel', dimensionMap[startDimension.start_date_dimension]||'--');
                                    }
                                }else if(col.field=='create_date'){
                                    //创建日期
                                    let createDimension = submitDimension.find(item=>item.group_by=='create_date');
                                    if(createDimension){
                                        this.$set(actionCondition, 'selectValue', createDimension.create_date_dimension);

                                        let dimensionMap = {
                                            'account_create_time': this.platId=='9'?'按广告系列组':'按账户',
                                            'plan_create_date': '按计划',
                                            'adgroup_create_date': this.platId=='10'? '按任务' : this.platId=='11'?'按分组':'按广告组',
                                            'ad_create_date': this.platId=='1'||this.platId=='8'||this.platId=='7'||this.platId=='12'||this.platId=='37'||this.platId=='10'||this.platId=='11'?'按创意':'按广告',
                                            'idea_create_date':'按创意',
                                            'task_create_date':'按任务',
                                            'sub_task_create_date':'按子任务',
                                            'keyword_create_date':'按关键词',
                                        };
                                        this.$set(actionCondition, 'selectLabel', dimensionMap[createDimension.create_date_dimension]||'--');
                                    }
                                }
                            }else{
                                if(col.field=='yy_type'){
                                    //运营类型
                                    let yyTypeDimension = submitDimension.find(item=>item.group_by=='yy_type');
                                    if(yyTypeDimension){
                                        this.$set(actionCondition, 'selectValue', yyTypeDimension.yy_type_dimension);

                                        let dimensionMap = {
                                            'bloc_yy_type': '按集团',
                                            'company_yy_type': '按客户',
                                            'account_yy_type': this.platId=='9'?'按广告系列组':'按账户',
                                            'app_yy_type': '按产品',
                                            'main_app_yy_type': '按产品主名称',
                                            'project_yy_type': '按项目',
                                            'subproject_yy_type': '按推广',
                                            'plan_yy_type': '按计划',
                                            'adgroup_yy_type': this.platId=='10'?'按任务':this.platId=='11'?'按分组':'按广告组',
                                            'ad_yy_type': this.platId=='1'||this.platId=='8'||this.platId=='7'||this.platId=='12'||this.platId=='37'||this.platId=='10'||this.platId=='11'?'按创意':'按广告',
                                            'idea_yy_type': '按创意',
                                            'task_yy_type':'按任务',
                                            'sub_task_yy_type':'按子任务',
                                            'keyword_yy_type':'按关键词',
                                            'search_term_yy_type':'按搜索词',
                                        };
                                        this.$set(actionCondition, 'selectLabel', dimensionMap[yyTypeDimension.yy_type_dimension]||'--');
                                    }
                                }

                                let resList =( (res.data||{}).list||[]).map(item=>{
                                    item.id = item.id===null?'':item.id;
                                    return item;
                                });
                                if(resList.length>0){
                                    if(this.autoLoadFields.includes(col.field)){
                                        let checkedResList = resList.filter(inner=>inner.name===value);
                                        if(checkedResList.length>0){
                                            checkedResList.forEach((checkedItem,index)=>{
                                                if(isFirstAdd&&index==0){
                                                    this.$set(actionCondition, 'contentValue', [{
                                                        checked:true,
                                                        id:checkedItem.id,
                                                        name:checkedItem.name,
                                                        isHide:false,
                                                    }]);
                                                }else {
                                                    actionCondition.contentValue.push({
                                                        checked:true,
                                                        id:checkedItem.id,
                                                        name:checkedItem.name,
                                                        isHide:false,
                                                    })
                                                }
                                            });
                                        }else{
                                            if(isFirstAdd){
                                                this.removeCondition(actionCondition);
                                            }
                                            this.$message.error('添加筛选失败，该条件在当前筛选场景下无任何数据');
                                            reject();
                                            return false;
                                        }

                                    }else{
                                        if(col.field=='xs_email'||col.field=='kf_email'||col.field=='yy_id'||col.field=='traffic_scenarios'||this.multipleSearchDimensionNames.includes(col.field)){
                                            let valueItem = value.split('，')||[];
                                            let resultArr = [];
                                            let errList = [];
                                            valueItem.forEach(user=>{
                                                let checkedItem = resList.find(inner=>inner.name===user);
                                                if(checkedItem){
                                                    resultArr.push({
                                                        checked:true,
                                                        id:checkedItem.id,
                                                        name:checkedItem.name,
                                                        isHide:false,
                                                    })
                                                }else{
                                                    errList.push(user);
                                                }
                                            });

                                            if(resultArr.length>0){
                                                if(isFirstAdd){
                                                    this.$set(actionCondition, 'contentValue', resultArr);
                                                }else{
                                                    let contentValue = actionCondition.contentValue||[];
                                                    resultArr.forEach(item=>{
                                                        let actionI = contentValue.find(inner=>inner.name==item.name);
                                                        if(!actionI){
                                                            contentValue.push({
                                                                checked:true,
                                                                id:item.id,
                                                                name:item.name,
                                                                isHide:false,
                                                            })
                                                        }
                                                    })
                                                }
                                                if(errList.length>0){
                                                    console.log('部分人员添加筛选失败',errList);
                                                    // 有部分失败，仅提示
                                                    this.$message.error('部分人员添加筛选失败：'+errList.join());
                                                    reject();
                                                    return;
                                                }
                                            }else{
                                                if(isFirstAdd){
                                                    this.removeCondition(actionCondition);
                                                }
                                                this.$message.error('添加筛选失败，该条件在当前筛选场景下无任何数据');
                                                reject();
                                                return;
                                            }
                                        }else{
                                            let checkedItem = resList.find(inner=>inner.name===value);
                                          
                                            if(checkedItem){
                                                if(isFirstAdd){
                                                    this.$set(actionCondition, 'contentValue', [{
                                                        checked:true,
                                                        id:checkedItem.id,
                                                        name:checkedItem.name,
                                                        isHide:false,
                                                    }]);
                                                }else{
                                                    actionCondition.contentValue.push({
                                                        checked:true,
                                                        id:checkedItem.id,
                                                        name:checkedItem.name,
                                                        isHide:false,
                                                    })
                                                }
                                            }else{
                                                this.$message.error('添加筛选失败，该条件在当前筛选场景下无任何数据');
                                                if(isFirstAdd){
                                                    this.removeCondition(actionCondition);
                                                }
                                                reject();
                                                return;
                                            }
                                        }
                                    }
                                }else{
                                    if(isFirstAdd){
                                        this.removeCondition(actionCondition);
                                    }
                                    this.$message.error('添加筛选失败，该条件在当前筛选场景下无任何数据');
                                    reject();
                                    return;
                                }
                            }
                            this.updateDisableDate();
                            resolve(returnCondition);
                        },err=>{
                            console.log('getConditions error', err);
                            this.$message.error(err.info||'添加筛选失败，该条件在当前筛选场景下无任何数据');
                            if(isFirstAdd){
                                this.removeCondition(actionCondition);
                            }
                            this.$set(actionCondition,'filterLoading',false);
                            reject();
                            return;
                        })
                    }
                });
                /*  catch后会影响then里逻辑
                * .catch((e)=>{
                    console.log('addFilter error',e);
                })*/
            },
            firstGroup(col,returnCondition){
                let [returnField,returnDimension] = (returnCondition||'|').split('|');

                let groupField = col.field;
                let index = this.formItem.group.findIndex(item=>item.name==groupField);
                if(index>=0){
                    for(let i=0;i<index;i++){
                        this.removeDimension(this.formItem.group[0])
                    }
                    // 当前维度里存在，需要修改维度里的维度
                    let actionGroup = this._findFieldByName(this.dimensionList,groupField);
                    actionGroup.dimensionValue = {
                        sum_type: actionGroup.name == 'date' ? 'day' : '',
                        start_date_dimension: actionGroup.name == 'start_date' ? (returnDimension||(this.isPlatAll?'subproject_name': this.platId=='12'?'account_name': 'app_name')) : '',      // 开投日期默认维度：按产品
                        create_date_dimension: actionGroup.name == 'create_date' ? (returnDimension||(this.platId=='9'?'plan_create_date':'account_create_time')) : '',
                        yy_type_dimension: actionGroup.name == 'yy_type' ? (returnDimension||'account_yy_type') : '',      // 运营类型默认维度：按账户
                        order_by: actionGroup.name=='time_interval'?'time_interval':actionGroup.name=='date'?'date':'',
                        order_type: 'desc',
                        show_type: '1',
                        show_num: null,
                    };
                    this.$set(actionGroup, 'subText', this.getDimensionSubText(actionGroup));
                    if(actionGroup.name == 'date'&&this.isCompare){
                        if(this.formItem.compare_type!='self'){
                            this.setMoMDate();
                        }
                    }
                }else{
                    // 当前维度里不存在，需要新增
                    let actionGroup = this._findFieldByName(this.dimensionList,groupField);
                    // this.changeCheckItem(actionGroup, true, 'group');

                    let field = Object.assign({},actionGroup);

                    field.dimensionValue = {
                        sum_type: field.name == 'date' ? 'day' : '',
                        start_date_dimension: field.name == 'start_date' ? (returnDimension||(this.isPlatAll?'subproject_name': this.platId=='12'?'account_name': 'app_name')) : '',      // 开投日期默认维度：按产品
                        create_date_dimension: field.name == 'create_date' ? (returnDimension||(this.platId=='9'?'plan_create_date':'account_create_time')) : '',
                        yy_type_dimension: field.name == 'yy_type' ? (returnDimension||'account_yy_type') : '',      // 运营类型默认维度：按账户
                        order_by: field.name=='time_interval'?'time_interval':field.name=='date'?'date':'',
                        order_type: 'desc',
                        show_type: '1',
                        show_num: null,
                    };
                    this.$set(field, 'subText', this.getDimensionSubText(field));
                    this.formItem.group.unshift(field);
                    if(field.name == 'date'&&this.isCompare){
                        if(this.formItem.compare_type!='self'){
                            this.setMoMDate();
                        }
                    }
                    this.$set(actionGroup, 'checked', true);
                }
            },
            addFilterAndFirstGroup(col,row){
                console.log('addFilterAndFirstGroup',col,row);
                this.addFilter(col,row).then((returnCondition)=>{
                    console.log('addFilter Success...',returnCondition);

                    this.firstGroup(col,returnCondition);
                },()=>{
                    console.log('addFilter Err...');
                });
            },
            handleSizeChange(val) {
                console.log('handleSizeChange',val);
                this.queryData.rn= val;
                if(Object.keys(this.lastSubmitRequestData).length<=0) return;
                this.getDataList('changePage');
            },
            handleCurrentChange(val) {
                console.log('handleCurrentChange',val);
                this.queryData.pn= val;
                if(Object.keys(this.lastSubmitRequestData).length<=0) return;
                this.getDataList('changePage');
            },

            removeAppleForm(groupList,conditionList){
                console.log('removeAppleForm',groupList,conditionList);
                groupList.forEach(item=>{
                    let actionItem = this.formItem.group.find(inner=>inner.name==item);
                    if(actionItem){
                        this.removeDimension(actionItem);
                    }
                });
                conditionList.forEach(item=>{
                    let actionItem = this.formItem.condition.find(inner=>inner.name==item);
                    if(actionItem){
                        this.removeCondition(actionItem);
                    }
                });
            },


            /*---组件内部工具方法---*/
            _findFieldById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _setListValue(data, key, value) {
                for (let item in data) {
                    this.$set(data[item], key, value);
                    let child = data[item].children;
                    if (child && child.length > 0) {
                        this._setListValue(child, key, value);
                    }
                }
            },
            getIsSumField(field){
                let actionField = this._findFieldByName(this.fieldList,field.name);
                if(actionField){
                    let pid = actionField.pid;
                    let aField = this._findFieldById(this.fieldList,pid);
                    if(aField){
                        return aField.name == this.platName+'_sum_data';
                    }
                    return false;
                }
                return false;
            },
        },
        beforeDestroy() {
            $('.sidebar-container,.fixed-header,.tab-bar,.left-wrap,.right-top,.table-tool-bar').off('mouseenter.tdPop');
        }

    }
</script>

<style lang="scss" scoped>
.data-table .el-table__header-wrapper .cell {
    padding:  0 0;
}
    .game-loading-box {
        position: absolute;
        inset: 0;
        z-index: 2001;
        .game-loading-img {
            display: block;
            margin: 0 auto;
        }
    }

    .title-group {
        font-size: 12px;
        line-height: 24px;
        padding: 0 6px;

    }

    .date-tips {
        right: 10px;
        top: 0;
        line-height: 24px;
        min-width: 200px;
        text-align: right;
    }

    .chosen-area, .search-result {
        background-color: #fff;
        top: 42px;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        height: calc(100% - 42px);
        /*overflow-y: auto;*/
        overflow-y: hidden;
    }

    .search-result {
        z-index: 2;
        padding: 0 0 0 12px;
        overflow-y: auto;
        right: 0;

        .title-text {
            height: 32px;
            line-height: 32px;
            font-weight: bold;
            font-size: 12px;
        }
    }

    ::v-deep .chosen-area .el-scrollbar__wrap,
    ::v-deep .search-result .el-scrollbar__wrap{
        overflow-x: hidden;
    }


    .filter-tabs {
        /*padding: 0 6px 0;*/
        height: 100%;
    }

    .filter-tab-pane {
        /*overflow-y: auto;*/
        height: 100%;
    }

    ::v-deep .filter-tabs .el-collapse {
        padding-bottom: 30px;
        border-bottom: none;
    }

    ::v-deep .filter-tabs .el-tab-pane{
        height: 100%;
    }

    ::v-deep .filter-tabs .el-tabs__header {
        margin-bottom: 0;
        position: relative;
        &:after{
            content: '';
            display: block;
            position: absolute;
            height: 5px;
            background-color: #fff;
            left: 0;
            bottom: -4px;
            right: 0;
            z-index: 1;
        }
    }

    ::v-deep .show-search-result .el-tabs__header:after{
        content: '';
        display: none!important;
    }

    ::v-deep .filter-tabs .el-tabs__item {
        font-size: 12px;
        padding: 0 20px !important;
        height: 32px;
        line-height: 32px;
        font-weight: bold;
    }

    ::v-deep .filter-tabs .el-collapse-item__header {
        height: 32px;
        line-height: 32px;
        font-weight: bold;
        font-size: 12px;
    }

    ::v-deep .filter-tabs .el-collapse-item .el-collapse-item__content {
        padding-bottom: 10px;
    }

    ::v-deep .filter-tabs .el-collapse-item:last-child .el-collapse-item__wrap {
        border-bottom: none;
    }
    ::v-deep .filter-tabs .el-tabs__content{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 31px;
        /*overflow-y: auto;*/
        padding-left: 6px;
    }


    .conditions-group {
        border: solid 1px #ccc;
        margin-bottom: 10px;
        min-height: 60px;
    }

    .ver-middle {
        line-height: 28px;
        vertical-align: middle;
        margin: 0 6px;
    }

    .ver-middle.active {
        color: #409EFF;
    }

    .display-type-select {
        width: 78px;
    }

    ::v-deep .display-type-select .el-input__inner {
        height: 22px;
        line-height: 22px;
    }

    ::v-deep .display-type-select .el-select__caret {
        line-height: 22px;
    }


    .filter-checked-wrap {
        /*padding-right: 80px;*/
        height: 38px;
        overflow-y: hidden;
    }

    .more-btn {
        /*position: absolute;*/
        /*right: 20px;*/
        /*bottom: 5px;*/
        float: left;
        margin-top: 5px;
    }

    .hidden-list {
        width: 210px;
        max-height: 300px;
        overflow-y: scroll;
    }

    ::v-deep .data-table-wrap thead .cell{
        white-space: nowrap;
        text-overflow: unset;
        padding: 0;
    }

    .table-tool-bar {
        background-color: #fafafa;
        border-bottom: solid 1px #dcdee2;
    }

    ::v-deep .total-data-row td {
        background-color: #dcdee2 !important;
        font-weight: bold;
    }
    ::v-deep .sum-data-row td {
        background-color: #dcdee2 !important;
        font-weight: bold;
    }

    .cell-block-bg{
        /*background-color: #a0cfff;*/
        background-color: #c2e0ff;
        width: 0;
        height: 100%;
        position: absolute;
        z-index: -1;
    }


    .data-table-wrap{
        /*padding-bottom: 15px;*/
        min-height: 200px;
        overflow-x: hidden;
        overflow-y: auto;
        background-color: #f8f8f9;
    }
    ::v-deep.data-table-wrap .el-table__header th.el-table__cell{
        padding: 2px 0;
        background-color: #f8f8f9;
    }
    ::v-deep.data-table-wrap td.el-table__cell{
        padding: 2px 0;
        border-bottom: 1px solid #f2f5fc!important;
    }
    ::v-deep.data-table-wrap .el-table--border .el-table__body td.el-table__cell{
        border-right: 1px solid transparent!important;
    }
    ::v-deep.data-table-wrap .el-table--border th.el-table__cell{
        border-right: 1px solid #d7dce7!important;
    }
    ::v-deep.data-table-wrap td.el-table__cell .el-tooltip .relative{
        overflow: hidden;
        text-overflow: ellipsis;
    }

    ::v-deep.data-table-wrap .el-table__header th.el-table__cell .caret-wrapper {
        height: 28px;
    }
    ::v-deep.data-table-wrap .el-table__header .sort-caret.ascending {
        top:3px;
    }
    ::v-deep.data-table-wrap .el-table__header .sort-caret.descending {
        bottom:3px;
    }
    ::v-deep.data-table .el-table--border .el-table__body .el-table__cell{
        border-right: 1px solid transparent;
    }

    ::v-deep.data-table-wrap .el-table--border .el-table__cell.gutter{
        border: none!important;
    }
    ::v-deep.data-table-wrap .el-table--border .el-table__header-wrapper{
        background-color: #f8f8f9;
    }

    ::v-deep.data-table-wrap .el-table--border.el-table::before{
        z-index: 0!important;
    }

    ::v-deep.data-table-wrap .el-loading-mask{
        background-color: #f8f8f9!important;
    }

    .date-loading,.date-loading2{
        position: absolute;
        left: 185px;
        top: 6px;
        width: 26px;
        height: 26px;
        z-index: 3;
        transform: scale(0.4);
    }
    .date-loading2{
        left: 543px;
    }

    .pointer-icon{
        font-size: 18px;
        vertical-align: -3px;
    }
    .pointer-icon:hover{
        color: #409EFF;
    }

    /* 顶部 已选条件区样式 */
    .header-title{
        border-bottom: solid 1px #dcdee2;
        min-height: 32px;
        padding: 4px 0;
    }
    .filter-group-item{
        border-bottom: solid 1px #dcdee2;
        min-height: 32px;
        padding: 5px 0;
        line-height: 24px;
    }
    .filter-group-label{
        width: 60px;
    }
    .filter-main{
        left: 60px;
        right: 50px;
        top: 0;
    }
    .filter-action{
        width: 50px;
        text-align: right;
        right: 5px;
        top: 2px;
        line-height: 36px;
    }
    .display-setting{
        min-height: 32px;
        line-height: 32px;
    }
    ::v-deep .data-table .el-table__body-wrapper{
        background-color: #f8f8f9;
    }
    .no-fixed-table-height{
        max-height: none!important;
        ::v-deep .jt-table-body{
            max-height: none!important;
        }
    }

    ::v-deep .drag-ghost{
        border-color: #999!important;
        border-style: dashed!important;
        background-color: #ccc!important;
        position: relative;
    }
    ::v-deep .drag-ghost .main-info{
        /*color: red!important;*/
        font-weight: bold;
    }

    .mini-button{
        padding: 4px 6px;
    }

    ::v-deep.cost-type-radio-btn .el-radio-button__inner{
        min-width: 90px;
    }

    ::v-deep.header-title .el-date-editor.is-disabled{
        pointer-events: none;
    }

    .table-bottom-bar{
        background-color: #fff;
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        text-align: center;
        z-index: 1;
    }
</style>
<style>
    .form-range-time.el-date-range-picker .el-date-table  td div{
        height: 34px;
    }
</style>
